// src/data/quiz-library/quizLibrary.js
//
// THE SHARED QUIZ LIBRARY — 209 quizzes, 1006 questions, keyed by topic slug.
//
// WHY GAMES ONLY WORKED IN VIRGINIA
// ---------------------------------
// There are 245 *QuizContent.js files in src/data. 227 of them are a copy of
// the same nineteen-topic FIRST GRADE SCIENCE set — motion, instruments,
// soundVibration, matter, plantParts — no matter what the filename says. The
// file called ca5thSocialStudiesQuizContent.js contains first grade science.
// So does nc3rdSocialStudies, and dc4thMath, and forty-odd others.
//
// Only VA and MD held real content, and those two are byte-identical. The
// game loader's last-resort fallback is keyed `state_grade_subject`, so a
// California student landed in the California file, found first grade science,
// and got either the wrong questions or none at all. Virginia worked because
// Virginia is where the questions actually were.
//
// A quiz is not state-specific. "Ancient Egypt" is the same five questions in
// Sacramento and Richmond. So they live here once, keyed by the slug the topic
// already carries, and any state whose topic uses that slug gets the game.
//
// This file is the offline fallback. The real source of truth is Firestore
// `quizzes/{slug}`, which UniversalQuizGame already checks first — run
// scripts/seed-quiz-library.mjs to push these there.

const quizLibrary = {
  "10timestable": {
    "slug": "10timestable",
    "title": "10 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "10 × 2 = ?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "10", "correct": false },
          { "text": "30", "correct": false }
        ]
      },
      {
        "question": "10 × 4 = ?",
        "answers": [
          { "text": "40", "correct": true },
          { "text": "30", "correct": false },
          { "text": "50", "correct": false }
        ]
      },
      {
        "question": "10 × 6 = ?",
        "answers": [
          { "text": "60", "correct": true },
          { "text": "50", "correct": false },
          { "text": "70", "correct": false }
        ]
      },
      {
        "question": "10 × 8 = ?",
        "answers": [
          { "text": "80", "correct": true },
          { "text": "70", "correct": false },
          { "text": "90", "correct": false }
        ]
      },
      {
        "question": "10 × 12 = ?",
        "answers": [
          { "text": "120", "correct": true },
          { "text": "100", "correct": false },
          { "text": "110", "correct": false }
        ]
      }
    ]
  },
  "11timestable": {
    "slug": "11timestable",
    "title": "11 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "11 × 2 = ?",
        "answers": [
          { "text": "22", "correct": true },
          { "text": "21", "correct": false },
          { "text": "24", "correct": false }
        ]
      },
      {
        "question": "11 × 4 = ?",
        "answers": [
          { "text": "44", "correct": true },
          { "text": "42", "correct": false },
          { "text": "48", "correct": false }
        ]
      },
      {
        "question": "11 × 6 = ?",
        "answers": [
          { "text": "66", "correct": true },
          { "text": "64", "correct": false },
          { "text": "60", "correct": false }
        ]
      },
      {
        "question": "11 × 8 = ?",
        "answers": [
          { "text": "88", "correct": true },
          { "text": "80", "correct": false },
          { "text": "99", "correct": false }
        ]
      },
      {
        "question": "11 × 12 = ?",
        "answers": [
          { "text": "132", "correct": true },
          { "text": "121", "correct": false },
          { "text": "142", "correct": false }
        ]
      }
    ]
  },
  "12timestable": {
    "slug": "12timestable",
    "title": "12 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "12 × 2 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "22", "correct": false },
          { "text": "26", "correct": false }
        ]
      },
      {
        "question": "12 × 4 = ?",
        "answers": [
          { "text": "48", "correct": true },
          { "text": "42", "correct": false },
          { "text": "52", "correct": false }
        ]
      },
      {
        "question": "12 × 6 = ?",
        "answers": [
          { "text": "72", "correct": true },
          { "text": "68", "correct": false },
          { "text": "78", "correct": false }
        ]
      },
      {
        "question": "12 × 8 = ?",
        "answers": [
          { "text": "96", "correct": true },
          { "text": "92", "correct": false },
          { "text": "100", "correct": false }
        ]
      },
      {
        "question": "12 × 12 = ?",
        "answers": [
          { "text": "144", "correct": true },
          { "text": "132", "correct": false },
          { "text": "156", "correct": false }
        ]
      }
    ]
  },
  "2timestable": {
    "slug": "2timestable",
    "title": "2 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "2 × 3 = ?",
        "answers": [
          { "text": "6", "correct": true },
          { "text": "5", "correct": false },
          { "text": "8", "correct": false }
        ]
      },
      {
        "question": "2 × 5 = ?",
        "answers": [
          { "text": "10", "correct": true },
          { "text": "8", "correct": false },
          { "text": "12", "correct": false }
        ]
      },
      {
        "question": "2 × 7 = ?",
        "answers": [
          { "text": "14", "correct": true },
          { "text": "12", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "2 × 9 = ?",
        "answers": [
          { "text": "18", "correct": true },
          { "text": "20", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "2 × 12 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "22", "correct": false },
          { "text": "26", "correct": false }
        ]
      }
    ]
  },
  "3statesofmatter": {
    "slug": "3statesofmatter",
    "title": "3 States of Matter",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match state to description.",
        "options": [
          { "id": "solidA", "text": "Solid", "image": "", "targetText": "Keeps shape", "targetImage": "" },
          { "id": "liquidA", "text": "Liquid", "image": "", "targetText": "Flows to fit", "targetImage": "" },
          { "id": "gasA", "text": "Gas", "image": "", "targetText": "Spreads to fill", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match example to state.",
        "options": [
          { "id": "rock", "text": "Rock", "image": "", "targetText": "Solid", "targetImage": "" },
          { "id": "juice", "text": "Juice", "image": "", "targetText": "Liquid", "targetImage": "" },
          { "id": "air", "text": "Air", "image": "", "targetText": "Gas", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match particle picture words to state.",
        "options": [
          { "id": "packed", "text": "Packed tight", "image": "", "targetText": "Solid", "targetImage": "" },
          { "id": "slides", "text": "Slides past", "image": "", "targetText": "Liquid", "targetImage": "" },
          { "id": "farapart", "text": "Far apart", "image": "", "targetText": "Gas", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match change words to heating/cooling.",
        "options": [
          { "id": "melt", "text": "Melting", "image": "", "targetText": "Solid → Liquid", "targetImage": "" },
          { "id": "freeze", "text": "Freezing", "image": "", "targetText": "Liquid → Solid", "targetImage": "" },
          { "id": "evap", "text": "Evaporation", "image": "", "targetText": "Liquid → Gas", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each set that shows all three states.",
        "options": [
          { "id": "water-set", "text": "Ice / Water / Steam", "image": "", "targetText": "Solid / Liquid / Gas", "targetImage": "" },
          { "id": "soda-set", "text": "Ice / Soda / Bubbles", "image": "", "targetText": "Solid / Liquid / Gas", "targetImage": "" },
          { "id": "weather-set", "text": "Hail / Rain / Fog", "image": "", "targetText": "Solid / Liquid / Gas", "targetImage": "" }
        ]
      }
    ]
  },
  "3timestable": {
    "slug": "3timestable",
    "title": "3 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "3 × 2 = ?",
        "answers": [
          { "text": "6", "correct": true },
          { "text": "5", "correct": false },
          { "text": "9", "correct": false }
        ]
      },
      {
        "question": "3 × 4 = ?",
        "answers": [
          { "text": "12", "correct": true },
          { "text": "9", "correct": false },
          { "text": "15", "correct": false }
        ]
      },
      {
        "question": "3 × 6 = ?",
        "answers": [
          { "text": "18", "correct": true },
          { "text": "15", "correct": false },
          { "text": "12", "correct": false }
        ]
      },
      {
        "question": "3 × 8 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "27", "correct": false },
          { "text": "21", "correct": false }
        ]
      },
      {
        "question": "3 × 12 = ?",
        "answers": [
          { "text": "36", "correct": true },
          { "text": "30", "correct": false },
          { "text": "33", "correct": false }
        ]
      }
    ]
  },
  "4timestable": {
    "slug": "4timestable",
    "title": "4 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "4 × 3 = ?",
        "answers": [
          { "text": "12", "correct": true },
          { "text": "8", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "4 × 5 = ?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "24", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "4 × 7 = ?",
        "answers": [
          { "text": "28", "correct": true },
          { "text": "24", "correct": false },
          { "text": "30", "correct": false }
        ]
      },
      {
        "question": "4 × 9 = ?",
        "answers": [
          { "text": "36", "correct": true },
          { "text": "32", "correct": false },
          { "text": "40", "correct": false }
        ]
      },
      {
        "question": "4 × 12 = ?",
        "answers": [
          { "text": "48", "correct": true },
          { "text": "44", "correct": false },
          { "text": "42", "correct": false }
        ]
      }
    ]
  },
  "5timestable": {
    "slug": "5timestable",
    "title": "5 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "5 × 3 = ?",
        "answers": [
          { "text": "15", "correct": true },
          { "text": "10", "correct": false },
          { "text": "20", "correct": false }
        ]
      },
      {
        "question": "5 × 4 = ?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "15", "correct": false },
          { "text": "25", "correct": false }
        ]
      },
      {
        "question": "5 × 6 = ?",
        "answers": [
          { "text": "30", "correct": true },
          { "text": "25", "correct": false },
          { "text": "35", "correct": false }
        ]
      },
      {
        "question": "5 × 8 = ?",
        "answers": [
          { "text": "40", "correct": true },
          { "text": "35", "correct": false },
          { "text": "45", "correct": false }
        ]
      },
      {
        "question": "5 × 12 = ?",
        "answers": [
          { "text": "60", "correct": true },
          { "text": "55", "correct": false },
          { "text": "65", "correct": false }
        ]
      }
    ]
  },
  "6timestable": {
    "slug": "6timestable",
    "title": "6 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "6 × 3 = ?",
        "answers": [
          { "text": "18", "correct": true },
          { "text": "12", "correct": false },
          { "text": "24", "correct": false }
        ]
      },
      {
        "question": "6 × 4 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "18", "correct": false },
          { "text": "30", "correct": false }
        ]
      },
      {
        "question": "6 × 5 = ?",
        "answers": [
          { "text": "30", "correct": true },
          { "text": "24", "correct": false },
          { "text": "36", "correct": false }
        ]
      },
      {
        "question": "6 × 7 = ?",
        "answers": [
          { "text": "42", "correct": true },
          { "text": "48", "correct": false },
          { "text": "36", "correct": false }
        ]
      },
      {
        "question": "6 × 9 = ?",
        "answers": [
          { "text": "54", "correct": true },
          { "text": "60", "correct": false },
          { "text": "48", "correct": false }
        ]
      }
    ]
  },
  "7timestable": {
    "slug": "7timestable",
    "title": "7 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "7 × 2 = ?",
        "answers": [
          { "text": "14", "correct": true },
          { "text": "12", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "7 × 3 = ?",
        "answers": [
          { "text": "21", "correct": true },
          { "text": "24", "correct": false },
          { "text": "18", "correct": false }
        ]
      },
      {
        "question": "7 × 5 = ?",
        "answers": [
          { "text": "35", "correct": true },
          { "text": "28", "correct": false },
          { "text": "42", "correct": false }
        ]
      },
      {
        "question": "7 × 8 = ?",
        "answers": [
          { "text": "56", "correct": true },
          { "text": "63", "correct": false },
          { "text": "49", "correct": false }
        ]
      },
      {
        "question": "7 × 12 = ?",
        "answers": [
          { "text": "84", "correct": true },
          { "text": "77", "correct": false },
          { "text": "91", "correct": false }
        ]
      }
    ]
  },
  "8timestable": {
    "slug": "8timestable",
    "title": "8 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "8 × 2 = ?",
        "answers": [
          { "text": "16", "correct": true },
          { "text": "18", "correct": false },
          { "text": "14", "correct": false }
        ]
      },
      {
        "question": "8 × 3 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "28", "correct": false },
          { "text": "32", "correct": false }
        ]
      },
      {
        "question": "8 × 5 = ?",
        "answers": [
          { "text": "40", "correct": true },
          { "text": "48", "correct": false },
          { "text": "56", "correct": false }
        ]
      },
      {
        "question": "8 × 7 = ?",
        "answers": [
          { "text": "56", "correct": true },
          { "text": "64", "correct": false },
          { "text": "48", "correct": false }
        ]
      },
      {
        "question": "8 × 12 = ?",
        "answers": [
          { "text": "96", "correct": true },
          { "text": "88", "correct": false },
          { "text": "104", "correct": false }
        ]
      }
    ]
  },
  "9timestable": {
    "slug": "9timestable",
    "title": "9 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "9 × 2 = ?",
        "answers": [
          { "text": "18", "correct": true },
          { "text": "16", "correct": false },
          { "text": "20", "correct": false }
        ]
      },
      {
        "question": "9 × 4 = ?",
        "answers": [
          { "text": "36", "correct": true },
          { "text": "32", "correct": false },
          { "text": "27", "correct": false }
        ]
      },
      {
        "question": "9 × 5 = ?",
        "answers": [
          { "text": "45", "correct": true },
          { "text": "40", "correct": false },
          { "text": "54", "correct": false }
        ]
      },
      {
        "question": "9 × 7 = ?",
        "answers": [
          { "text": "63", "correct": true },
          { "text": "72", "correct": false },
          { "text": "54", "correct": false }
        ]
      },
      {
        "question": "9 × 12 = ?",
        "answers": [
          { "text": "108", "correct": true },
          { "text": "99", "correct": false },
          { "text": "112", "correct": false }
        ]
      }
    ]
  },
  "abrahamlincoln": {
    "slug": "abrahamlincoln",
    "title": "Abraham Lincoln",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What number President of the United States was Abraham Lincoln?",
        "questionImage": "",
        "answers": [
          { "text": "16th", "correct": true, "image": "" },
          { "text": "1st", "correct": false, "image": "" },
          { "text": "3rd", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. In which state was Abraham Lincoln born?",
        "questionImage": "",
        "answers": [
          { "text": "Kentucky", "correct": true, "image": "" },
          { "text": "Virginia", "correct": false, "image": "" },
          { "text": "New York", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is Abraham Lincoln best known for during the Civil War?",
        "questionImage": "",
        "answers": [
          { "text": "Freeing enslaved people", "correct": true, "image": "" },
          { "text": "Starting a new war", "correct": false, "image": "" },
          { "text": "Building railroads", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which war took place while Abraham Lincoln was President?",
        "questionImage": "",
        "answers": [
          { "text": "Civil War", "correct": true, "image": "" },
          { "text": "Revolutionary War", "correct": false, "image": "" },
          { "text": "World War I", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Before becoming President, what job did Abraham Lincoln have?",
        "questionImage": "",
        "answers": [
          { "text": "Lawyer", "correct": true, "image": "" },
          { "text": "Doctor", "correct": false, "image": "" },
          { "text": "Farmer", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "adaptation": {
    "slug": "adaptation",
    "title": "Adaptation",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is adaptation?",
        "questionImage": "",
        "answers": [
          { "text": "A way to survive", "correct": true, "image": "" },
          { "text": "A kind of food", "correct": false, "image": "" },
          { "text": "A machine part", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What helps animals blend in?",
        "questionImage": "",
        "answers": [
          { "text": "Camouflage", "correct": true, "image": "" },
          { "text": "Migration", "correct": false, "image": "" },
          { "text": "Recycling", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What helps animals look like something else?",
        "questionImage": "",
        "answers": [
          { "text": "Mimicry", "correct": true, "image": "" },
          { "text": "Hibernation", "correct": false, "image": "" },
          { "text": "Photosynthesis", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Moving to warmer places for winter is called…",
        "questionImage": "",
        "answers": [
          { "text": "Migration", "correct": true, "image": "" },
          { "text": "Camouflage", "correct": false, "image": "" },
          { "text": "Sprouting", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Sleeping through cold months is called…",
        "questionImage": "",
        "answers": [
          { "text": "Hibernation", "correct": true, "image": "" },
          { "text": "Pollination", "correct": false, "image": "" },
          { "text": "Germination", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "adaptivecharacteristics": {
    "slug": "adaptivecharacteristics",
    "title": "Adaptive Characteristics",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Why do otters have webbed feet?",
        "questionImage": "",
        "answers": [
          { "text": "To swim better", "correct": true, "image": "" },
          { "text": "To climb trees", "correct": false, "image": "" },
          { "text": "To fly", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Sharp claws are used for…",
        "questionImage": "",
        "answers": [
          { "text": "Catching prey", "correct": true, "image": "" },
          { "text": "Making nests", "correct": false, "image": "" },
          { "text": "Eating grass", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Large beaks help animals with…",
        "questionImage": "",
        "answers": [
          { "text": "Eating", "correct": true, "image": "" },
          { "text": "Sleeping", "correct": false, "image": "" },
          { "text": "Running", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Large teeth help animals with…",
        "questionImage": "",
        "answers": [
          { "text": "Biting food", "correct": true, "image": "" },
          { "text": "Flying", "correct": false, "image": "" },
          { "text": "Hiding", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Adaptive traits help animals…",
        "questionImage": "",
        "answers": [
          { "text": "Survive", "correct": true, "image": "" },
          { "text": "Sing", "correct": false, "image": "" },
          { "text": "Dance", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "addingfun": {
    "slug": "addingfun",
    "title": "Adding Fun",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What is 5 + 3?",
        "answers": [
          { "text": "8", "correct": true },
          { "text": "7", "correct": false },
          { "text": "6", "correct": false },
          { "text": "9", "correct": false }
        ]
      },
      {
        "question": "You have 2 apples and get 3 more. How many apples now?",
        "answers": [
          { "text": "5", "correct": true },
          { "text": "4", "correct": false },
          { "text": "6", "correct": false },
          { "text": "3", "correct": false }
        ]
      },
      {
        "question": "What is 6 + 4?",
        "answers": [
          { "text": "10", "correct": true },
          { "text": "9", "correct": false },
          { "text": "8", "correct": false },
          { "text": "11", "correct": false }
        ]
      }
    ]
  },
  "addingproperties": {
    "slug": "addingproperties",
    "title": "Adding Properties",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Which equation shows turning addends around doesn’t change the sum?",
        "answers": [
          { "text": "4 + 5 = 5 + 4", "correct": true },
          { "text": "4 + 5 = 4 + 6", "correct": false },
          { "text": "4 + 5 = 9 + 1", "correct": false },
          { "text": "4 + 5 = 3 + 5", "correct": false }
        ]
      },
      {
        "question": "What is 1 + 0?",
        "answers": [
          { "text": "1", "correct": true },
          { "text": "0", "correct": false },
          { "text": "2", "correct": false },
          { "text": "10", "correct": false }
        ]
      },
      {
        "question": "Fill in the blank: 2 + 3 = 3 + __",
        "answers": [
          { "text": "2", "correct": true },
          { "text": "1", "correct": false },
          { "text": "4", "correct": false },
          { "text": "5", "correct": false }
        ]
      }
    ]
  },
  "addsubtractfractions": {
    "slug": "addsubtractfractions",
    "title": "Add & Subtract Fractions",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. 1/4 + 2/4 = ?",
        "answers": [
          { "text": "3/4", "correct": true },
          { "text": "2/8", "correct": false },
          { "text": "1/2", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 3/8 + 4/8 = ?",
        "answers": [
          { "text": "7/8", "correct": true },
          { "text": "6/8", "correct": false },
          { "text": "5/8", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 5/6 - 2/6 = ?",
        "answers": [
          { "text": "3/6 or 1/2", "correct": true },
          { "text": "4/6", "correct": false },
          { "text": "1/6", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 2/3 + 1/3 = ?",
        "answers": [
          { "text": "3/3 or 1 whole", "correct": true },
          { "text": "2/6", "correct": false },
          { "text": "1/3", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 7/10 - 4/10 = ?",
        "answers": [
          { "text": "3/10", "correct": true },
          { "text": "5/10", "correct": false },
          { "text": "2/10", "correct": false }
        ]
      }
    ]
  },
  "addsubtractfractionscommon": {
    "slug": "addsubtractfractionscommon",
    "title": "Add & Subtract Fractions Common",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What stays the same when adding fractions with the same denominators?",
        "answers": [
          { "text": "The denominator", "correct": true },
          { "text": "The numerator", "correct": false },
          { "text": "The whole number", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is 2/6 + 3/6?",
        "answers": [
          { "text": "5/6", "correct": true },
          { "text": "6/12", "correct": false },
          { "text": "1/6", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is 5/8 - 2/8?",
        "answers": [
          { "text": "3/8", "correct": true },
          { "text": "7/8", "correct": false },
          { "text": "5/16", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When adding 1/4 + 2/4, what is the sum?",
        "answers": [
          { "text": "3/4", "correct": true },
          { "text": "1/2", "correct": false },
          { "text": "2/8", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. To subtract 7/10 - 3/10, what should you do?",
        "answers": [
          { "text": "Subtract the numerators and keep the denominator", "correct": true },
          { "text": "Subtract both numerators and denominators", "correct": false },
          { "text": "Change the denominator", "correct": false }
        ]
      }
    ]
  },
  "africa-features": {
    "slug": "africa-features",
    "title": "Africa Features",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is the longest river in the world that flows through Africa?",
        "questionImage": "",
        "answers": [
          { "text": "Nile River", "correct": true, "image": "" },
          { "text": "Congo River", "correct": false, "image": "" },
          { "text": "Amazon River", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Where are the Atlas Mountains located?",
        "questionImage": "",
        "answers": [
          { "text": "Northwest Africa", "correct": true, "image": "" },
          { "text": "East Africa", "correct": false, "image": "" },
          { "text": "Central Africa", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the largest desert on Earth?",
        "questionImage": "",
        "answers": [
          { "text": "Sahara Desert", "correct": true, "image": "" },
          { "text": "Kalahari Desert", "correct": false, "image": "" },
          { "text": "Gobi Desert", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the tallest mountain in Africa?",
        "questionImage": "",
        "answers": [
          { "text": "Mount Kilimanjaro", "correct": true, "image": "" },
          { "text": "Mount Kenya", "correct": false, "image": "" },
          { "text": "Mount Everest", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which river flows through the African rainforest?",
        "questionImage": "",
        "answers": [
          { "text": "Congo River", "correct": true, "image": "" },
          { "text": "Niger River", "correct": false, "image": "" },
          { "text": "Zambezi River", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "americagrew": {
  "slug": "americagrew",
  "title": "America Grew",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What did the Louisiana Purchase do?",
      "questionImage": "",
      "answers": [
        { "text": "Doubled size", "correct": true, "image": "" },
        { "text": "Halved size", "correct": false, "image": "" },
        { "text": "No change", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which land came by treaty from Spain?",
      "questionImage": "",
      "answers": [
        { "text": "Florida", "correct": true, "image": "" },
        { "text": "Oregon", "correct": false, "image": "" },
        { "text": "Alaska", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which became independent before joining?",
      "questionImage": "",
      "answers": [
        { "text": "Texas", "correct": true, "image": "" },
        { "text": "Utah", "correct": false, "image": "" },
        { "text": "Maine", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which territory was split with Britain?",
      "questionImage": "",
      "answers": [
        { "text": "Oregon", "correct": true, "image": "" },
        { "text": "Louisiana", "correct": false, "image": "" },
        { "text": "Hawaii", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which area joined after the war with Mexico?",
      "questionImage": "",
      "answers": [
        { "text": "California", "correct": true, "image": "" },
        { "text": "Vermont", "correct": false, "image": "" },
        { "text": "Georgia", "correct": false, "image": "" }
      ]
    }
  ]
},
  "americanflagmc": {
    "slug": "americanflagmc",
    "title": "American Flag",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. How many stars appear on the flag of the United States today?",
        "questionImage": "",
        "answers": [
          { "text": "50", "correct": true, "image": "" },
          { "text": "13", "correct": false, "image": "" },
          { "text": "25", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many stripes are on the flag of the United States?",
        "questionImage": "",
        "answers": [
          { "text": "13", "correct": true, "image": "" },
          { "text": "10", "correct": false, "image": "" },
          { "text": "20", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do the stars on the United States flag represent?",
        "questionImage": "",
        "answers": [
          { "text": "50 states", "correct": true, "image": "" },
          { "text": "13 colonies", "correct": false, "image": "" },
          { "text": "Presidents", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do the stripes on the United States flag stand for?",
        "questionImage": "",
        "answers": [
          { "text": "13 colonies", "correct": true, "image": "" },
          { "text": "50 states", "correct": false, "image": "" },
          { "text": "Rivers", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What feeling or value does the American flag often show?",
        "questionImage": "",
        "answers": [
          { "text": "Patriotism", "correct": true, "image": "" },
          { "text": "Weather", "correct": false, "image": "" },
          { "text": "Music", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "ancientchina": {
    "slug": "ancientchina",
    "title": "Ancient China",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which continent was Ancient China a part of according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Asia", "correct": true, "image": "" },
          { "text": "Africa", "correct": false, "image": "" },
          { "text": "Europe", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What kind of written language did people in Ancient China use?",
        "questionImage": "",
        "answers": [
          { "text": "Symbols", "correct": true, "image": "" },
          { "text": "Alphabet", "correct": false, "image": "" },
          { "text": "Runes", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which river did Ancient China use for irrigation and farming?",
        "questionImage": "",
        "answers": [
          { "text": "Huang He River", "correct": true, "image": "" },
          { "text": "Nile River", "correct": false, "image": "" },
          { "text": "Tigris River", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which invention from Ancient China helped people find directions?",
        "questionImage": "",
        "answers": [
          { "text": "Compass", "correct": true, "image": "" },
          { "text": "Clock", "correct": false, "image": "" },
          { "text": "Abacus", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which large structure did the people of Ancient China build to protect their land?",
        "questionImage": "",
        "answers": [
          { "text": "Great Wall", "correct": true, "image": "" },
          { "text": "Colosseum", "correct": false, "image": "" },
          { "text": "Pyramids", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "ancientegypt": {
    "slug": "ancientegypt",
    "title": "Ancient Egypt",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. On which continent was Ancient Egypt located according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Africa", "correct": true, "image": "" },
          { "text": "Asia", "correct": false, "image": "" },
          { "text": "Europe", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which river provided water for farming in Ancient Egypt?",
        "questionImage": "",
        "answers": [
          { "text": "Nile River", "correct": true, "image": "" },
          { "text": "Tigris River", "correct": false, "image": "" },
          { "text": "Euphrates River", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How is the climate of Ancient Egypt described in the song?",
        "questionImage": "",
        "answers": [
          { "text": "Hot and dry", "correct": true, "image": "" },
          { "text": "Cold", "correct": false, "image": "" },
          { "text": "Rainy", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What kind of writing did Ancient Egyptians use according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Hieroglyphics", "correct": true, "image": "" },
          { "text": "Cuneiform", "correct": false, "image": "" },
          { "text": "Alphabet", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which large structures are Ancient Egyptians famous for building?",
        "questionImage": "",
        "answers": [
          { "text": "Pyramids", "correct": true, "image": "" },
          { "text": "Great Wall", "correct": false, "image": "" },
          { "text": "Parthenon", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "ancientgreece": {
    "slug": "ancientgreece",
    "title": "Ancient Greece",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What kind of clothing did people in Ancient Greece wear according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Chiton", "correct": true, "image": "" },
          { "text": "Toga", "correct": false, "image": "" },
          { "text": "Kimono", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which city in Ancient Greece was known for education and learning?",
        "questionImage": "",
        "answers": [
          { "text": "Athens", "correct": true, "image": "" },
          { "text": "Sparta", "correct": false, "image": "" },
          { "text": "Troy", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What did the Greeks call their marketplaces where they traded goods?",
        "questionImage": "",
        "answers": [
          { "text": "Agoras", "correct": true, "image": "" },
          { "text": "Bazaars", "correct": false, "image": "" },
          { "text": "Fora", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What type of government is Ancient Greece called the birthplace of in the song?",
        "questionImage": "",
        "answers": [
          { "text": "Democracy", "correct": true, "image": "" },
          { "text": "Monarchy", "correct": false, "image": "" },
          { "text": "Empire", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which famous temple with rows of columns was built in Athens?",
        "questionImage": "",
        "answers": [
          { "text": "Parthenon", "correct": true, "image": "" },
          { "text": "Pantheon", "correct": false, "image": "" },
          { "text": "Colosseum", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "ancientrome": {
    "slug": "ancientrome",
    "title": "Ancient Rome",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. In which modern country is the city of Rome located today?",
        "questionImage": "",
        "answers": [
          { "text": "Italy", "correct": true, "image": "" },
          { "text": "France", "correct": false, "image": "" },
          { "text": "Greece", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What word describes Ancient Rome’s large area of control across continents?",
        "questionImage": "",
        "answers": [
          { "text": "Empire", "correct": true, "image": "" },
          { "text": "Village", "correct": false, "image": "" },
          { "text": "Kingdom", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which major sea was Ancient Rome located next to as the song explains?",
        "questionImage": "",
        "answers": [
          { "text": "Mediterranean Sea", "correct": true, "image": "" },
          { "text": "Black Sea", "correct": false, "image": "" },
          { "text": "Red Sea", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which structure did Romans build to carry water to their cities?",
        "questionImage": "",
        "answers": [
          { "text": "Aqueducts", "correct": true, "image": "" },
          { "text": "Walls", "correct": false, "image": "" },
          { "text": "Lighthouses", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What form of government did Romans use where people voted for representatives?",
        "questionImage": "",
        "answers": [
          { "text": "Republic", "correct": true, "image": "" },
          { "text": "Monarchy", "correct": false, "image": "" },
          { "text": "Dictatorship", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "angles": {
    "slug": "angles",
    "title": "Angles",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is the measure of a right angle?",
        "answers": [
          { "text": "90°", "correct": true },
          { "text": "45°", "correct": false },
          { "text": "120°", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which type of angle measures less than 90°?",
        "answers": [
          { "text": "Acute angle", "correct": true },
          { "text": "Right angle", "correct": false },
          { "text": "Obtuse angle", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which type of angle measures more than 90° but less than 180°?",
        "answers": [
          { "text": "Obtuse angle", "correct": true },
          { "text": "Acute angle", "correct": false },
          { "text": "Right angle", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What tool is used to measure angles?",
        "answers": [
          { "text": "Protractor", "correct": true },
          { "text": "Ruler", "correct": false },
          { "text": "Compass", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the point called where two rays meet to form an angle?",
        "answers": [
          { "text": "Vertex", "correct": true },
          { "text": "Corner", "correct": false },
          { "text": "Edge", "correct": false }
        ]
      }
    ]
  },
  "animallifecycle": {
  "slug": "animallifecycle",
  "title": "Animal Life Cycle",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each life cycle word to its meaning.",
      "options": [
        { "id": "born", "text": "Born", "image": "", "targetText": "Start of life", "targetImage": "" },
        { "id": "develop", "text": "Develop", "image": "", "targetText": "Grow and change", "targetImage": "" },
        { "id": "reproduce", "text": "Reproduce", "image": "", "targetText": "Make young", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each human stage to its description.",
      "options": [
        { "id": "baby", "text": "Baby", "image": "", "targetText": "Learns basics", "targetImage": "" },
        { "id": "child", "text": "Child", "image": "", "targetText": "Grows bigger", "targetImage": "" },
        { "id": "adult", "text": "Adult", "image": "", "targetText": "Can have young", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match frog stages to what they are.",
      "options": [
        { "id": "egg", "text": "Egg", "image": "", "targetText": "First stage", "targetImage": "" },
        { "id": "tadpole", "text": "Tadpole", "image": "", "targetText": "Tail and gills", "targetImage": "" },
        { "id": "adultfrog", "text": "Adult frog", "image": "", "targetText": "Legs and lungs", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match insect words to the stage.",
      "options": [
        { "id": "egg2", "text": "Egg", "image": "", "targetText": "First stage", "targetImage": "" },
        { "id": "larva", "text": "Larva", "image": "", "targetText": "Caterpillar/grub", "targetImage": "" },
        { "id": "pupa", "text": "Pupa", "image": "", "targetText": "Cocoon/chrysalis", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match the action to the life cycle idea.",
      "options": [
        { "id": "hatch", "text": "Hatch", "image": "", "targetText": "Egg to young", "targetImage": "" },
        { "id": "molt", "text": "Molt", "image": "", "targetText": "Larva grows", "targetImage": "" },
        { "id": "layeggs", "text": "Lay eggs", "image": "", "targetText": "Adult task", "targetImage": "" }
      ]
    }
  ]
},
  "animalneeds": {
  "slug": "animalneeds",
  "title": "Animal Needs",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each basic need to its use.",
      "options": [
        { "id": "food", "text": "Food", "image": "", "targetText": "Eat", "targetImage": "" },
        { "id": "water", "text": "Water", "image": "", "targetText": "Drink", "targetImage": "" },
        { "id": "shelter", "text": "Shelter", "image": "", "targetText": "Home", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match habitat to its main oxygen source.",
      "options": [
        { "id": "land", "text": "Land habitat", "image": "", "targetText": "Air oxygen", "targetImage": "" },
        { "id": "waterHab", "text": "Water habitat", "image": "", "targetText": "Water oxygen", "targetImage": "" },
        { "id": "wetlands", "text": "Wetlands", "image": "", "targetText": "Both air and water", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each resource to what it gives.",
      "options": [
        { "id": "sunlight", "text": "Sunlight", "image": "", "targetText": "Energy", "targetImage": "" },
        { "id": "space", "text": "Space", "image": "", "targetText": "Room to live", "targetImage": "" },
        { "id": "soil", "text": "Soil", "image": "", "targetText": "Place to grow", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each action to the need it meets.",
      "options": [
        { "id": "hunt", "text": "Hunt", "image": "", "targetText": "Food", "targetImage": "" },
        { "id": "drink", "text": "Drink", "image": "", "targetText": "Water", "targetImage": "" },
        { "id": "nest", "text": "Build a nest", "image": "", "targetText": "Shelter", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each example to the resource.",
      "options": [
        { "id": "pond", "text": "Pond", "image": "", "targetText": "Water", "targetImage": "" },
        { "id": "grass", "text": "Grass", "image": "", "targetText": "Food", "targetImage": "" },
        { "id": "burrow", "text": "Burrow", "image": "", "targetText": "Shelter", "targetImage": "" }
      ]
    }
  ]
},
  "areas": {
  "slug": "areas",
  "title": "Areas",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match the landform to its description.",
      "options": [
        { "id": "coastalplain", "text": "Coastal Plain", "image": "", "targetText": "Flat land", "targetImage": "" },
        { "id": "appalachian", "text": "Appalachian", "image": "", "targetText": "Highlands", "targetImage": "" },
        { "id": "interior", "text": "Interior Lowlands", "image": "", "targetText": "Grassy hills", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each flat land region to its name.",
      "options": [
        { "id": "interior2", "text": "Interior", "image": "", "targetText": "Flat lands", "targetImage": "" },
        { "id": "greatplains", "text": "Great Plains", "image": "", "targetText": "Flat lands", "targetImage": "" },
        { "id": "basin", "text": "Basin & Range", "image": "", "targetText": "Lowest point", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Rocky Mountains, Basin & Range, and Coastal Range.",
      "options": [
        { "id": "rocky", "text": "Rocky", "image": "", "targetText": "Rugged", "targetImage": "" },
        { "id": "basin2", "text": "Basin", "image": "", "targetText": "Lowest point", "targetImage": "" },
        { "id": "coastal", "text": "Coastal Range", "image": "", "targetText": "Fertile valleys", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each range to its region.",
      "options": [
        { "id": "coastal2", "text": "Coastal", "image": "", "targetText": "California to Canada", "targetImage": "" },
        { "id": "rocky2", "text": "Rocky", "image": "", "targetText": "Alaska to Mexico", "targetImage": "" },
        { "id": "appalachian2", "text": "Appalachian", "image": "", "targetText": "Canada to Alabama", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Great Plains, Coastal Plain, and Appalachian.",
      "options": [
        { "id": "greatplains2", "text": "Great Plains", "image": "", "targetText": "Grasslands", "targetImage": "" },
        { "id": "coastal3", "text": "Coastal", "image": "", "targetText": "Atlantic Ocean", "targetImage": "" },
        { "id": "appalachian3", "text": "Appalachian", "image": "", "targetText": "Highlands", "targetImage": "" }
      ]
    }
  ]
},
  "articles": {
  "slug": "articles",
  "title": "Articles",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What were the Articles of Confederation?",
      "questionImage": "",
      "answers": [
        { "text": "Constitution", "correct": true, "image": "" },
        { "text": "Treaty", "correct": false, "image": "" },
        { "text": "Speech", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How strong was the national government?",
      "questionImage": "",
      "answers": [
        { "text": "Weak", "correct": true, "image": "" },
        { "text": "Strong", "correct": false, "image": "" },
        { "text": "Absolute", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How many votes did each state have?",
      "questionImage": "",
      "answers": [
        { "text": "One", "correct": true, "image": "" },
        { "text": "Two", "correct": false, "image": "" },
        { "text": "Ten", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which branches were missing?",
      "questionImage": "",
      "answers": [
        { "text": "Exec/Judicial", "correct": true, "image": "" },
        { "text": "Legislative", "correct": false, "image": "" },
        { "text": "Military", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What powers did Congress lack?",
      "questionImage": "",
      "answers": [
        { "text": "Tax/Trade", "correct": true, "image": "" },
        { "text": "War/Peace", "correct": false, "image": "" },
        { "text": "Coins", "correct": false, "image": "" }
      ]
    }
  ]
},
  "asamericans": {
    "slug": "asamericans",
    "title": "As Americans",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which rights are repeated in the chorus as belonging to Americans?",
        "questionImage": "",
        "answers": [
          { "text": "Life, liberty, and happiness", "correct": true, "image": "" },
          { "text": "Only property", "correct": false, "image": "" },
          { "text": "Only travel", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Where do American people come from according to the verse?",
        "questionImage": "",
        "answers": [
          { "text": "Many countries", "correct": true, "image": "" },
          { "text": "One city", "correct": false, "image": "" },
          { "text": "One family", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What kind of government principle unites people as Americans?",
        "questionImage": "",
        "answers": [
          { "text": "A republican form of government", "correct": true, "image": "" },
          { "text": "Absolute rule", "correct": false, "image": "" },
          { "text": "No laws", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What idea shows that Americans have different backgrounds?",
        "questionImage": "",
        "answers": [
          { "text": "Different ethnic origins", "correct": true, "image": "" },
          { "text": "Same hobbies", "correct": false, "image": "" },
          { "text": "Same food", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do these government principles help Americans do together?",
        "questionImage": "",
        "answers": [
          { "text": "Unite as one nation", "correct": true, "image": "" },
          { "text": "Divide from each other", "correct": false, "image": "" },
          { "text": "Separate by regions", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "asanative": {
  "slug": "asanative",
  "title": "As a Native",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What food did American Natives get from water?",
      "questionImage": "",
      "answers": [
        { "text": "Fish", "correct": true, "image": "" },
        { "text": "Corn", "correct": false, "image": "" },
        { "text": "Wheat", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did they grow in fields?",
      "questionImage": "",
      "answers": [
        { "text": "Crops", "correct": true, "image": "" },
        { "text": "Iron", "correct": false, "image": "" },
        { "text": "Cloth", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did they make clothes from?",
      "questionImage": "",
      "answers": [
        { "text": "Plants", "correct": false, "image": "" },
        { "text": "Animal skins", "correct": false, "image": "" },
        { "text": "Both", "correct": true, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What type of resources were animals?",
      "questionImage": "",
      "answers": [
        { "text": "Natural", "correct": true, "image": "" },
        { "text": "Capital", "correct": false, "image": "" },
        { "text": "Human", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What type of resources were canoes and bows?",
      "questionImage": "",
      "answers": [
        { "text": "Capital", "correct": true, "image": "" },
        { "text": "Human", "correct": false, "image": "" },
        { "text": "Natural", "correct": false, "image": "" }
      ]
    }
  ]
},
  "atoms": {
  "slug": "atoms",
  "title": "Atoms",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What are atoms?",
      "questionImage": "",
      "answers": [
        { "text": "Smallest particles of matter", "correct": true, "image": "" },
        { "text": "Biggest rocks on Earth", "correct": false, "image": "" },
        { "text": "Drops of water", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which particles live in the nucleus?",
      "questionImage": "",
      "answers": [
        { "text": "Protons & neutrons", "correct": true, "image": "" },
        { "text": "Electrons only", "correct": false, "image": "" },
        { "text": "Photons & shadows", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What charge does a proton have?",
      "questionImage": "",
      "answers": [
        { "text": "Positive", "correct": true, "image": "" },
        { "text": "Negative", "correct": false, "image": "" },
        { "text": "No charge", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which particle has no charge?",
      "questionImage": "",
      "answers": [
        { "text": "Neutron", "correct": true, "image": "" },
        { "text": "Proton", "correct": false, "image": "" },
        { "text": "Electron", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where do electrons move?",
      "questionImage": "",
      "answers": [
        { "text": "Around the nucleus", "correct": true, "image": "" },
        { "text": "Inside the core", "correct": false, "image": "" },
        { "text": "Far outside the atom", "correct": false, "image": "" }
      ]
    }
  ]
},
  "bargraph": {
    "slug": "bargraph",
    "title": "Bar Graph",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What does a bar graph show?",
        "answers": [
          { "text": "Data with bars you can compare", "correct": true },
          { "text": "Only pictures of animals", "correct": false },
          { "text": "Maps of roads", "correct": false },
          { "text": "Stories", "correct": false }
        ]
      },
      {
        "question": "If 7 kids like cats and 4 like dogs, how many more like cats?",
        "answers": [
          { "text": "3", "correct": true },
          { "text": "2", "correct": false },
          { "text": "11", "correct": false },
          { "text": "1", "correct": false }
        ]
      },
      {
        "question": "If 3 kids like red, 2 like blue, and 1 likes green, how many in all?",
        "answers": [
          { "text": "6", "correct": true },
          { "text": "5", "correct": false },
          { "text": "3", "correct": false },
          { "text": "1", "correct": false }
        ]
      }
    ]
  },
  "barter": {
    "slug": "barter",
    "title": "Barter",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What does the word barter mean in the song?",
        "questionImage": "",
        "answers": [
          { "text": "To trade goods or services", "correct": true, "image": "" },
          { "text": "To print money", "correct": false, "image": "" },
          { "text": "To save coins", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How common was money for most people long ago?",
        "questionImage": "",
        "answers": [
          { "text": "It was rare", "correct": true, "image": "" },
          { "text": "It was everywhere", "correct": false, "image": "" },
          { "text": "It was free to use", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What item was sometimes used like money for trading?",
        "questionImage": "",
        "answers": [
          { "text": "Tobacco", "correct": true, "image": "" },
          { "text": "Rocks", "correct": false, "image": "" },
          { "text": "Leaves", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. In bartering, what do people trade with each other?",
        "questionImage": "",
        "answers": [
          { "text": "Goods and services", "correct": true, "image": "" },
          { "text": "Only food", "correct": false, "image": "" },
          { "text": "Only land", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What would a farmer most likely do when money was not used?",
        "questionImage": "",
        "answers": [
          { "text": "Barter or trade items", "correct": true, "image": "" },
          { "text": "Borrow money from a bank", "correct": false, "image": "" },
          { "text": "Hide his goods", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "battles": {
  "slug": "battles",
  "title": "Battles",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What was the first land battle fought in Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Great Bridge", "correct": true, "image": "" },
        { "text": "Yorktown", "correct": false, "image": "" },
        { "text": "Saratoga", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What happened to the British governor after the Battle of Great Bridge?",
      "questionImage": "",
      "answers": [
        { "text": "He fled Norfolk", "correct": true, "image": "" },
        { "text": "He won the city", "correct": false, "image": "" },
        { "text": "He held a trial", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What was the last major battle of the American Revolution?",
      "questionImage": "",
      "answers": [
        { "text": "Yorktown", "correct": true, "image": "" },
        { "text": "Bunker Hill", "correct": false, "image": "" },
        { "text": "Trenton", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What was the result of the Battle of Yorktown?",
      "questionImage": "",
      "answers": [
        { "text": "British surrender", "correct": true, "image": "" },
        { "text": "British victory", "correct": false, "image": "" },
        { "text": "Stalemate", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the victory at Yorktown lead to?",
      "questionImage": "",
      "answers": [
        { "text": "The end of the war", "correct": true, "image": "" },
        { "text": "New taxes", "correct": false, "image": "" },
        { "text": "More battles", "correct": false, "image": "" }
      ]
    }
  ]
},
  "believe": {
  "slug": "believe",
  "title": "Believe",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What slogan did colonists say to protest unfair taxes?",
      "questionImage": "",
      "answers": [
        { "text": "No taxation without representation", "correct": true, "image": "" },
        { "text": "More taxes for all", "correct": false, "image": "" },
        { "text": "Buy British goods", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who said they had the legal authority to govern the colonies?",
      "questionImage": "",
      "answers": [
        { "text": "Parliament", "correct": true, "image": "" },
        { "text": "France", "correct": false, "image": "" },
        { "text": "Spain", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who did the colonists believe had the right to govern them?",
      "questionImage": "",
      "answers": [
        { "text": "Their local assemblies", "correct": true, "image": "" },
        { "text": "The royal navy", "correct": false, "image": "" },
        { "text": "City guilds", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did Parliament claim it could do to the colonies?",
      "questionImage": "",
      "answers": [
        { "text": "Tax the colonies", "correct": true, "image": "" },
        { "text": "Pick mayors", "correct": false, "image": "" },
        { "text": "Close ports", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why did colonists say taxes were unfair?",
      "questionImage": "",
      "answers": [
        { "text": "They had no representatives in Parliament", "correct": true, "image": "" },
        { "text": "They were too easy to pay", "correct": false, "image": "" },
        { "text": "They wanted more stamps", "correct": false, "image": "" }
      ]
    }
  ]
},
  "benjaminfranklin": {
    "slug": "benjaminfranklin",
    "title": "Benjamin Franklin",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which helpful item for seeing clearly did Benjamin Franklin invent?",
        "questionImage": "",
        "answers": [
          { "text": "Bifocals", "correct": true, "image": "" },
          { "text": "Microscope", "correct": false, "image": "" },
          { "text": "Telescope", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What did Franklin’s kite experiment help show about lightning?",
        "questionImage": "",
        "answers": [
          { "text": "It’s electricity", "correct": true, "image": "" },
          { "text": "It’s magnetism", "correct": false, "image": "" },
          { "text": "It’s gravity", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which important document did Benjamin Franklin help write?",
        "questionImage": "",
        "answers": [
          { "text": "Declaration of Independence", "correct": true, "image": "" },
          { "text": "Bill of Rights", "correct": false, "image": "" },
          { "text": "Gettysburg Address", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which other important document did Benjamin Franklin sign?",
        "questionImage": "",
        "answers": [
          { "text": "U.S. Constitution", "correct": true, "image": "" },
          { "text": "Emancipation Proclamation", "correct": false, "image": "" },
          { "text": "Homestead Act", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Did Benjamin Franklin ever serve as President of the United States?",
        "questionImage": "",
        "answers": [
          { "text": "No", "correct": true, "image": "" },
          { "text": "Yes", "correct": false, "image": "" },
          { "text": "Maybe", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "builditflat": {
    "slug": "builditflat",
    "title": "Build It Flat",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Two equal right triangles can fit together to make a ____.",
        "answers": [
          { "text": "Rectangle", "correct": true },
          { "text": "Circle", "correct": false },
          { "text": "Cone", "correct": false },
          { "text": "Sphere", "correct": false }
        ]
      },
      {
        "question": "Which set can make a square?",
        "answers": [
          { "text": "Two equal triangles", "correct": true },
          { "text": "Two circles", "correct": false },
          { "text": "One triangle and one circle", "correct": false },
          { "text": "Only one rectangle", "correct": false }
        ]
      },
      {
        "question": "Putting shapes together to make new shapes is called:",
        "answers": [
          { "text": "Composing shapes", "correct": true },
          { "text": "Coloring shapes", "correct": false },
          { "text": "Counting shapes", "correct": false },
          { "text": "Erasing shapes", "correct": false }
        ]
      }
    ]
  },
  "capitolbuilding": {
    "slug": "capitolbuilding",
    "title": "Capitol Building",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which group meets in the United States Capitol Building to do their work?",
        "questionImage": "",
        "answers": [
          { "text": "Congress", "correct": true, "image": "" },
          { "text": "Supreme Court", "correct": false, "image": "" },
          { "text": "Cabinet", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. In which city is the United States Capitol Building located?",
        "questionImage": "",
        "answers": [
          { "text": "Washington, D.C.", "correct": true, "image": "" },
          { "text": "Richmond, Virginia", "correct": false, "image": "" },
          { "text": "Boston, Massachusetts", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What are the names of the two groups that make up the United States Congress?",
        "questionImage": "",
        "answers": [
          { "text": "Senate and House of Representatives", "correct": true, "image": "" },
          { "text": "President and Court", "correct": false, "image": "" },
          { "text": "Mayor and Council", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the main job of Congress when they meet at the Capitol?",
        "questionImage": "",
        "answers": [
          { "text": "Make laws", "correct": true, "image": "" },
          { "text": "Hold concerts", "correct": false, "image": "" },
          { "text": "Plan parties", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the name of the statue that stands on top of the Capitol dome?",
        "questionImage": "",
        "answers": [
          { "text": "Statue of Freedom", "correct": true, "image": "" },
          { "text": "Statue of Liberty", "correct": false, "image": "" },
          { "text": "Lincoln Statue", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "cashcrops": {
  "slug": "cashcrops",
  "title": "Cash Crops",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What were crops sometimes used as in Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Money", "correct": true, "image": "" },
        { "text": "Toys", "correct": false, "image": "" },
        { "text": "Jewels", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What were these kinds of money-making crops called?",
      "questionImage": "",
      "answers": [
        { "text": "Cash crops", "correct": true, "image": "" },
        { "text": "Food crops", "correct": false, "image": "" },
        { "text": "Free crops", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which crop made the most money for Virginia’s economy?",
      "questionImage": "",
      "answers": [
        { "text": "Tobacco", "correct": true, "image": "" },
        { "text": "Rice", "correct": false, "image": "" },
        { "text": "Corn", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who worked the tobacco plantations?",
      "questionImage": "",
      "answers": [
        { "text": "Enslaved people", "correct": true, "image": "" },
        { "text": "Kings", "correct": false, "image": "" },
        { "text": "Explorers", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who was brought to Virginia to provide labor for the plantations?",
      "questionImage": "",
      "answers": [
        { "text": "Africans", "correct": true, "image": "" },
        { "text": "Spanish", "correct": false, "image": "" },
        { "text": "French", "correct": false, "image": "" }
      ]
    }
  ]
},
  "charters": {
  "slug": "charters",
  "title": "Charters",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Who granted the Virginia Company charters?",
      "questionImage": "",
      "answers": [
        { "text": "King of England", "correct": true, "image": "" },
        { "text": "French king", "correct": false, "image": "" },
        { "text": "Spanish king", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who received the charters from the King?",
      "questionImage": "",
      "answers": [
        { "text": "Virginia Company", "correct": true, "image": "" },
        { "text": "Dutch East India Company", "correct": false, "image": "" },
        { "text": "Hudson’s Bay Company", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the charters allow the Virginia Company to do?",
      "questionImage": "",
      "answers": [
        { "text": "Create settlements", "correct": true, "image": "" },
        { "text": "Start wars", "correct": false, "image": "" },
        { "text": "Block trade", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did each charter state or describe?",
      "questionImage": "",
      "answers": [
        { "text": "Rights and laws", "correct": true, "image": "" },
        { "text": "Songs and poems", "correct": false, "image": "" },
        { "text": "Menus and meals", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where were the new English settlements located?",
      "questionImage": "",
      "answers": [
        { "text": "North America", "correct": true, "image": "" },
        { "text": "Asia", "correct": false, "image": "" },
        { "text": "Africa", "correct": false, "image": "" }
      ]
    }
  ]
},
  "christophernewport": {
    "slug": "christophernewport",
    "title": "Christopher Newport",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match what Christopher Newport is best known for.",
        "options": [
          { "id": "newport_explorer", "text": "Christopher Newport", "image": "", "targetText": "Explorer", "targetImage": "" },
          { "id": "newport_captain", "text": "Sea Captain", "image": "", "targetText": "Led the ships", "targetImage": "" },
          { "id": "newport_founder", "text": "Leader", "image": "", "targetText": "Helped start Jamestown", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each voyage detail to where or what it describes.",
        "options": [
          { "id": "eng_to_va", "text": "England → Jamestown", "image": "", "targetText": "Voyage route", "targetImage": "" },
          { "id": "atlantic_ocean", "text": "Atlantic Ocean", "image": "", "targetText": "Crossed by ship", "targetImage": "" },
          { "id": "virginia_coast", "text": "Virginia Coast", "image": "", "targetText": "Landing area", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match what Christopher Newport brought to the colony.",
        "options": [
          { "id": "people_supplies", "text": "People and supplies", "image": "", "targetText": "To new colony", "targetImage": "" },
          { "id": "food_goods", "text": "Food and goods", "image": "", "targetText": "For survival", "targetImage": "" },
          { "id": "tools_weapons", "text": "Tools and weapons", "image": "", "targetText": "For work and safety", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each ship to what it carried or did.",
        "options": [
          { "id": "susan_constant", "text": "Susan Constant", "image": "", "targetText": "Main supply ship", "targetImage": "" },
          { "id": "godspeed", "text": "Godspeed", "image": "", "targetText": "Carried settlers", "targetImage": "" },
          { "id": "discovery", "text": "Discovery", "image": "", "targetText": "Exploration ship", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each fact to what it tells about Christopher Newport.",
        "options": [
          { "id": "leader_role", "text": "Captain", "image": "", "targetText": "Led voyage", "targetImage": "" },
          { "id": "help_found", "text": "Founder", "image": "", "targetText": "Helped start colony", "targetImage": "" },
          { "id": "brave_explorer", "text": "Explorer", "image": "", "targetText": "Sailed across ocean", "targetImage": "" }
        ]
      }
    ]
  },
  "circuits": {
  "slug": "circuits",
  "title": "Circuits",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. A circuit is?",
      "questionImage": "",
      "answers": [
        { "text": "Path electricity takes", "correct": true, "image": "" },
        { "text": "Path water takes", "correct": false, "image": "" },
        { "text": "Path wind takes", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Electricity flows through?",
      "questionImage": "",
      "answers": [
        { "text": "Closed circuit", "correct": true, "image": "" },
        { "text": "Open circuit", "correct": false, "image": "" },
        { "text": "Broken path", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Series circuits have?",
      "questionImage": "",
      "answers": [
        { "text": "One path", "correct": true, "image": "" },
        { "text": "No path", "correct": false, "image": "" },
        { "text": "Many paths", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Parallel circuits have?",
      "questionImage": "",
      "answers": [
        { "text": "More than one path", "correct": true, "image": "" },
        { "text": "Only one path", "correct": false, "image": "" },
        { "text": "Closed loop only", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Electricity cannot flow through?",
      "questionImage": "",
      "answers": [
        { "text": "Open circuit", "correct": true, "image": "" },
        { "text": "Closed circuit", "correct": false, "image": "" },
        { "text": "Parallel circuit", "correct": false, "image": "" }
      ]
    }
  ]
},
  "civilwarcauses": {
  "slug": "civilwarcauses",
  "title": "Civil War Causes",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What did the Missouri Compromise do?",
      "questionImage": "",
      "answers": [
        { "text": "Split the nation into free and slave states", "correct": true, "image": "" },
        { "text": "Ended slavery everywhere", "correct": false, "image": "" },
        { "text": "Banned all farming", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the Fugitive Slave Law require people to do?",
      "questionImage": "",
      "answers": [
        { "text": "Capture escaped enslaved people", "correct": true, "image": "" },
        { "text": "Free enslaved people", "correct": false, "image": "" },
        { "text": "End all taxes", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the Dred Scott case decide?",
      "questionImage": "",
      "answers": [
        { "text": "Enslaved people were property, not citizens", "correct": true, "image": "" },
        { "text": "Enslaved people were free in the North", "correct": false, "image": "" },
        { "text": "Enslaved people could vote", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who led a raid to end slavery at Harpers Ferry?",
      "questionImage": "",
      "answers": [
        { "text": "John Brown", "correct": true, "image": "" },
        { "text": "Abraham Lincoln", "correct": false, "image": "" },
        { "text": "Jefferson Davis", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What event officially started the Civil War?",
      "questionImage": "",
      "answers": [
        { "text": "The attack on Fort Sumter", "correct": true, "image": "" },
        { "text": "The Battle of Bull Run", "correct": false, "image": "" },
        { "text": "The Battle of Gettysburg", "correct": false, "image": "" }
      ]
    }
  ]
},
  "colonialtimes": {
  "slug": "colonialtimes",
  "title": "Colonial Times",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Who did large landowners rely on for labor?",
      "questionImage": "",
      "answers": [
        { "text": "Slaves/servants", "correct": true, "image": "" },
        { "text": "Robots", "correct": false, "image": "" },
        { "text": "Kings", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who did farmers depend on for labor?",
      "questionImage": "",
      "answers": [
        { "text": "Family", "correct": true, "image": "" },
        { "text": "Soldiers", "correct": false, "image": "" },
        { "text": "Teachers", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What was a woman's main role?",
      "questionImage": "",
      "answers": [
        { "text": "Homemaker", "correct": true, "image": "" },
        { "text": "Governor", "correct": false, "image": "" },
        { "text": "Warrior", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Could women vote in colonial times?",
      "questionImage": "",
      "answers": [
        { "text": "No", "correct": true, "image": "" },
        { "text": "Yes", "correct": false, "image": "" },
        { "text": "Sometimes", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Could free African Americans own land?",
      "questionImage": "",
      "answers": [
        { "text": "Yes", "correct": true, "image": "" },
        { "text": "No", "correct": false, "image": "" },
        { "text": "Only slaves", "correct": false, "image": "" }
      ]
    }
  ]
},
  "comparefractions": {
    "slug": "comparefractions",
    "title": "Compare Fractions",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which fraction is greater: 3/4 or 1/4?",
        "answers": [
          { "text": "3/4", "correct": true },
          { "text": "1/4", "correct": false },
          { "text": "They are equal", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which fraction is less: 2/8 or 6/8?",
        "answers": [
          { "text": "2/8", "correct": true },
          { "text": "6/8", "correct": false },
          { "text": "They are equal", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which pair of fractions are equal?",
        "answers": [
          { "text": "1/2 and 2/4", "correct": true },
          { "text": "1/3 and 2/3", "correct": false },
          { "text": "1/4 and 3/4", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When fractions have the same denominator, how do you compare them?",
        "answers": [
          { "text": "Compare the numerators", "correct": true },
          { "text": "Compare the denominators", "correct": false },
          { "text": "Add them together", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which is greater: 2/3 or 2/6?",
        "answers": [
          { "text": "2/3", "correct": true },
          { "text": "2/6", "correct": false },
          { "text": "They are equal", "correct": false }
        ]
      }
    ]
  },
  "compression": {
  "slug": "compression",
  "title": "Compression",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match wave type to description.",
      "options": [
        { "id": "long", "text": "Compression", "image": "", "targetText": "Longitudinal", "targetImage": "" },
        { "id": "side", "text": "Moves back/forward", "image": "", "targetText": "Direction of travel", "targetImage": "" },
        { "id": "sound", "text": "Sound wave", "image": "", "targetText": "Compression wave", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match medium to fact.",
      "options": [
        { "id": "solid", "text": "Solid", "image": "", "targetText": "Carries sound", "targetImage": "" },
        { "id": "liquid", "text": "Liquid", "image": "", "targetText": "Carries sound", "targetImage": "" },
        { "id": "gas", "text": "Gas", "image": "", "targetText": "Carries sound", "targetImage": "" }
      ]
    }
  ]
},
  "conductors": {
  "slug": "conductors",
  "title": "Conductors",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match material to type.",
      "options": [
        { "id": "copper", "text": "Copper", "image": "", "targetText": "Conductor", "targetImage": "" },
        { "id": "gold", "text": "Gold", "image": "", "targetText": "Conductor", "targetImage": "" },
        { "id": "rubber", "text": "Rubber", "image": "", "targetText": "Insulator", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match more examples.",
      "options": [
        { "id": "styro", "text": "Styrofoam", "image": "", "targetText": "Insulator", "targetImage": "" },
        { "id": "wire", "text": "Metal wire", "image": "", "targetText": "Conductor", "targetImage": "" },
        { "id": "glass", "text": "Glass", "image": "", "targetText": "Insulator", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match term to meaning.",
      "options": [
        { "id": "condef", "text": "Conductor", "image": "", "targetText": "Flows easily", "targetImage": "" },
        { "id": "insdef", "text": "Insulator", "image": "", "targetText": "Doesn’t flow", "targetImage": "" },
        { "id": "electron", "text": "Electrons", "image": "", "targetText": "Jumping", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match idea to effect.",
      "options": [
        { "id": "jump", "text": "Electron jump", "image": "", "targetText": "Current", "targetImage": "" },
        { "id": "block", "text": "No jumping", "image": "", "targetText": "No current", "targetImage": "" },
        { "id": "flow", "text": "Easy flow", "image": "", "targetText": "Conduct", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match item to category.",
      "options": [
        { "id": "coin", "text": "Copper coin", "image": "", "targetText": "Conductor", "targetImage": "" },
        { "id": "eraser", "text": "Rubber band", "image": "", "targetText": "Insulator", "targetImage": "" },
        { "id": "foil", "text": "Gold foil", "image": "", "targetText": "Conductor", "targetImage": "" }
      ]
    }
  ]
},
  "conservewater": {
  "slug": "conservewater",
  "title": "Conserve Water",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. When should you turn the water off while washing hands?",
      "questionImage": "",
      "answers": [
        { "text": "While scrubbing", "correct": true, "image": "" },
        { "text": "All the time", "correct": false, "image": "" },
        { "text": "Never ever", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What should you do after wetting your hands?",
      "questionImage": "",
      "answers": [
        { "text": "Add soap, turn off", "correct": true, "image": "" },
        { "text": "Add soap, leave on", "correct": false, "image": "" },
        { "text": "Skip soap", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When brushing teeth, how do you save water?",
      "questionImage": "",
      "answers": [
        { "text": "Turn off while brushing", "correct": true, "image": "" },
        { "text": "Run water the whole time", "correct": false, "image": "" },
        { "text": "Use extra water for fun", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When should you turn the water back on?",
      "questionImage": "",
      "answers": [
        { "text": "To rinse", "correct": true, "image": "" },
        { "text": "To sing", "correct": false, "image": "" },
        { "text": "To look at it", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why do we conserve water?",
      "questionImage": "",
      "answers": [
        { "text": "Protect resources", "correct": true, "image": "" },
        { "text": "Make bigger bills", "correct": false, "image": "" },
        { "text": "Waste on purpose", "correct": false, "image": "" }
      ]
    }
  ]
},
  "continentsandoceans": {
    "slug": "continentsandoceans",
    "title": "Continents and Oceans",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each name to whether it is a continent or an ocean.",
        "options": [
          { "id": "af", "text": "Africa", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "eu", "text": "Europe", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "na", "text": "North America", "image": "", "targetText": "Continent", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Continue matching the names to the correct category.",
        "options": [
          { "id": "sa", "text": "South America", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "as", "text": "Asia", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "an", "text": "Antarctica", "image": "", "targetText": "Continent", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Finish the continent matches by placing each name in the correct group.",
        "options": [
          { "id": "au", "text": "Australia", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "af2", "text": "Africa", "image": "", "targetText": "Continent", "targetImage": "" },
          { "id": "eu2", "text": "Europe", "image": "", "targetText": "Continent", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each ocean name to the word Ocean.",
        "options": [
          { "id": "pac", "text": "Pacific Ocean", "image": "", "targetText": "Ocean", "targetImage": "" },
          { "id": "atl", "text": "Atlantic Ocean", "image": "", "targetText": "Ocean", "targetImage": "" },
          { "id": "ind", "text": "Indian Ocean", "image": "", "targetText": "Ocean", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Complete the ocean matches by placing each remaining name with Ocean.",
        "options": [
          { "id": "arc", "text": "Arctic Ocean", "image": "", "targetText": "Ocean", "targetImage": "" },
          { "id": "sou", "text": "Southern Ocean", "image": "", "targetText": "Ocean", "targetImage": "" },
          { "id": "pac2", "text": "Pacific Ocean", "image": "", "targetText": "Ocean", "targetImage": "" }
        ]
      }
    ]
  },
  "contributions": {
    "slug": "contributions",
    "title": "Contributions",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each leader to the kind of contribution they made to society.",
        "options": [
          { "id": "ashe_social", "text": "Arthur Ashe", "image": "", "targetText": "Social change", "targetImage": "" },
          { "id": "walker_business", "text": "Maggie Walker", "image": "", "targetText": "Business success", "targetImage": "" },
          { "id": "wilder_governor", "text": "L. Douglas Wilder", "image": "", "targetText": "Political leadership", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each person to the important ‘first’ they achieved.",
        "options": [
          { "id": "wilder_firstgov", "text": "L. Douglas Wilder", "image": "", "targetText": "First Black Governor", "targetImage": "" },
          { "id": "walker_firstbank", "text": "Maggie Walker", "image": "", "targetText": "First woman bank owner", "targetImage": "" },
          { "id": "ashe_firstchamp", "text": "Arthur Ashe", "image": "", "targetText": "First Black tennis champion", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each leader to the field they influenced most.",
        "options": [
          { "id": "oliverhill_law", "text": "Oliver Hill", "image": "", "targetText": "Law and rights", "targetImage": "" },
          { "id": "ashe_sports", "text": "Arthur Ashe", "image": "", "targetText": "Sports and equality", "targetImage": "" },
          { "id": "walker_finance", "text": "Maggie Walker", "image": "", "targetText": "Finance and business", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each person to what they worked to improve.",
        "options": [
          { "id": "oliverhill_schools", "text": "Oliver Hill", "image": "", "targetText": "Equal schools", "targetImage": "" },
          { "id": "ashe_health", "text": "Arthur Ashe", "image": "", "targetText": "Health awareness", "targetImage": "" },
          { "id": "walker_jobs", "text": "Maggie Walker", "image": "", "targetText": "Jobs for others", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each contribution to the person who made it.",
        "options": [
          { "id": "brownvboard", "text": "Oliver Hill", "image": "", "targetText": "Brown v. Board case", "targetImage": "" },
          { "id": "bank_lead", "text": "Maggie Walker", "image": "", "targetText": "Opened bank", "targetImage": "" },
          { "id": "governor_va", "text": "L. Douglas Wilder", "image": "", "targetText": "Governor of Virginia", "targetImage": "" }
        ]
      }
    ]
  },
  "coordinates": {
    "slug": "coordinates",
    "title": "Coordinates",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What do we use coordinates to find on a simple map grid in this lesson?",
        "questionImage": "",
        "answers": [
          { "text": "Location", "correct": true, "image": "" },
          { "text": "Weather", "correct": false, "image": "" },
          { "text": "Time", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. On a letter–number grid, what do we look at first to start finding a place?",
        "questionImage": "",
        "answers": [
          { "text": "Letter", "correct": true, "image": "" },
          { "text": "Picture", "correct": false, "image": "" },
          { "text": "Title", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. After the letter, what is the next thing we find on the grid to locate the spot?",
        "questionImage": "",
        "answers": [
          { "text": "Number", "correct": true, "image": "" },
          { "text": "Color", "correct": false, "image": "" },
          { "text": "Arrow", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Where do the letter and number meet to show the location on the map?",
        "questionImage": "",
        "answers": [
          { "text": "Grid square", "correct": true, "image": "" },
          { "text": "Compass", "correct": false, "image": "" },
          { "text": "Border", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What two things together make a simple map coordinate in this activity?",
        "questionImage": "",
        "answers": [
          { "text": "Letter and number", "correct": true, "image": "" },
          { "text": "Two colors", "correct": false, "image": "" },
          { "text": "Two arrows", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "countby10s": {
    "slug": "countby10s",
    "title": "Count By 10's",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What number comes after 10 when counting by 10's?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "15", "correct": false },
          { "text": "25", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What number comes after 40 when counting by 10's?",
        "answers": [
          { "text": "50", "correct": true },
          { "text": "45", "correct": false },
          { "text": "60", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which list shows numbers counted by 10's?",
        "answers": [
          { "text": "10, 20, 30, 40, 50", "correct": true },
          { "text": "5, 10, 15, 20, 25", "correct": false },
          { "text": "2, 4, 6, 8, 10", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What number comes before 100 when counting by 10's?",
        "answers": [
          { "text": "90", "correct": true },
          { "text": "80", "correct": false },
          { "text": "70", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How much does each number increase when you count by 10's?",
        "answers": [
          { "text": "10 more each time", "correct": true },
          { "text": "5 more each time", "correct": false },
          { "text": "2 more each time", "correct": false }
        ]
      }
    ]
  },
  "countby3s": {
    "slug": "countby3s",
    "title": "Count By 3's",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What number comes after 3 when counting by 3’s?",
        "answers": [
          { "text": "6", "correct": true },
          { "text": "4", "correct": false },
          { "text": "5", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If you start at 6 and count by 3’s, what number comes next?",
        "answers": [
          { "text": "9", "correct": true },
          { "text": "8", "correct": false },
          { "text": "10", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which number is part of the 3’s pattern?",
        "answers": [
          { "text": "15", "correct": true },
          { "text": "14", "correct": false },
          { "text": "13", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What number comes after 21 when counting by 3’s?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "25", "correct": false },
          { "text": "22", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If you keep counting by 3’s, what number comes after 27?",
        "answers": [
          { "text": "30", "correct": true },
          { "text": "28", "correct": false },
          { "text": "31", "correct": false }
        ]
      }
    ]
  },
  "countby5s": {
    "slug": "countby5s",
    "title": "Count By 5's",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What number comes after 5 when counting by 5's?",
        "answers": [
          { "text": "10", "correct": true },
          { "text": "6", "correct": false },
          { "text": "15", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What number comes after 25 when counting by 5's?",
        "answers": [
          { "text": "30", "correct": true },
          { "text": "35", "correct": false },
          { "text": "20", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What number do you say after 50 when counting by 5's?",
        "answers": [
          { "text": "55", "correct": true },
          { "text": "60", "correct": false },
          { "text": "65", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which list shows numbers counted by 5's?",
        "answers": [
          { "text": "5, 10, 15, 20, 25", "correct": true },
          { "text": "2, 4, 6, 8, 10", "correct": false },
          { "text": "1, 3, 5, 7, 9", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What number comes before 100 when counting by 5's?",
        "answers": [
          { "text": "95", "correct": true },
          { "text": "90", "correct": false },
          { "text": "85", "correct": false }
        ]
      }
    ]
  },
  "countfrom100to150": {
    "slug": "countfrom100to150",
    "title": "Count from 100 to 150",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What comes after 109?",
        "answers": [
          { "text": "110", "correct": true },
          { "text": "111", "correct": false },
          { "text": "100", "correct": false },
          { "text": "120", "correct": false }
        ]
      },
      {
        "question": "Which number is between 119 and 121?",
        "answers": [
          { "text": "120", "correct": true },
          { "text": "122", "correct": false },
          { "text": "118", "correct": false },
          { "text": "130", "correct": false }
        ]
      },
      {
        "question": "What number comes before 130?",
        "answers": [
          { "text": "129", "correct": true },
          { "text": "131", "correct": false },
          { "text": "120", "correct": false },
          { "text": "128", "correct": false }
        ]
      }
    ]
  },
  "countfrom50to100": {
    "slug": "countfrom50to100",
    "title": "Count from 50 to 100",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What number comes after 50?",
        "answers": [
          { "text": "51", "correct": true },
          { "text": "60", "correct": false },
          { "text": "49", "correct": false },
          { "text": "59", "correct": false }
        ]
      },
      {
        "question": "What comes after 59?",
        "answers": [
          { "text": "60", "correct": true },
          { "text": "58", "correct": false },
          { "text": "61", "correct": false },
          { "text": "70", "correct": false }
        ]
      },
      {
        "question": "What number comes before 70?",
        "answers": [
          { "text": "69", "correct": true },
          { "text": "71", "correct": false },
          { "text": "68", "correct": false },
          { "text": "60", "correct": false }
        ]
      }
    ]
  },
  "countriesexplored": {
  "slug": "countriesexplored",
  "title": "Countries Explored",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What was one reason countries explored?",
      "questionImage": "",
      "answers": [
        { "text": "Gold", "correct": true, "image": "" },
        { "text": "Sleep", "correct": false, "image": "" },
        { "text": "Games", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Explorers wanted to spread what?",
      "questionImage": "",
      "answers": [
        { "text": "Religion", "correct": true, "image": "" },
        { "text": "Clothes", "correct": false, "image": "" },
        { "text": "Music", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What was one challenge explorers faced?",
      "questionImage": "",
      "answers": [
        { "text": "Diseases", "correct": true, "image": "" },
        { "text": "Fast travel", "correct": false, "image": "" },
        { "text": "Easy maps", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did explorers exchange with others?",
      "questionImage": "",
      "answers": [
        { "text": "Goods", "correct": true, "image": "" },
        { "text": "Boats", "correct": false, "image": "" },
        { "text": "Sand", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did explorers claim?",
      "questionImage": "",
      "answers": [
        { "text": "Territories", "correct": true, "image": "" },
        { "text": "Stars", "correct": false, "image": "" },
        { "text": "Clouds", "correct": false, "image": "" }
      ]
    }
  ]
},
  "countto50": {
    "slug": "countto50",
    "title": "Count to 50",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What number comes after 19?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "18", "correct": false },
          { "text": "21", "correct": false },
          { "text": "29", "correct": false }
        ]
      },
      {
        "question": "What number comes after 29?",
        "answers": [
          { "text": "30", "correct": true },
          { "text": "28", "correct": false },
          { "text": "31", "correct": false },
          { "text": "39", "correct": false }
        ]
      },
      {
        "question": "What number comes before 40?",
        "answers": [
          { "text": "39", "correct": true },
          { "text": "41", "correct": false },
          { "text": "38", "correct": false },
          { "text": "30", "correct": false }
        ]
      }
    ]
  },
  "cutitequal": {
    "slug": "cutitequal",
    "title": "Cut It Equal",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Cut a rectangle into 2 equal parts. Each part is called a ____.",
        "answers": [
          { "text": "half", "correct": true },
          { "text": "third", "correct": false },
          { "text": "fourth", "correct": false },
          { "text": "whole", "correct": false }
        ]
      },
      {
        "question": "Cut a circle into 4 equal parts. Each part is a ____.",
        "answers": [
          { "text": "fourth (quarter)", "correct": true },
          { "text": "half", "correct": false },
          { "text": "third", "correct": false },
          { "text": "eighth", "correct": false }
        ]
      },
      {
        "question": "Equal parts are also called:",
        "answers": [
          { "text": "fair shares", "correct": true },
          { "text": "random pieces", "correct": false },
          { "text": "tiny bits", "correct": false },
          { "text": "leftovers", "correct": false }
        ]
      }
    ]
  },
  "dependedon": {
  "slug": "dependedon",
  "title": "Depended On",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match New England specialties.",
      "options": [
        { "id": "fishing", "text": "Fishing", "image": "", "targetText": "New England", "targetImage": "" },
        { "id": "shipbuilding", "text": "Shipbuilding", "image": "", "targetText": "New England", "targetImage": "" },
        { "id": "naval", "text": "Naval supplies", "image": "", "targetText": "New England", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match Mid-Atlantic specialties.",
      "options": [
        { "id": "livestock", "text": "Livestock", "image": "", "targetText": "Mid-Atlantic", "targetImage": "" },
        { "id": "fish", "text": "Fish", "image": "", "targetText": "Mid-Atlantic", "targetImage": "" },
        { "id": "grains", "text": "Grains", "image": "", "targetText": "Mid-Atlantic", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match Southern specialties.",
      "options": [
        { "id": "rice", "text": "Rice", "image": "", "targetText": "Southern", "targetImage": "" },
        { "id": "tobacco", "text": "Tobacco", "image": "", "targetText": "Southern", "targetImage": "" },
        { "id": "cotton", "text": "Cotton", "image": "", "targetText": "Southern", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match each colony with what it depended on.",
      "options": [
        { "id": "newenglandtools", "text": "New England", "image": "", "targetText": "Metal tools", "targetImage": "" },
        { "id": "midatlanticgrains", "text": "Mid-Atlantic", "image": "", "targetText": "Grains", "targetImage": "" },
        { "id": "southerntobacco", "text": "Southern", "image": "", "targetText": "Tobacco", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match Southern trade needs.",
      "options": [
        { "id": "southtools", "text": "Southern", "image": "", "targetText": "Equipment", "targetImage": "" },
        { "id": "southgrains", "text": "Southern", "image": "", "targetText": "Grains", "targetImage": "" },
        { "id": "southlivestock", "text": "Southern", "image": "", "targetText": "Livestock", "targetImage": "" }
      ]
    }
  ]
},
  "determineweather": {
  "slug": "determineweather",
  "title": "Determine Weather",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each measurement to what it tells you.",
      "options": [
        { "id": "temp", "text": "Temperature", "image": "", "targetText": "How hot or cold", "targetImage": "" },
        { "id": "precip", "text": "Precipitation", "image": "", "targetText": "Rain or snow", "targetImage": "" },
        { "id": "windspd", "text": "Wind speed", "image": "", "targetText": "How fast wind blows", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match wind words to what they mean.",
      "options": [
        { "id": "wdir", "text": "Wind direction", "image": "", "targetText": "N / S / E / W", "targetImage": "" },
        { "id": "wspd", "text": "Wind speed", "image": "", "targetText": "How fast", "targetImage": "" },
        { "id": "gust", "text": "Gust", "image": "", "targetText": "Sudden strong wind", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each tool to what it measures.",
      "options": [
        { "id": "thermo", "text": "Thermometer", "image": "", "targetText": "Temperature", "targetImage": "" },
        { "id": "baro", "text": "Barometer", "image": "", "targetText": "Air pressure", "targetImage": "" },
        { "id": "raing", "text": "Rain gauge", "image": "", "targetText": "Precipitation", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match humidity words to their ideas.",
      "options": [
        { "id": "humid", "text": "Humidity", "image": "", "targetText": "Water vapor in air", "targetImage": "" },
        { "id": "highhumid", "text": "High humidity", "image": "", "targetText": "Feels sticky", "targetImage": "" },
        { "id": "lowhumid", "text": "Low humidity", "image": "", "targetText": "Feels dry", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each time word to what is tracked over time.",
      "options": [
        { "id": "rainTotal", "text": "Total rainfall", "image": "", "targetText": "Amount over time", "targetImage": "" },
        { "id": "tempTrend", "text": "Temperature trend", "image": "", "targetText": "Change over time", "targetImage": "" },
        { "id": "windAvg", "text": "Average wind", "image": "", "targetText": "Average over time", "targetImage": "" }
      ]
    }
  ]
},
  "dividingdecimals": {
    "slug": "dividingdecimals",
    "title": "Dividing Decimals",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. 0.6 ÷ 2 = ?",
        "answers": [
          { "text": "0.3", "correct": true },
          { "text": "3", "correct": false },
          { "text": "0.12", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 1.2 ÷ 4 = ?",
        "answers": [
          { "text": "0.3", "correct": true },
          { "text": "0.4", "correct": false },
          { "text": "3", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 0.8 ÷ 0.2 = ?",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "0.4", "correct": false },
          { "text": "8", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 2.4 ÷ 0.3 = ?",
        "answers": [
          { "text": "8", "correct": true },
          { "text": "0.8", "correct": false },
          { "text": "6", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 0.9 ÷ 0.3 = ?",
        "answers": [
          { "text": "3", "correct": true },
          { "text": "0.6", "correct": false },
          { "text": "0.03", "correct": false }
        ]
      }
    ]
  },
  "dollarsandcents": {
    "slug": "dollarsandcents",
    "title": "Dollars & Cents",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. How many cents are in one dollar?",
        "answers": [
          { "text": "100", "correct": true },
          { "text": "50", "correct": false },
          { "text": "25", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many nickels make one dollar?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "10", "correct": false },
          { "text": "5", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many dimes are in one dollar?",
        "answers": [
          { "text": "10", "correct": true },
          { "text": "5", "correct": false },
          { "text": "20", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many quarters equal one dollar?",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "10", "correct": false },
          { "text": "2", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which president is on the penny?",
        "answers": [
          { "text": "Abraham Lincoln", "correct": true },
          { "text": "George Washington", "correct": false },
          { "text": "Thomas Jefferson", "correct": false }
        ]
      }
    ]
  },
  "dollarscents": {
    "slug": "dollarscents",
    "title": "Dollars & Cents",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. How many cents are in one dollar?",
        "answers": [
          { "text": "100", "correct": true },
          { "text": "50", "correct": false },
          { "text": "25", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How much is a nickel worth?",
        "answers": [
          { "text": "5 cents", "correct": true },
          { "text": "10 cents", "correct": false },
          { "text": "1 cent", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which president is on the penny?",
        "answers": [
          { "text": "Abraham Lincoln", "correct": true },
          { "text": "George Washington", "correct": false },
          { "text": "Thomas Jefferson", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If you have 4 quarters, how much money do you have?",
        "answers": [
          { "text": "$1.00", "correct": true },
          { "text": "$0.50", "correct": false },
          { "text": "$0.75", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many dimes make one dollar?",
        "answers": [
          { "text": "10", "correct": true },
          { "text": "4", "correct": false },
          { "text": "5", "correct": false }
        ]
      }
    ]
  },
  "drmartinlutherkingjr": {
    "slug": "drmartinlutherkingjr",
    "title": "Dr. Martin Luther King Jr.",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which major award did Dr. Martin Luther King Jr. receive according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Nobel Peace Prize", "correct": true, "image": "" },
          { "text": "Oscar Award", "correct": false, "image": "" },
          { "text": "Grammy Award", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. In what year was Dr. Martin Luther King Jr. born as stated in the lyrics?",
        "questionImage": "",
        "answers": [
          { "text": "1929", "correct": true, "image": "" },
          { "text": "1919", "correct": false, "image": "" },
          { "text": "1940", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the famous speech by Dr. King mentioned in the song?",
        "questionImage": "",
        "answers": [
          { "text": "I Have a Dream", "correct": true, "image": "" },
          { "text": "Four Freedoms", "correct": false, "image": "" },
          { "text": "New Frontier", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What was Dr. King’s job as described in the song?",
        "questionImage": "",
        "answers": [
          { "text": "Minister", "correct": true, "image": "" },
          { "text": "General", "correct": false, "image": "" },
          { "text": "Judge", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What did Dr. Martin Luther King Jr. work to achieve for people?",
        "questionImage": "",
        "answers": [
          { "text": "Equal rights", "correct": true, "image": "" },
          { "text": "More wars", "correct": false, "image": "" },
          { "text": "New taxes", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "earthsrevolution": {
  "slug": "earthsrevolution",
  "title": "Earth’s Revolution",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. One revolution takes how long?",
      "questionImage": "",
      "answers": [
        { "text": "1 year", "correct": true, "image": "" },
        { "text": "1 week", "correct": false, "image": "" },
        { "text": "1 hour", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How many days is that?",
      "questionImage": "",
      "answers": [
        { "text": "365", "correct": true, "image": "" },
        { "text": "24", "correct": false, "image": "" },
        { "text": "30", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Earth goes around the…",
      "questionImage": "",
      "answers": [
        { "text": "Sun", "correct": true, "image": "" },
        { "text": "Moon", "correct": false, "image": "" },
        { "text": "Pole", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Another word for Earth’s path is…",
      "questionImage": "",
      "answers": [
        { "text": "Orbit", "correct": true, "image": "" },
        { "text": "Tunnel", "correct": false, "image": "" },
        { "text": "Bridge", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Revolution means one…",
      "questionImage": "",
      "answers": [
        { "text": "Trip", "correct": true, "image": "" },
        { "text": "Spin", "correct": false, "image": "" },
        { "text": "Jump", "correct": false, "image": "" }
      ]
    }
  ]
},
  "earthsrotation": {
  "slug": "earthsrotation",
  "title": "Earth’s Rotation",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Earth spins on its what?",
      "questionImage": "",
      "answers": [
        { "text": "Axis", "correct": true, "image": "" },
        { "text": "Rail", "correct": false, "image": "" },
        { "text": "Rope", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How long is one full turn of Earth?",
      "questionImage": "",
      "answers": [
        { "text": "24 hours", "correct": true, "image": "" },
        { "text": "24 days", "correct": false, "image": "" },
        { "text": "12 hours", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What makes day and night?",
      "questionImage": "",
      "answers": [
        { "text": "Rotation", "correct": true, "image": "" },
        { "text": "Revolution", "correct": false, "image": "" },
        { "text": "Eclipse", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why do stars seem to move across the sky?",
      "questionImage": "",
      "answers": [
        { "text": "Earth turns", "correct": true, "image": "" },
        { "text": "Stars walk", "correct": false, "image": "" },
        { "text": "Sky spins", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The Sun seems to rise in the…",
      "questionImage": "",
      "answers": [
        { "text": "East", "correct": true, "image": "" },
        { "text": "West", "correct": false, "image": "" },
        { "text": "North", "correct": false, "image": "" }
      ]
    }
  ]
},
  "ecoenergyflow": {
    "slug": "ecoenergyflow",
    "title": "Eco Energy Flow",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Where does energy in most food chains start?",
        "questionImage": "",
        "answers": [
          { "text": "Sun", "correct": true, "image": "" },
          { "text": "Moon", "correct": false, "image": "" },
          { "text": "Stars", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Who makes food using sunlight?",
        "questionImage": "",
        "answers": [
          { "text": "Plants", "correct": true, "image": "" },
          { "text": "Animals", "correct": false, "image": "" },
          { "text": "Rocks", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What happens to most energy in a plant?",
        "questionImage": "",
        "answers": [
          { "text": "Used for life", "correct": true, "image": "" },
          { "text": "Saved forever", "correct": false, "image": "" },
          { "text": "Wasted fully", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Animals at the top of a chain need…",
        "questionImage": "",
        "answers": [
          { "text": "More food", "correct": true, "image": "" },
          { "text": "Less food", "correct": false, "image": "" },
          { "text": "No food", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. At each step, much energy is lost as…",
        "questionImage": "",
        "answers": [
          { "text": "Heat", "correct": true, "image": "" },
          { "text": "Ice", "correct": false, "image": "" },
          { "text": "Gold", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "ecosystemlevels": {
    "slug": "ecosystemlevels",
    "title": "Ecosystem Levels",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is the first level of an ecosystem?",
        "questionImage": "",
        "answers": [
          { "text": "Organism", "correct": true, "image": "" },
          { "text": "Population", "correct": false, "image": "" },
          { "text": "Community", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When organisms have young, they make a…",
        "questionImage": "",
        "answers": [
          { "text": "Population", "correct": true, "image": "" },
          { "text": "Ecosystem", "correct": false, "image": "" },
          { "text": "Mountain", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Different organisms together form a…",
        "questionImage": "",
        "answers": [
          { "text": "Community", "correct": true, "image": "" },
          { "text": "Rock", "correct": false, "image": "" },
          { "text": "Planet", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Living and nonliving things together form an…",
        "questionImage": "",
        "answers": [
          { "text": "Ecosystem", "correct": true, "image": "" },
          { "text": "Cloud", "correct": false, "image": "" },
          { "text": "River", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which level comes after organism?",
        "questionImage": "",
        "answers": [
          { "text": "Population", "correct": true, "image": "" },
          { "text": "Volcano", "correct": false, "image": "" },
          { "text": "Mountain", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "ecosystemsallaround": {
  "slug": "ecosystemsallaround",
  "title": "Ecosystems All Around",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which animal is common in grasslands?",
      "questionImage": "",
      "answers": [
        { "text": "Bison", "correct": true, "image": "" },
        { "text": "Penguins", "correct": false, "image": "" },
        { "text": "Sharks", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which plant is common in the ocean?",
      "questionImage": "",
      "answers": [
        { "text": "Seaweed", "correct": true, "image": "" },
        { "text": "Cactus", "correct": false, "image": "" },
        { "text": "Oak", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which animal is common in ponds and lakes?",
      "questionImage": "",
      "answers": [
        { "text": "Frogs", "correct": true, "image": "" },
        { "text": "Camels", "correct": false, "image": "" },
        { "text": "Tigers", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which feature is typical of a forest?",
      "questionImage": "",
      "answers": [
        { "text": "Trees", "correct": true, "image": "" },
        { "text": "Coral", "correct": false, "image": "" },
        { "text": "Icebergs", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What does “biotic” mean in an ecosystem?",
      "questionImage": "",
      "answers": [
        { "text": "Living", "correct": true, "image": "" },
        { "text": "Nonliving", "correct": false, "image": "" },
        { "text": "Windy", "correct": false, "image": "" }
      ]
    }
  ]
},
  "elapsedtime": {
    "slug": "elapsedtime",
    "title": "Elapsed Time",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. School starts at 8:00 AM and ends at 3:00 PM. How much time has passed?",
        "answers": [
          { "text": "7 hours", "correct": true },
          { "text": "6 hours", "correct": false },
          { "text": "8 hours", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. A movie begins at 2:30 PM and ends at 4:00 PM. How long is the movie?",
        "answers": [
          { "text": "1 hour 30 minutes", "correct": true },
          { "text": "1 hour", "correct": false },
          { "text": "2 hours", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. A bus leaves at 9:15 AM and arrives at 10:45 AM. What is the elapsed time?",
        "answers": [
          { "text": "1 hour 30 minutes", "correct": true },
          { "text": "1 hour 15 minutes", "correct": false },
          { "text": "2 hours", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If dinner starts at 5:45 PM and ends at 6:30 PM, how much time passed?",
        "answers": [
          { "text": "45 minutes", "correct": true },
          { "text": "30 minutes", "correct": false },
          { "text": "1 hour", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. You start homework at 6:10 PM and finish at 7:25 PM. How long did it take?",
        "answers": [
          { "text": "1 hour 15 minutes", "correct": true },
          { "text": "1 hour", "correct": false },
          { "text": "1 hour 30 minutes", "correct": false }
        ]
      }
    ]
  },
  "energy": {
  "slug": "energy",
  "title": "Energy",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Kinetic energy is?",
      "questionImage": "",
      "answers": [
        { "text": "In motion", "correct": true, "image": "" },
        { "text": "Stored up", "correct": false, "image": "" },
        { "text": "Silent", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Potential energy is?",
      "questionImage": "",
      "answers": [
        { "text": "Stored", "correct": true, "image": "" },
        { "text": "Moving", "correct": false, "image": "" },
        { "text": "Melting", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Heat, motion, sound, light are?",
      "questionImage": "",
      "answers": [
        { "text": "Forms", "correct": true, "image": "" },
        { "text": "Plants", "correct": false, "image": "" },
        { "text": "Minerals", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Electrical, thermal, chemical, nuclear are?",
      "questionImage": "",
      "answers": [
        { "text": "Energies", "correct": true, "image": "" },
        { "text": "Weathers", "correct": false, "image": "" },
        { "text": "Rocks", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Both groups fit into two?",
      "questionImage": "",
      "answers": [
        { "text": "Categories", "correct": true, "image": "" },
        { "text": "Colors", "correct": false, "image": "" },
        { "text": "Seasons", "correct": false, "image": "" }
      ]
    }
  ]
},
  "energytransfer": {
  "slug": "energytransfer",
  "title": "Energy Transfer",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Solar panels change light to?",
      "questionImage": "",
      "answers": [
        { "text": "Electrical", "correct": true, "image": "" },
        { "text": "Sound", "correct": false, "image": "" },
        { "text": "Motion", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. A TV turns electrical into?",
      "questionImage": "",
      "answers": [
        { "text": "Light", "correct": true, "image": "" },
        { "text": "Fuel", "correct": false, "image": "" },
        { "text": "Friction", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Fuel in cars has what energy?",
      "questionImage": "",
      "answers": [
        { "text": "Chemical", "correct": true, "image": "" },
        { "text": "Magnetic", "correct": false, "image": "" },
        { "text": "Solar", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Batteries in flashlights change to?",
      "questionImage": "",
      "answers": [
        { "text": "Light", "correct": true, "image": "" },
        { "text": "Wind", "correct": false, "image": "" },
        { "text": "Tide", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Burning wood becomes?",
      "questionImage": "",
      "answers": [
        { "text": "Thermal", "correct": true, "image": "" },
        { "text": "Nuclear", "correct": false, "image": "" },
        { "text": "Electric", "correct": false, "image": "" }
      ]
    }
  ]
},
  "englishruler": {
  "slug": "englishruler",
  "title": "English Ruler",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. How many inches are in one foot?",
      "answers": [
        { "text": "12", "correct": true },
        { "text": "10", "correct": false },
        { "text": "16", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. On a ruler, what does each number represent?",
      "answers": [
        { "text": "One inch", "correct": true },
        { "text": "One foot", "correct": false },
        { "text": "One centimeter", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is the notch halfway between two inches called?",
      "answers": [
        { "text": "1/2 inch", "correct": true },
        { "text": "1/4 inch", "correct": false },
        { "text": "1/8 inch", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which notch is smaller than 1/4 inch but larger than 1/16 inch?",
      "answers": [
        { "text": "1/8 inch", "correct": true },
        { "text": "1/2 inch", "correct": false },
        { "text": "1 inch", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is the smallest marking on a ruler usually called?",
      "answers": [
        { "text": "1/16 inch", "correct": true },
        { "text": "1/8 inch", "correct": false },
        { "text": "1/2 inch", "correct": false }
      ]
    }
  ]
},
  "environmentalchange": {
  "slug": "environmentalchange",
  "title": "Environmental Change",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. When organisms adapt, what do they do to survive changes?",
      "questionImage": "",
      "answers": [
        { "text": "They change", "correct": true, "image": "" },
        { "text": "They quit", "correct": false, "image": "" },
        { "text": "They hide", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is it called when animals move to a new place to survive?",
      "questionImage": "",
      "answers": [
        { "text": "Migrate", "correct": true, "image": "" },
        { "text": "Hibernate", "correct": false, "image": "" },
        { "text": "Celebrate", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is it called when a kind of organism dies out and no longer exists?",
      "questionImage": "",
      "answers": [
        { "text": "Extinction", "correct": true, "image": "" },
        { "text": "Invention", "correct": false, "image": "" },
        { "text": "Prediction", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What can help some organisms survive better when the environment changes?",
      "questionImage": "",
      "answers": [
        { "text": "Useful traits", "correct": true, "image": "" },
        { "text": "Pretty colors only", "correct": false, "image": "" },
        { "text": "Songs", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which organisms are most likely to do well during changes?",
      "questionImage": "",
      "answers": [
        { "text": "Resilient ones", "correct": true, "image": "" },
        { "text": "Random ones", "correct": false, "image": "" },
        { "text": "Absent ones", "correct": false, "image": "" }
      ]
    }
  ]
},
  "equalrights": {
    "slug": "equalrights",
    "title": "Equal Rights",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each leader to the cause they are known for in the song.",
        "options": [
          { "id": "sba", "text": "Susan B. Anthony", "image": "", "targetText": "Women's voting rights", "targetImage": "" },
          { "id": "jr", "text": "Jackie Robinson", "image": "", "targetText": "First in Major League Baseball", "targetImage": "" },
          { "id": "mlk", "text": "Martin Luther King Jr.", "image": "", "targetText": "Civil rights leader", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each person to their civil rights role from the verse.",
        "options": [
          { "id": "tm", "text": "Thurgood Marshall", "image": "", "targetText": "Supreme Court Justice", "targetImage": "" },
          { "id": "rp", "text": "Rosa Parks", "image": "", "targetText": "Refused to give up her seat", "targetImage": "" },
          { "id": "sba2", "text": "Susan B. Anthony", "image": "", "targetText": "Fought for equal rights", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each person to the protest or change they helped inspire.",
        "options": [
          { "id": "rp2", "text": "Rosa Parks", "image": "", "targetText": "Bus boycott", "targetImage": "" },
          { "id": "mlk2", "text": "Martin Luther King Jr.", "image": "", "targetText": "Peaceful marches", "targetImage": "" },
          { "id": "jr2", "text": "Jackie Robinson", "image": "", "targetText": "Sports equality", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each name to the job title connected to them in the lyrics.",
        "options": [
          { "id": "mlk_job", "text": "Martin Luther King Jr.", "image": "", "targetText": "Minister", "targetImage": "" },
          { "id": "tm_job", "text": "Thurgood Marshall", "image": "", "targetText": "Justice", "targetImage": "" },
          { "id": "jr_job", "text": "Jackie Robinson", "image": "", "targetText": "Athlete", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each person to the field where they first broke a barrier.",
        "options": [
          { "id": "sba_field", "text": "Susan B. Anthony", "image": "", "targetText": "Voting rights", "targetImage": "" },
          { "id": "jr_field", "text": "Jackie Robinson", "image": "", "targetText": "Baseball", "targetImage": "" },
          { "id": "tm_field", "text": "Thurgood Marshall", "image": "", "targetText": "Law and courts", "targetImage": "" }
        ]
      }
    ]
  },
  "europe-features": {
  "slug": "europe-features",
  "title": "Europe Features",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which sea is important for trade in Europe?",
      "questionImage": "",
      "answers": [
        { "text": "Mediterranean Sea", "correct": true, "image": "" },
        { "text": "Baltic Sea", "correct": false, "image": "" },
        { "text": "North Sea", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What are the Alps?",
      "questionImage": "",
      "answers": [
        { "text": "Tall and wide mountains in Europe", "correct": true, "image": "" },
        { "text": "The longest river in Europe", "correct": false, "image": "" },
        { "text": "A desert in Europe", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which river is the longest in Europe?",
      "questionImage": "",
      "answers": [
        { "text": "Volga River", "correct": true, "image": "" },
        { "text": "Danube River", "correct": false, "image": "" },
        { "text": "Rhine River", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which river flows through many countries in Europe?",
      "questionImage": "",
      "answers": [
        { "text": "Danube River", "correct": true, "image": "" },
        { "text": "Volga River", "correct": false, "image": "" },
        { "text": "Thames River", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What kind of landform makes up most of Northern Europe?",
      "questionImage": "",
      "answers": [
        { "text": "Plains", "correct": true, "image": "" },
        { "text": "Deserts", "correct": false, "image": "" },
        { "text": "Canyons", "correct": false, "image": "" }
      ]
    }
  ]
},
  "expressions": {
  "slug": "expressions",
  "title": "Expressions",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which of these is a numerical expression?",
      "answers": [
        { "text": "8 + 4", "correct": true },
        { "text": "x + 5 = 9", "correct": false },
        { "text": "y + 3", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which of these is an algebraic expression?",
      "answers": [
        { "text": "5 + c", "correct": true },
        { "text": "5 + 2", "correct": false },
        { "text": "7 = 7", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is the value of 3 × a when a = 4?",
      "answers": [
        { "text": "12", "correct": true },
        { "text": "7", "correct": false },
        { "text": "9", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is the value of 10 - b when b = 6?",
      "answers": [
        { "text": "4", "correct": true },
        { "text": "16", "correct": false },
        { "text": "6", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which statement about expressions is true?",
      "answers": [
        { "text": "Expressions do not have equal signs.", "correct": true },
        { "text": "Expressions always have equal signs.", "correct": false },
        { "text": "Expressions only use letters.", "correct": false }
      ]
    }
  ]
},
  "firstfive": {
  "slug": "firstfive",
  "title": "First Five",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from Row A and drop it on the item in Row B that matches. Match president to order.",
      "options": [
        { "id": "washington_ord", "text": "Washington", "image": "", "targetText": "1st", "targetImage": "" },
        { "id": "adams_ord", "text": "Adams", "image": "", "targetText": "2nd", "targetImage": "" },
        { "id": "jefferson_ord", "text": "Jefferson", "image": "", "targetText": "3rd", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from Row A and drop it on the item in Row B that matches. Match event to president.",
      "options": [
        { "id": "washington_bor", "text": "Washington", "image": "", "targetText": "Bill of Rights", "targetImage": "" },
        { "id": "adams_parties", "text": "Adams", "image": "", "targetText": "Two parties", "targetImage": "" },
        { "id": "jefferson_lp", "text": "Jefferson", "image": "", "targetText": "Louisiana Purchase", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from Row A and drop it on the item in Row B that matches. Match exploration or policy.",
      "options": [
        { "id": "jefferson_lc", "text": "Jefferson", "image": "", "targetText": "Lewis & Clark", "targetImage": "" },
        { "id": "madison_war", "text": "Madison", "image": "", "targetText": "War of 1812", "targetImage": "" },
        { "id": "monroe_doc", "text": "Monroe", "image": "", "targetText": "Monroe Doctrine", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from Row A and drop it on the item in Row B that matches. Match president to order (later).",
      "options": [
        { "id": "madison_ord", "text": "Madison", "image": "", "targetText": "4th", "targetImage": "" },
        { "id": "monroe_ord", "text": "Monroe", "image": "", "targetText": "5th", "targetImage": "" },
        { "id": "adams_ord2", "text": "Adams", "image": "", "targetText": "2nd", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from Row A and drop it on the item in Row B that matches. Match summary fact.",
      "options": [
        { "id": "farm_lc", "text": "Jefferson", "image": "", "targetText": "New lands", "targetImage": "" },
        { "id": "lead_bor", "text": "Washington", "image": "", "targetText": "Bill added", "targetImage": "" },
        { "id": "policy_md", "text": "Monroe", "image": "", "targetText": "Doctrine", "targetImage": "" }
      ]
    }
  ]
},
  "fiveregions": {
  "slug": "fiveregions",
  "title": "5 Regions",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Coastal Plain to its description.",
      "options": [
        { "id": "coastal", "text": "Coastal Plain", "image": "", "targetText": "Flat land", "targetImage": "" },
        { "id": "tidewater", "text": "Tidewater", "image": "", "targetText": "Flat land", "targetImage": "" },
        { "id": "piedmont", "text": "Piedmont", "image": "", "targetText": "Rolling hills", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match mountain regions to their traits.",
      "options": [
        { "id": "blueridge", "text": "Blue Ridge", "image": "", "targetText": "Rounded mountains", "targetImage": "" },
        { "id": "valley", "text": "Valley & Ridge", "image": "", "targetText": "Valleys", "targetImage": "" },
        { "id": "plateau", "text": "Plateau", "image": "", "targetText": "Highlands", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each region to its feature.",
      "options": [
        { "id": "piedmont2", "text": "Piedmont", "image": "", "targetText": "Rolling hills", "targetImage": "" },
        { "id": "blueridge2", "text": "Blue Ridge", "image": "", "targetText": "Appalachians", "targetImage": "" },
        { "id": "coastal2", "text": "Coastal Plain", "image": "", "targetText": "Flat land", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match regions with geography.",
      "options": [
        { "id": "valley2", "text": "Valley & Ridge", "image": "", "targetText": "Valleys", "targetImage": "" },
        { "id": "plateau2", "text": "Plateau", "image": "", "targetText": "Highlands", "targetImage": "" },
        { "id": "piedmont3", "text": "Piedmont", "image": "", "targetText": "Hills", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Blue Ridge, Plateau, and Coastal Plain.",
      "options": [
        { "id": "blueridge3", "text": "Blue Ridge", "image": "", "targetText": "Rounded", "targetImage": "" },
        { "id": "plateau3", "text": "Plateau", "image": "", "targetText": "Highlands", "targetImage": "" },
        { "id": "coastal3", "text": "Coastal Plain", "image": "", "targetText": "Low flat", "targetImage": "" }
      ]
    }
  ]
},
  "foodchain": {
    "slug": "foodchain",
    "title": "Food Chain",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What starts a food chain?",
        "questionImage": "",
        "answers": [
          { "text": "Producers", "correct": true, "image": "" },
          { "text": "Snakes", "correct": false, "image": "" },
          { "text": "Owls", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Grass is eaten by…",
        "questionImage": "",
        "answers": [
          { "text": "Grasshoppers", "correct": true, "image": "" },
          { "text": "Frogs", "correct": false, "image": "" },
          { "text": "Hawks", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What eats the grasshopper?",
        "questionImage": "",
        "answers": [
          { "text": "Frog", "correct": true, "image": "" },
          { "text": "Snake", "correct": false, "image": "" },
          { "text": "Hawk", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What eats the frog?",
        "questionImage": "",
        "answers": [
          { "text": "Snake", "correct": true, "image": "" },
          { "text": "Grass", "correct": false, "image": "" },
          { "text": "Producer", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What eats the snake?",
        "questionImage": "",
        "answers": [
          { "text": "Hawk", "correct": true, "image": "" },
          { "text": "Grasshopper", "correct": false, "image": "" },
          { "text": "Frog", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "foodweb": {
    "slug": "foodweb",
    "title": "Food Web",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each organism to who eats it.",
        "options": [
          { "id": "mice", "text": "Mice", "image": "", "targetText": "Snakes & owls", "targetImage": "" },
          { "id": "bugs", "text": "Bugs", "image": "", "targetText": "Birds & skunks", "targetImage": "" },
          { "id": "rabbits", "text": "Rabbits", "image": "", "targetText": "Foxes", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match producers to what they give.",
        "options": [
          { "id": "trees", "text": "Trees", "image": "", "targetText": "Acorns", "targetImage": "" },
          { "id": "plants", "text": "Plants", "image": "", "targetText": "Food for animals", "targetImage": "" },
          { "id": "grass", "text": "Grass", "image": "", "targetText": "Food for rabbits", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each eater to its food.",
        "options": [
          { "id": "owl", "text": "Owl", "image": "", "targetText": "Eats mice", "targetImage": "" },
          { "id": "snake", "text": "Snake", "image": "", "targetText": "Eats frogs/mice", "targetImage": "" },
          { "id": "bird", "text": "Bird", "image": "", "targetText": "Eats bugs", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Put web roles with their names.",
        "options": [
          { "id": "producer", "text": "Producer", "image": "", "targetText": "Makes food", "targetImage": "" },
          { "id": "consumer", "text": "Consumer", "image": "", "targetText": "Eats food", "targetImage": "" },
          { "id": "predator", "text": "Predator", "image": "", "targetText": "Hunts other animals", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each food chain step.",
        "options": [
          { "id": "acorn", "text": "Acorn", "image": "", "targetText": "Food for mice", "targetImage": "" },
          { "id": "mouse", "text": "Mouse", "image": "", "targetText": "Food for owl", "targetImage": "" },
          { "id": "owl2", "text": "Owl", "image": "", "targetText": "Top hunter", "targetImage": "" }
        ]
      }
    ]
  },
  "force": {
    "slug": "force",
    "title": "Force",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each force word to what it does.",
        "options": [
          { "id": "push", "text": "Push", "image": "", "targetText": "Moves away from you", "targetImage": "" },
          { "id": "pull", "text": "Pull", "image": "", "targetText": "Moves toward you", "targetImage": "" },
          { "id": "twist", "text": "Twist", "image": "", "targetText": "Turns an object", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each motion change with the effect of a force.",
        "options": [
          { "id": "speedup", "text": "Speed up", "image": "", "targetText": "Goes faster", "targetImage": "" },
          { "id": "slowdown", "text": "Slow down", "image": "", "targetText": "Goes slower", "targetImage": "" },
          { "id": "turn", "text": "Change direction", "image": "", "targetText": "Turns left or right", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each action to the type of force.",
        "options": [
          { "id": "hammer", "text": "Hammer a nail", "image": "", "targetText": "Push", "targetImage": "" },
          { "id": "rope", "text": "Pull a rope", "image": "", "targetText": "Pull", "targetImage": "" },
          { "id": "knob", "text": "Turn a doorknob", "image": "", "targetText": "Twist", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match words to describe a force.",
        "options": [
          { "id": "push2", "text": "Push", "image": "", "targetText": "A force", "targetImage": "" },
          { "id": "pull2", "text": "Pull", "image": "", "targetText": "A force", "targetImage": "" },
          { "id": "kick", "text": "Kick", "image": "", "targetText": "A force", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match the picture idea to the motion it shows.",
        "options": [
          { "id": "start", "text": "Start moving", "image": "", "targetText": "Force makes it go", "targetImage": "" },
          { "id": "stop", "text": "Stop moving", "image": "", "targetText": "Force makes it stop", "targetImage": "" },
          { "id": "redirect", "text": "Turn a corner", "image": "", "targetText": "Force changes direction", "targetImage": "" }
        ]
      }
    ]
  },
  "formsofenergy": {
  "slug": "formsofenergy",
  "title": "Forms of Energy",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Where is chemical energy stored?",
      "questionImage": "",
      "answers": [
        { "text": "Bonds", "correct": true, "image": "" },
        { "text": "Wheels", "correct": false, "image": "" },
        { "text": "Clouds", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What stores mechanical energy?",
      "questionImage": "",
      "answers": [
        { "text": "Springs", "correct": true, "image": "" },
        { "text": "Paint", "correct": false, "image": "" },
        { "text": "Sand", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where is nuclear energy stored?",
      "questionImage": "",
      "answers": [
        { "text": "Nucleus", "correct": true, "image": "" },
        { "text": "Orbit", "correct": false, "image": "" },
        { "text": "Crust", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What stores electrical energy?",
      "questionImage": "",
      "answers": [
        { "text": "Battery", "correct": true, "image": "" },
        { "text": "Leaf", "correct": false, "image": "" },
        { "text": "Brick", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Light, X-rays, radio waves are?",
      "questionImage": "",
      "answers": [
        { "text": "Radiant", "correct": true, "image": "" },
        { "text": "Solid", "correct": false, "image": "" },
        { "text": "Liquid", "correct": false, "image": "" }
      ]
    }
  ]
},
  "formsofwater": {
    "slug": "formsofwater",
    "title": "Forms of Water",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each term to its meaning (set 1).",
        "options": [
          { "id": "reservoir1", "text": "Reservoir", "image": "", "targetText": "Stores water", "targetImage": "" },
          { "id": "groundwater1", "text": "Groundwater", "image": "", "targetText": "Beneath surface", "targetImage": "" },
          { "id": "river1", "text": "River", "image": "", "targetText": "Moving stream", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each term to its meaning (set 2).",
        "options": [
          { "id": "lake1", "text": "Lake", "image": "", "targetText": "Land-surrounded", "targetImage": "" },
          { "id": "bay1", "text": "Bay", "image": "", "targetText": "Partly enclosed", "targetImage": "" },
          { "id": "peninsula1", "text": "Peninsula", "image": "", "targetText": "3 sides water", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match place to location type.",
        "options": [
          { "id": "groundwater2", "text": "Groundwater", "image": "", "targetText": "Underground", "targetImage": "" },
          { "id": "lake2", "text": "Lake", "image": "", "targetText": "Inland water", "targetImage": "" },
          { "id": "bay2", "text": "Bay", "image": "", "targetText": "Coast", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match item to a key idea.",
        "options": [
          { "id": "reservoir2", "text": "Reservoir", "image": "", "targetText": "Collect/store", "targetImage": "" },
          { "id": "river2", "text": "River", "image": "", "targetText": "Flows/moves", "targetImage": "" },
          { "id": "peninsula2", "text": "Peninsula", "image": "", "targetText": "Mostly land", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each to category.",
        "options": [
          { "id": "lake3", "text": "Lake", "image": "", "targetText": "Water body", "targetImage": "" },
          { "id": "bay3", "text": "Bay", "image": "", "targetText": "Water body", "targetImage": "" },
          { "id": "peninsula3", "text": "Peninsula", "image": "", "targetText": "Landform", "targetImage": "" }
        ]
      }
    ]
  },
  "fossilfuels": {
  "slug": "fossilfuels",
  "title": "Fossil Fuels",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What are coal, oil, and natural gas made from over long time?",
      "questionImage": "",
      "answers": [
        { "text": "Old plants/animals", "correct": true, "image": "" },
        { "text": "Fresh rainwater", "correct": false, "image": "" },
        { "text": "New plastic", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How long did fossil fuels take to form?",
      "questionImage": "",
      "answers": [
        { "text": "Millions of years", "correct": true, "image": "" },
        { "text": "One day", "correct": false, "image": "" },
        { "text": "One week", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why are fossil fuels nonrenewable?",
      "questionImage": "",
      "answers": [
        { "text": "They form very slowly", "correct": true, "image": "" },
        { "text": "They are sunlight", "correct": false, "image": "" },
        { "text": "They are recycled daily", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which list shows only fossil fuels?",
      "questionImage": "",
      "answers": [
        { "text": "Coal, oil, gas", "correct": true, "image": "" },
        { "text": "Sun, wind, rain", "correct": false, "image": "" },
        { "text": "Copper, tin, gold", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What do people mainly use fossil fuels for?",
      "questionImage": "",
      "answers": [
        { "text": "Energy", "correct": true, "image": "" },
        { "text": "Art", "correct": false, "image": "" },
        { "text": "Snacks", "correct": false, "image": "" }
      ]
    }
  ]
},
  "fossils": {
    "slug": "fossils",
    "title": "Fossils",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Fossils tell us about…",
        "questionImage": "",
        "answers": [
          { "text": "The past", "correct": true, "image": "" },
          { "text": "The future", "correct": false, "image": "" },
          { "text": "Today’s weather", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Fossils form mostly in…",
        "questionImage": "",
        "answers": [
          { "text": "Rock layers", "correct": true, "image": "" },
          { "text": "Clouds", "correct": false, "image": "" },
          { "text": "Fire", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Fossils can be from…",
        "questionImage": "",
        "answers": [
          { "text": "Plants or animals", "correct": true, "image": "" },
          { "text": "Plastic toys", "correct": false, "image": "" },
          { "text": "Metal cans", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What can uncover fossils over time?",
        "questionImage": "",
        "answers": [
          { "text": "Wind and rain", "correct": true, "image": "" },
          { "text": "TV waves", "correct": false, "image": "" },
          { "text": "Music", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Fossils are found…",
        "questionImage": "",
        "answers": [
          { "text": "Underground", "correct": true, "image": "" },
          { "text": "In the sky", "correct": false, "image": "" },
          { "text": "On the Moon", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "founders": {
    "slug": "founders",
    "title": "Founders",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each leader to what they are best known for.",
        "options": [
          { "id": "washington", "text": "George Washington", "image": "", "targetText": "First President", "targetImage": "" },
          { "id": "jefferson", "text": "Thomas Jefferson", "image": "", "targetText": "Wrote Declaration", "targetImage": "" },
          { "id": "lincoln", "text": "Abraham Lincoln", "image": "", "targetText": "Ended Slavery", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each person to something they helped create or lead.",
        "options": [
          { "id": "jefferson_vsrf", "text": "Thomas Jefferson", "image": "", "targetText": "VA Statute for Religious Freedom", "targetImage": "" },
          { "id": "wash_father", "text": "George Washington", "image": "", "targetText": "Father of Our Country", "targetImage": "" },
          { "id": "lincoln_union", "text": "Abraham Lincoln", "image": "", "targetText": "Kept Union Together", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each leader to the time or event they are remembered for.",
        "options": [
          { "id": "wash_revolution", "text": "George Washington", "image": "", "targetText": "Revolutionary War", "targetImage": "" },
          { "id": "jeff_founding", "text": "Thomas Jefferson", "image": "", "targetText": "Founding Era", "targetImage": "" },
          { "id": "lincoln_civil", "text": "Abraham Lincoln", "image": "", "targetText": "Civil War", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each leader to where they served.",
        "options": [
          { "id": "wash_capital", "text": "George Washington", "image": "", "targetText": "Led from the Capital", "targetImage": "" },
          { "id": "jeff_monticello", "text": "Thomas Jefferson", "image": "", "targetText": "Lived at Monticello", "targetImage": "" },
          { "id": "lincoln_whitehouse", "text": "Abraham Lincoln", "image": "", "targetText": "Lived in the White House", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each leader to the symbol or idea connected with them.",
        "options": [
          { "id": "wash_flag", "text": "George Washington", "image": "", "targetText": "American Flag", "targetImage": "" },
          { "id": "jeff_liberty", "text": "Thomas Jefferson", "image": "", "targetText": "Liberty", "targetImage": "" },
          { "id": "lincoln_freedom", "text": "Abraham Lincoln", "image": "", "targetText": "Freedom", "targetImage": "" }
        ]
      }
    ]
  },
  "fractiondefinitions": {
    "slug": "fractiondefinitions",
    "title": "Fraction Definitions",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is a fraction?",
        "answers": [
          { "text": "A part of a whole", "correct": true },
          { "text": "A whole number", "correct": false },
          { "text": "A type of shape", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does the denominator tell us?",
        "answers": [
          { "text": "How many parts the whole is divided into", "correct": true },
          { "text": "How many parts we have", "correct": false },
          { "text": "The size of the parts", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does the numerator tell us?",
        "answers": [
          { "text": "How many parts we have", "correct": true },
          { "text": "How many parts make the whole", "correct": false },
          { "text": "The size of each part", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which number is on the top of a fraction?",
        "answers": [
          { "text": "Numerator", "correct": true },
          { "text": "Denominator", "correct": false },
          { "text": "Whole number", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which number is on the bottom of a fraction?",
        "answers": [
          { "text": "Denominator", "correct": true },
          { "text": "Numerator", "correct": false },
          { "text": "Equal sign", "correct": false }
        ]
      }
    ]
  },
  "fractionstodecimals": {
    "slug": "fractionstodecimals",
    "title": "Fractions to Decimals",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. 1/2 as a decimal equals?",
        "answers": [
          { "text": "0.5", "correct": true },
          { "text": "0.2", "correct": false },
          { "text": "0.8", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 1/4 as a decimal equals?",
        "answers": [
          { "text": "0.25", "correct": true },
          { "text": "0.75", "correct": false },
          { "text": "0.4", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 3/4 as a decimal equals?",
        "answers": [
          { "text": "0.75", "correct": true },
          { "text": "0.25", "correct": false },
          { "text": "0.5", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 1/5 as a decimal equals?",
        "answers": [
          { "text": "0.2", "correct": true },
          { "text": "0.5", "correct": false },
          { "text": "0.25", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 2/5 as a decimal equals?",
        "answers": [
          { "text": "0.4", "correct": true },
          { "text": "0.8", "correct": false },
          { "text": "0.25", "correct": false }
        ]
      }
    ]
  },
  "friction": {
  "slug": "friction",
  "title": "Friction",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Friction is the ______ to motion.",
      "questionImage": "",
      "answers": [
        { "text": "Resistance", "correct": true, "image": "" },
        { "text": "Fuel", "correct": false, "image": "" },
        { "text": "Shadow", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Friction happens when objects?",
      "questionImage": "",
      "answers": [
        { "text": "Rub", "correct": true, "image": "" },
        { "text": "Freeze", "correct": false, "image": "" },
        { "text": "Float", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Friction makes?",
      "questionImage": "",
      "answers": [
        { "text": "Heat", "correct": true, "image": "" },
        { "text": "Light", "correct": false, "image": "" },
        { "text": "Snow", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Rubbing hands causes?",
      "questionImage": "",
      "answers": [
        { "text": "Friction", "correct": true, "image": "" },
        { "text": "Rust", "correct": false, "image": "" },
        { "text": "Steam", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Friction is made by objects moving?",
      "questionImage": "",
      "answers": [
        { "text": "Against", "correct": true, "image": "" },
        { "text": "Alone", "correct": false, "image": "" },
        { "text": "Apart", "correct": false, "image": "" }
      ]
    }
  ]
},
  "fromthesun": {
    "slug": "fromthesun",
    "title": "From the Sun",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What does the sun give the Earth?",
        "answers": [
          { "text": "Energy", "correct": true },
          { "text": "Toys", "correct": false },
          { "text": "Cars", "correct": false },
          { "text": "Clothes", "correct": false }
        ]
      },
      {
        "question": "What happens when the sun heats water?",
        "answers": [
          { "text": "It turns into gas (evaporation)", "correct": true },
          { "text": "It turns into ice", "correct": false },
          { "text": "It makes food", "correct": false },
          { "text": "It glows in the dark", "correct": false }
        ]
      },
      {
        "question": "What do clouds form from?",
        "answers": [
          { "text": "Water vapor", "correct": true },
          { "text": "Sand", "correct": false },
          { "text": "Rocks", "correct": false },
          { "text": "Metal", "correct": false }
        ]
      },
      {
        "question": "What comes down from clouds?",
        "answers": [
          { "text": "Rain, snow, or hail", "correct": true },
          { "text": "Shoes", "correct": false },
          { "text": "Candy", "correct": false },
          { "text": "Fireworks", "correct": false }
        ]
      },
      {
        "question": "What makes the water cycle go?",
        "answers": [
          { "text": "The sun’s energy", "correct": true },
          { "text": "Cars", "correct": false },
          { "text": "Computers", "correct": false },
          { "text": "Windmills", "correct": false }
        ]
      }
    ]
  },
  "gbandthecolonies": {
  "slug": "gbandthecolonies",
  "title": "Great Britain and The Colonies",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Who controlled trade in the colonies?",
      "questionImage": "",
      "answers": [
        { "text": "Great Britain", "correct": true, "image": "" },
        { "text": "France", "correct": false, "image": "" },
        { "text": "Spain", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did Great Britain trade for raw materials?",
      "questionImage": "",
      "answers": [
        { "text": "Goods", "correct": true, "image": "" },
        { "text": "Sand", "correct": false, "image": "" },
        { "text": "Ice", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did Great Britain add to the colonies?",
      "questionImage": "",
      "answers": [
        { "text": "Taxes", "correct": true, "image": "" },
        { "text": "Freedom", "correct": false, "image": "" },
        { "text": "Gold", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who enforced the laws?",
      "questionImage": "",
      "answers": [
        { "text": "Governors", "correct": true, "image": "" },
        { "text": "Farmers", "correct": false, "image": "" },
        { "text": "Teachers", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who appointed the governors?",
      "questionImage": "",
      "answers": [
        { "text": "The King", "correct": true, "image": "" },
        { "text": "Colonists", "correct": false, "image": "" },
        { "text": "Merchants", "correct": false, "image": "" }
      ]
    }
  ]
},
  "generalassembly": {
  "slug": "generalassembly",
  "title": "General Assembly",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. In what year did the General Assembly first meet?",
      "questionImage": "",
      "answers": [
        { "text": "1619", "correct": true, "image": "" },
        { "text": "1607", "correct": false, "image": "" },
        { "text": "1620", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who was part of the General Assembly?",
      "questionImage": "",
      "answers": [
        { "text": "Governor", "correct": true, "image": "" },
        { "text": "King", "correct": false, "image": "" },
        { "text": "Pope", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What were the elected representatives in the Assembly called?",
      "questionImage": "",
      "answers": [
        { "text": "Burgesses", "correct": true, "image": "" },
        { "text": "Senators", "correct": false, "image": "" },
        { "text": "Lords", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Around 1640, what name did the Assembly take on?",
      "questionImage": "",
      "answers": [
        { "text": "House of Burgesses", "correct": true, "image": "" },
        { "text": "Parliament", "correct": false, "image": "" },
        { "text": "Privy Council", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who elected the Burgesses to serve in the Assembly?",
      "questionImage": "",
      "answers": [
        { "text": "Settlers", "correct": true, "image": "" },
        { "text": "King", "correct": false, "image": "" },
        { "text": "Generals", "correct": false, "image": "" }
      ]
    }
  ]
},
  "gravity": {
    "slug": "gravity",
    "title": "Gravity",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What does each planet in our solar system orbit around?",
        "questionImage": "",
        "answers": [
          { "text": "The Sun", "correct": true, "image": "" },
          { "text": "The Moon", "correct": false, "image": "" },
          { "text": "The Earth", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which force keeps planets moving in their paths?",
        "questionImage": "",
        "answers": [
          { "text": "Gravity", "correct": true, "image": "" },
          { "text": "Wind", "correct": false, "image": "" },
          { "text": "Light", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If an object has more mass, what does gravity give it more of?",
        "questionImage": "",
        "answers": [
          { "text": "More pull", "correct": true, "image": "" },
          { "text": "Less pull", "correct": false, "image": "" },
          { "text": "No pull", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When you jump up, what happens next because of gravity?",
        "questionImage": "",
        "answers": [
          { "text": "You fall down", "correct": true, "image": "" },
          { "text": "You float up", "correct": false, "image": "" },
          { "text": "You stay up", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Gravity pulls people and objects toward which part of Earth?",
        "questionImage": "",
        "answers": [
          { "text": "Earth’s center", "correct": true, "image": "" },
          { "text": "The clouds", "correct": false, "image": "" },
          { "text": "The North Pole", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "greaterthan": {
    "slug": "greaterthan",
    "title": "Greater Than",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What does the alligator mouth face toward?",
        "answers": [
          { "text": "The larger number", "correct": true },
          { "text": "The smaller number", "correct": false },
          { "text": "The equal number", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which side is less than?",
        "answers": [
          { "text": "The closed side of the alligator", "correct": true },
          { "text": "The open side of the alligator", "correct": false },
          { "text": "The tail of the alligator", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does the equal sign mean?",
        "answers": [
          { "text": "Both numbers are the same", "correct": true },
          { "text": "The first number is smaller", "correct": false },
          { "text": "The first number is larger", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which symbol shows 'greater than'?",
        "answers": [
          { "text": ">", "correct": true },
          { "text": "<", "correct": false },
          { "text": "=", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If 8 > 5, what does this mean?",
        "answers": [
          { "text": "8 is greater than 5", "correct": true },
          { "text": "8 is less than 5", "correct": false },
          { "text": "8 is equal to 5", "correct": false }
        ]
      }
    ]
  },
  "greaterthanlessthan": {
    "slug": "greaterthanlessthan",
    "title": "Greater Than Less Than",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which is greater: 8 ___ 5?",
        "answers": [
          { "text": "8 > 5", "correct": true },
          { "text": "8 < 5", "correct": false },
          { "text": "8 = 5", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which is less: 3 ___ 7?",
        "answers": [
          { "text": "3 < 7", "correct": true },
          { "text": "3 > 7", "correct": false },
          { "text": "3 = 7", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which statement is true?",
        "answers": [
          { "text": "9 > 4", "correct": true },
          { "text": "9 < 4", "correct": false },
          { "text": "9 = 4", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which statement shows equal numbers?",
        "answers": [
          { "text": "6 = 6", "correct": true },
          { "text": "6 > 6", "correct": false },
          { "text": "6 < 6", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which side of the symbol faces the greater number?",
        "answers": [
          { "text": "The open side", "correct": true },
          { "text": "The closed side", "correct": false },
          { "text": "Both sides are equal", "correct": false }
        ]
      }
    ]
  },
  "habitats": {
    "slug": "habitats",
    "title": "Habitats",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#c2f0f7" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the animal with its habitat.",
        "options": [
          { "id": "ants", "text": "Ants", "targetText": "Ant farm" },
          { "id": "bees", "text": "Bees", "targetText": "Hive" },
          { "id": "fish", "text": "Fish", "targetText": "Water" },
          { "id": "toucan", "text": "Toucan", "targetText": "Rainforest" }
        ]
      },
      {
        "question": "Match the habitat with what it gives.",
        "options": [
          { "id": "food", "text": "Food", "targetText": "Helps animals eat" },
          { "id": "water", "text": "Water", "targetText": "Helps animals drink" },
          { "id": "shelter", "text": "Shelter", "targetText": "Keeps animals safe" },
          { "id": "air", "text": "Air", "targetText": "Helps animals breathe" }
        ]
      },
      {
        "question": "Match the habitat with the right temperature.",
        "options": [
          { "id": "desert", "text": "Desert", "targetText": "Hot and dry" },
          { "id": "arctic", "text": "Arctic", "targetText": "Cold and icy" },
          { "id": "forest", "text": "Forest", "targetText": "Cool and shady" },
          { "id": "rainforest", "text": "Rainforest", "targetText": "Warm and wet" }
        ]
      },
      {
        "question": "Match the word with its meaning.",
        "options": [
          { "id": "habitat", "text": "Habitat", "targetText": "Home of an animal" },
          { "id": "population", "text": "Population", "targetText": "Group of same animals" },
          { "id": "organisms", "text": "Organisms", "targetText": "Living things" }
        ]
      },
      {
        "question": "Match the animal with what it needs most.",
        "options": [
          { "id": "fish", "text": "Fish", "targetText": "Clean water" },
          { "id": "birds", "text": "Birds", "targetText": "Trees for nests" },
          { "id": "bees", "text": "Bees", "targetText": "Flowers for food" }
        ]
      }
    ]
  },
  "halfoffourthof": {
    "slug": "halfoffourthof",
    "title": "Half of, Fourth of",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Half of 8 is:",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "2", "correct": false },
          { "text": "6", "correct": false },
          { "text": "8", "correct": false }
        ]
      },
      {
        "question": "A fourth of 8 is:",
        "answers": [
          { "text": "2", "correct": true },
          { "text": "3", "correct": false },
          { "text": "4", "correct": false },
          { "text": "6", "correct": false }
        ]
      },
      {
        "question": "Which shows a half?",
        "answers": [
          { "text": "2 equal parts", "correct": true },
          { "text": "3 equal parts", "correct": false },
          { "text": "4 equal parts", "correct": false },
          { "text": "5 equal parts", "correct": false }
        ]
      }
    ]
  },
  "hardliving": {
  "slug": "hardliving",
  "title": "Hard Living",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What killed many settlers in Jamestown?",
      "questionImage": "",
      "answers": [
        { "text": "Starvation", "correct": true, "image": "" },
        { "text": "Lightning", "correct": false, "image": "" },
        { "text": "Floods", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What else caused many deaths in Jamestown?",
      "questionImage": "",
      "answers": [
        { "text": "Disease", "correct": true, "image": "" },
        { "text": "Cold", "correct": false, "image": "" },
        { "text": "Fire", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What kind of land did settlers build Jamestown on?",
      "questionImage": "",
      "answers": [
        { "text": "Marshy", "correct": true, "image": "" },
        { "text": "Desert", "correct": false, "image": "" },
        { "text": "Mountain", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who helped lead the settlers and bring supply ships?",
      "questionImage": "",
      "answers": [
        { "text": "John Smith", "correct": true, "image": "" },
        { "text": "Thomas Jefferson", "correct": false, "image": "" },
        { "text": "Christopher Columbus", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did settlers have to do to survive?",
      "questionImage": "",
      "answers": [
        { "text": "Farm", "correct": true, "image": "" },
        { "text": "Fish only", "correct": false, "image": "" },
        { "text": "Hunt only", "correct": false, "image": "" }
      ]
    }
  ]
},
  "hemisphere": {
    "slug": "hemisphere",
    "title": "Hemisphere",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What two halves of Earth are created by the Prime Meridian according to the lesson?",
        "questionImage": "",
        "answers": [
          { "text": "Eastern and Western Hemispheres", "correct": true, "image": "" },
          { "text": "Northern and Southern Hemispheres", "correct": false, "image": "" },
          { "text": "Land and Sea Hemispheres", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What two halves of Earth are created by the Equator as explained in the song?",
        "questionImage": "",
        "answers": [
          { "text": "Northern and Southern Hemispheres", "correct": true, "image": "" },
          { "text": "Eastern and Western Hemispheres", "correct": false, "image": "" },
          { "text": "Daytime and Nighttime Hemispheres", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How is the Prime Meridian described in the lyrics?",
        "questionImage": "",
        "answers": [
          { "text": "An imaginary line", "correct": true, "image": "" },
          { "text": "A river", "correct": false, "image": "" },
          { "text": "A mountain range", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How is the Equator described in the lyrics?",
        "questionImage": "",
        "answers": [
          { "text": "An imaginary line", "correct": true, "image": "" },
          { "text": "A road around the Earth", "correct": false, "image": "" },
          { "text": "A country border", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does the term Eastern Hemisphere mean in relation to the Prime Meridian?",
        "questionImage": "",
        "answers": [
          { "text": "The area east of the Prime Meridian", "correct": true, "image": "" },
          { "text": "The area south of the Equator", "correct": false, "image": "" },
          { "text": "The area west of the Prime Meridian", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "holiday": {
    "slug": "holiday",
    "title": "Holiday",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each month to the holiday celebrated in that month.",
        "options": [
          { "id": "jan", "text": "January", "image": "", "targetText": "Martin Luther King Jr. Day", "targetImage": "" },
          { "id": "feb", "text": "February", "image": "", "targetText": "Presidents Day", "targetImage": "" },
          { "id": "mar", "text": "March", "image": "", "targetText": "Women’s History Month", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each spring month to the holiday or event remembered.",
        "options": [
          { "id": "apr", "text": "April", "image": "", "targetText": "Earth Day", "targetImage": "" },
          { "id": "may", "text": "May", "image": "", "targetText": "Memorial Day", "targetImage": "" },
          { "id": "jun", "text": "June", "image": "", "targetText": "Flag Day", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each summer holiday to the correct month.",
        "options": [
          { "id": "jul", "text": "July", "image": "", "targetText": "Independence Day", "targetImage": "" },
          { "id": "aug", "text": "August", "image": "", "targetText": "Back to School Month", "targetImage": "" },
          { "id": "sep", "text": "September", "image": "", "targetText": "Labor Day", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match the fall months to the holidays celebrated then.",
        "options": [
          { "id": "oct", "text": "October", "image": "", "targetText": "Halloween", "targetImage": "" },
          { "id": "nov", "text": "November", "image": "", "targetText": "Veterans Day", "targetImage": "" },
          { "id": "nov2", "text": "November", "image": "", "targetText": "Thanksgiving", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each winter month to the holiday mentioned in the song.",
        "options": [
          { "id": "dec", "text": "December", "image": "", "targetText": "Christmas", "targetImage": "" },
          { "id": "dec2", "text": "December", "image": "", "targetText": "Kwanzaa", "targetImage": "" },
          { "id": "jan2", "text": "January", "image": "", "targetText": "New Year’s Day", "targetImage": "" }
        ]
      }
    ]
  },
  "hotwaterdissolves": {
    "slug": "hotwaterdissolves",
    "title": "Hot Water Dissolves Faster",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Why does sugar dissolve faster in hot water?",
        "questionImage": "",
        "answers": [
          { "text": "Molecules move faster", "correct": true, "image": "" },
          { "text": "Water is colder", "correct": false, "image": "" },
          { "text": "Less sugar is used", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When water gains heat energy, its molecules…",
        "questionImage": "",
        "answers": [
          { "text": "Move faster", "correct": true, "image": "" },
          { "text": "Stop moving", "correct": false, "image": "" },
          { "text": "Freeze", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Stirring a cup usually makes dissolving…",
        "questionImage": "",
        "answers": [
          { "text": "Happen faster", "correct": true, "image": "" },
          { "text": "Stop completely", "correct": false, "image": "" },
          { "text": "Make ice", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Smaller sugar grains dissolve…",
        "questionImage": "",
        "answers": [
          { "text": "Faster than big ones", "correct": true, "image": "" },
          { "text": "Slower than big ones", "correct": false, "image": "" },
          { "text": "Not at all", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. A solid that dissolves is called a…",
        "questionImage": "",
        "answers": [
          { "text": "Solute", "correct": true, "image": "" },
          { "text": "Solvent", "correct": false, "image": "" },
          { "text": "Solution", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "instruments": {
    "slug": "instruments",
    "title": "Instruments",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#b2d8ff" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the instrument with its sound maker.",
        "options": [
          { "id": "guitar", "text": "Guitar", "targetText": "Vibrating strings" },
          { "id": "violin", "text": "Violin", "targetText": "Vibrating strings" },
          { "id": "flute", "text": "Flute", "targetText": "Vibrating air" },
          { "id": "trumpet", "text": "Trumpet", "targetText": "Vibrating air" },
          { "id": "drum", "text": "Drum", "targetText": "Vibrating head" }
        ]
      },
      {
        "question": "Match the sound with the instrument.",
        "options": [
          { "id": "string_sound", "text": "Twanging sound", "targetText": "Guitar or Violin" },
          { "id": "air_sound", "text": "Blowing air sound", "targetText": "Flute or Trumpet" },
          { "id": "beat_sound", "text": "Booming sound", "targetText": "Drum" },
          { "id": "singing_sound", "text": "Helps people sing", "targetText": "Guitar" }
        ]
      },
      {
        "question": "Match each instrument to the family it belongs to.",
        "options": [
          { "id": "strings", "text": "Strings", "targetText": "Guitar, Violin" },
          { "id": "winds", "text": "Winds", "targetText": "Flute, Trumpet" },
          { "id": "percussion", "text": "Percussion", "targetText": "Drum" },
          { "id": "voices", "text": "Voices", "targetText": "Singing" }
        ]
      },
      {
        "question": "Match the instrument to how you play it.",
        "options": [
          { "id": "pluck", "text": "Pluck strings", "targetText": "Guitar" },
          { "id": "bow", "text": "Use a bow", "targetText": "Violin" },
          { "id": "blow", "text": "Blow into", "targetText": "Flute, Trumpet" },
          { "id": "hit", "text": "Hit with sticks or hands", "targetText": "Drum" }
        ]
      },
      {
        "question": "Match the instrument to its picture or idea.",
        "options": [
          { "id": "guitar", "text": "Guitar", "targetText": "Has six strings" },
          { "id": "violin", "text": "Violin", "targetText": "Small, played with bow" },
          { "id": "flute", "text": "Flute", "targetText": "Long, silver tube" },
          { "id": "trumpet", "text": "Trumpet", "targetText": "Gold with valves" }
        ]
      }
    ]
  },
  "ladybug": {
  "slug": "ladybug",
  "title": "Ladybug",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What is the first stage in a ladybug’s life cycle?",
      "questionImage": "",
      "answers": [
        { "text": "Egg", "correct": true, "image": "" },
        { "text": "Larva", "correct": false, "image": "" },
        { "text": "Adult", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is the second stage in a ladybug’s life cycle?",
      "questionImage": "",
      "answers": [
        { "text": "Larva", "correct": true, "image": "" },
        { "text": "Egg", "correct": false, "image": "" },
        { "text": "Pupa", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is the third stage in a ladybug’s life cycle?",
      "questionImage": "",
      "answers": [
        { "text": "Pupa", "correct": true, "image": "" },
        { "text": "Adult", "correct": false, "image": "" },
        { "text": "Egg", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What color is a typical adult ladybug’s shell?",
      "questionImage": "",
      "answers": [
        { "text": "Red", "correct": true, "image": "" },
        { "text": "Blue", "correct": false, "image": "" },
        { "text": "Green", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What kind of marks are on a ladybug’s back?",
      "questionImage": "",
      "answers": [
        { "text": "Spots", "correct": true, "image": "" },
        { "text": "Stripes", "correct": false, "image": "" },
        { "text": "Stars", "correct": false, "image": "" }
      ]
    }
  ]
},
  "languages": {
  "slug": "languages",
  "title": "Languages",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match region to language.",
      "options": [
        { "id": "tidewater", "text": "Tidewater", "image": "", "targetText": "Algonquian", "targetImage": "" },
        { "id": "piedmont", "text": "Piedmont", "image": "", "targetText": "Siouan", "targetImage": "" },
        { "id": "valley", "text": "Valley & Ridge", "image": "", "targetText": "Iroquoian", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match groups to regions.",
      "options": [
        { "id": "powhatan", "text": "Powhatan", "image": "", "targetText": "Tidewater", "targetImage": "" },
        { "id": "monacan", "text": "Monacan", "image": "", "targetText": "Piedmont", "targetImage": "" },
        { "id": "cherokee", "text": "Cherokee", "image": "", "targetText": "Valley & Ridge", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match languages to regions.",
      "options": [
        { "id": "algonquian", "text": "Algonquian", "image": "", "targetText": "Tidewater", "targetImage": "" },
        { "id": "siouan", "text": "Siouan", "image": "", "targetText": "Piedmont", "targetImage": "" },
        { "id": "iroquoian", "text": "Iroquoian", "image": "", "targetText": "Valley & Ridge", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Cherokee, Powhatan, and Monacan.",
      "options": [
        { "id": "cherokee2", "text": "Cherokee", "image": "", "targetText": "Iroquoian", "targetImage": "" },
        { "id": "powhatan2", "text": "Powhatan", "image": "", "targetText": "Algonquian", "targetImage": "" },
        { "id": "monacan2", "text": "Monacan", "image": "", "targetText": "Siouan", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match regions to their tribes.",
      "options": [
        { "id": "valley2", "text": "Valley & Ridge", "image": "", "targetText": "Cherokee", "targetImage": "" },
        { "id": "piedmont2", "text": "Piedmont", "image": "", "targetText": "Monacan", "targetImage": "" },
        { "id": "tidewater2", "text": "Tidewater", "image": "", "targetText": "Powhatan", "targetImage": "" }
      ]
    }
  ]
},
  "lines": {
    "slug": "lines",
    "title": "Lines",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is a line?",
        "answers": [
          { "text": "A straight path that extends in both directions", "correct": true },
          { "text": "A line with one endpoint", "correct": false },
          { "text": "A line that stops at both ends", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What are perpendicular lines?",
        "answers": [
          { "text": "Two lines that intersect to form right angles", "correct": true },
          { "text": "Lines that never meet", "correct": false },
          { "text": "Lines that curve around a point", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What are parallel lines?",
        "answers": [
          { "text": "Lines in a plane that do not intersect", "correct": true },
          { "text": "Lines that meet at one point", "correct": false },
          { "text": "Lines that form an angle", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is a ray?",
        "answers": [
          { "text": "A line that starts at one endpoint and goes on forever", "correct": true },
          { "text": "A line that stops at both ends", "correct": false },
          { "text": "Two lines that cross each other", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is a line segment?",
        "answers": [
          { "text": "Part of a line that has two endpoints", "correct": true },
          { "text": "A line that goes on forever", "correct": false },
          { "text": "Two lines that form a right angle", "correct": false }
        ]
      }
    ]
  },
  "location": {
  "slug": "location",
  "title": "Location",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Jamestown was located on a what?",
      "questionImage": "",
      "answers": [
        { "text": "Peninsula", "correct": true, "image": "" },
        { "text": "Desert", "correct": false, "image": "" },
        { "text": "Plateau", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The shoreline had water deep enough for what?",
      "questionImage": "",
      "answers": [
        { "text": "Ships to dock", "correct": true, "image": "" },
        { "text": "Horses to drink", "correct": false, "image": "" },
        { "text": "Carts to cross", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What could the site be easily defended against?",
      "questionImage": "",
      "answers": [
        { "text": "Sea attacks", "correct": true, "image": "" },
        { "text": "Snowstorms", "correct": false, "image": "" },
        { "text": "Drought", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did settlers believe about the nearby water supply?",
      "questionImage": "",
      "answers": [
        { "text": "It was safe to drink", "correct": true, "image": "" },
        { "text": "It was bad for crops", "correct": false, "image": "" },
        { "text": "It came from the ocean", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. In what year did the English settlers arrive in Jamestown?",
      "questionImage": "",
      "answers": [
        { "text": "1607", "correct": true, "image": "" },
        { "text": "1588", "correct": false, "image": "" },
        { "text": "1701", "correct": false, "image": "" }
      ]
    }
  ]
},
  "lookingfor": {
  "slug": "lookingfor",
  "title": "Looking For",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Why were colonies started in North America?",
      "questionImage": "",
      "answers": [
        { "text": "Religious reasons", "correct": true, "image": "" },
        { "text": "Space travel", "correct": false, "image": "" },
        { "text": "Sports", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why else were colonies started?",
      "questionImage": "",
      "answers": [
        { "text": "Economic reasons", "correct": true, "image": "" },
        { "text": "Magic", "correct": false, "image": "" },
        { "text": "Vacation", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why was Plymouth Colony settled?",
      "questionImage": "",
      "answers": [
        { "text": "Religious freedom", "correct": true, "image": "" },
        { "text": "Gold", "correct": false, "image": "" },
        { "text": "Horses", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why was Jamestown settled?",
      "questionImage": "",
      "answers": [
        { "text": "Economic ventures", "correct": true, "image": "" },
        { "text": "Music", "correct": false, "image": "" },
        { "text": "Religion", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why was Pennsylvania settled?",
      "questionImage": "",
      "answers": [
        { "text": "Religious freedom", "correct": true, "image": "" },
        { "text": "Tobacco", "correct": false, "image": "" },
        { "text": "Horses", "correct": false, "image": "" }
      ]
    }
  ]
},
  "magnetism": {
    "slug": "magnetism",
    "title": "Magnetism",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What happens when two like magnetic poles get close?",
        "questionImage": "",
        "answers": [
          { "text": "They repel", "correct": true, "image": "" },
          { "text": "They attract", "correct": false, "image": "" },
          { "text": "They do nothing", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What happens when two opposite magnetic poles get close?",
        "questionImage": "",
        "answers": [
          { "text": "They attract", "correct": true, "image": "" },
          { "text": "They repel", "correct": false, "image": "" },
          { "text": "They melt", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Where are a magnet’s strongest points?",
        "questionImage": "",
        "answers": [
          { "text": "At the poles", "correct": true, "image": "" },
          { "text": "In the middle", "correct": false, "image": "" },
          { "text": "On the sides", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. A magnetic field is best described as a kind of what?",
        "questionImage": "",
        "answers": [
          { "text": "Force", "correct": true, "image": "" },
          { "text": "Color", "correct": false, "image": "" },
          { "text": "Sound", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do we call a magnet made by electricity that is not permanent?",
        "questionImage": "",
        "answers": [
          { "text": "An electromagnet", "correct": true, "image": "" },
          { "text": "A permanent magnet", "correct": false, "image": "" },
          { "text": "A plastic magnet", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "majorbodies": {
  "slug": "majorbodies",
  "title": "Major Bodies",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each river to its explorers.",
      "options": [
        { "id": "columbia", "text": "Columbia", "image": "", "targetText": "Lewis & Clark", "targetImage": "" },
        { "id": "colorado", "text": "Colorado", "image": "", "targetText": "Spanish", "targetImage": "" },
        { "id": "gulfmexico", "text": "Gulf of Mexico", "image": "", "targetText": "Spanish/French", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match rivers to farm transport.",
      "options": [
        { "id": "mississippi", "text": "Mississippi", "image": "", "targetText": "Farm products", "targetImage": "" },
        { "id": "missouri", "text": "Missouri", "image": "", "targetText": "Farm products", "targetImage": "" },
        { "id": "ohio", "text": "Ohio", "image": "", "targetText": "West travel", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each Great Lake to its group.",
      "options": [
        { "id": "superior", "text": "Lake Superior", "image": "", "targetText": "Great Lakes", "targetImage": "" },
        { "id": "michigan", "text": "Lake Michigan", "image": "", "targetText": "Great Lakes", "targetImage": "" },
        { "id": "erie", "text": "Lake Erie", "image": "", "targetText": "Great Lakes", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match the Atlantic and Pacific Oceans to their use.",
      "options": [
        { "id": "atlantic", "text": "Atlantic", "image": "", "targetText": "World route", "targetImage": "" },
        { "id": "pacific", "text": "Pacific", "image": "", "targetText": "World route", "targetImage": "" },
        { "id": "gulfmexico2", "text": "Gulf of Mexico", "image": "", "targetText": "Mexico route", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each of the Great Lakes to their group.",
      "options": [
        { "id": "huron", "text": "Lake Huron", "image": "", "targetText": "Great Lakes", "targetImage": "" },
        { "id": "ontario", "text": "Lake Ontario", "image": "", "targetText": "Great Lakes", "targetImage": "" },
        { "id": "erie2", "text": "Lake Erie", "image": "", "targetText": "Great Lakes", "targetImage": "" }
      ]
    }
  ]
},
  "mali": {
    "slug": "mali",
    "title": "Mali",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Grab or click an item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Mali facts to the right idea.",
        "options": [
          { "id": "mali1", "text": "Mali", "image": "", "targetText": "Trade center", "targetImage": "" },
          { "id": "kings1", "text": "Kings", "image": "", "targetText": "Wealthy", "targetImage": "" },
          { "id": "timbuktu1", "text": "Timbuktu", "image": "", "targetText": "Important city", "targetImage": "" }
        ]
      },
      {
        "question": "Grab or click an item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each item to its place.",
        "options": [
          { "id": "salt1", "text": "Salt", "image": "", "targetText": "Sahara", "targetImage": "" },
          { "id": "gold1", "text": "Gold", "image": "", "targetText": "West Africa", "targetImage": "" },
          { "id": "mali2", "text": "Mali", "image": "", "targetText": "Between them", "targetImage": "" }
        ]
      },
      {
        "question": "Grab or click an item from the top row (A) and drop it on the item from the bottom row (B) that matches. Finish the idea from the song.",
        "options": [
          { "id": "trade1", "text": "Salt was traded", "image": "", "targetText": "For gold", "targetImage": "" },
          { "id": "timbuktu2", "text": "Timbuktu", "image": "", "targetText": "In Mali", "targetImage": "" },
          { "id": "mali3", "text": "Mali was", "image": "", "targetText": "A great empire", "targetImage": "" }
        ]
      },
      {
        "question": "Grab or click an item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each term to its category.",
        "options": [
          { "id": "mali4", "text": "Mali", "image": "", "targetText": "Empire", "targetImage": "" },
          { "id": "timbuktu3", "text": "Timbuktu", "image": "", "targetText": "City", "targetImage": "" },
          { "id": "kings2", "text": "Kings", "image": "", "targetText": "Rulers", "targetImage": "" }
        ]
      },
      {
        "question": "Grab or click an item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each phrase to its detail.",
        "options": [
          { "id": "between1", "text": "In between", "image": "", "targetText": "Salt & gold", "targetImage": "" },
          { "id": "wealth1", "text": "Mali’s kings", "image": "", "targetText": "Were wealthy", "targetImage": "" },
          { "id": "center1", "text": "Mali was", "image": "", "targetText": "Trade hub", "targetImage": "" }
        ]
      }
    ]
  },
  "matter": {
    "slug": "matter",
    "title": "Matter",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each state to its trait.",
        "options": [
          { "id": "solid", "text": "Solid", "image": "", "targetText": "Keeps its shape", "targetImage": "" },
          { "id": "liquid", "text": "Liquid", "image": "", "targetText": "Takes container’s shape", "targetImage": "" },
          { "id": "gas", "text": "Gas", "image": "", "targetText": "Fills the space", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match particle motion to the state.",
        "options": [
          { "id": "tight", "text": "Packed tightly", "image": "", "targetText": "Solid", "targetImage": "" },
          { "id": "slide", "text": "Slide past each other", "image": "", "targetText": "Liquid", "targetImage": "" },
          { "id": "spread", "text": "Spread out and fast", "image": "", "targetText": "Gas", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each example to its state.",
        "options": [
          { "id": "ice", "text": "Ice", "image": "", "targetText": "Solid", "targetImage": "" },
          { "id": "water", "text": "Water", "image": "", "targetText": "Liquid", "targetImage": "" },
          { "id": "steam", "text": "Steam", "image": "", "targetText": "Gas", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each idea to matter.",
        "options": [
          { "id": "mass", "text": "Has mass", "image": "", "targetText": "Matter", "targetImage": "" },
          { "id": "space", "text": "Takes up space", "image": "", "targetText": "Matter", "targetImage": "" },
          { "id": "particles", "text": "Made of particles", "image": "", "targetText": "Matter", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each container idea.",
        "options": [
          { "id": "cup-water", "text": "Water in a cup", "image": "", "targetText": "Liquid takes shape", "targetImage": "" },
          { "id": "balloon-air", "text": "Air in a balloon", "image": "", "targetText": "Gas fills space", "targetImage": "" },
          { "id": "block", "text": "Wood block", "image": "", "targetText": "Solid keeps shape", "targetImage": "" }
        ]
      }
    ]
  },
  "metamorphosis": {
  "slug": "metamorphosis",
  "title": "Metamorphosis",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What is the process called when an animal changes its body form during its life?",
      "questionImage": "",
      "answers": [
        { "text": "Metamorphosis", "correct": true, "image": "" },
        { "text": "No change", "correct": false, "image": "" },
        { "text": "Disappearing", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. In a frog’s life cycle, what is the first stage?",
      "questionImage": "",
      "answers": [
        { "text": "Egg", "correct": true, "image": "" },
        { "text": "Pupa", "correct": false, "image": "" },
        { "text": "Adult", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What do we call the young frog that lives in water and has a tail?",
      "questionImage": "",
      "answers": [
        { "text": "Tadpole", "correct": true, "image": "" },
        { "text": "Larva", "correct": false, "image": "" },
        { "text": "Nymph", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. As a tadpole grows into a frog, what new body parts appear?",
      "questionImage": "",
      "answers": [
        { "text": "Legs", "correct": true, "image": "" },
        { "text": "Wings", "correct": false, "image": "" },
        { "text": "Horns", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When a frog becomes an adult and lives on land, how does it breathe?",
      "questionImage": "",
      "answers": [
        { "text": "With lungs", "correct": true, "image": "" },
        { "text": "With gills", "correct": false, "image": "" },
        { "text": "With skin only", "correct": false, "image": "" }
      ]
    }
  ]
},
  "mixtures": {
    "slug": "mixtures",
    "title": "Mixtures",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is a mixture?",
        "questionImage": "",
        "answers": [
          { "text": "Different things together", "correct": true, "image": "" },
          { "text": "One pure element", "correct": false, "image": "" },
          { "text": "Only a gas", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which can be separated easily by hand?",
        "questionImage": "",
        "answers": [
          { "text": "Trail mix", "correct": true, "image": "" },
          { "text": "Salt water", "correct": false, "image": "" },
          { "text": "Soda", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which mixture dissolves and stays combined?",
        "questionImage": "",
        "answers": [
          { "text": "Salt water", "correct": true, "image": "" },
          { "text": "Sand and rocks", "correct": false, "image": "" },
          { "text": "Buttons in a jar", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. A mixture that looks the same everywhere is…",
        "questionImage": "",
        "answers": [
          { "text": "A solution", "correct": true, "image": "" },
          { "text": "A sandwich", "correct": false, "image": "" },
          { "text": "A magnet", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which tool can help separate iron from sand?",
        "questionImage": "",
        "answers": [
          { "text": "A magnet", "correct": true, "image": "" },
          { "text": "A spoon", "correct": false, "image": "" },
          { "text": "A ruler", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "moonphasesrap": {
  "slug": "moonphasesrap",
  "title": "Moon Phases Rap",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which phase is dark?",
      "questionImage": "",
      "answers": [
        { "text": "New moon", "correct": true, "image": "" },
        { "text": "Full moon", "correct": false, "image": "" },
        { "text": "Gibbous", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Less than half lit is…",
      "questionImage": "",
      "answers": [
        { "text": "Crescent", "correct": true, "image": "" },
        { "text": "Full", "correct": false, "image": "" },
        { "text": "Eclipse", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. A half-moon is called a…",
      "questionImage": "",
      "answers": [
        { "text": "Quarter moon", "correct": true, "image": "" },
        { "text": "New moon", "correct": false, "image": "" },
        { "text": "Blue moon", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. More than half lit is…",
      "questionImage": "",
      "answers": [
        { "text": "Gibbous", "correct": true, "image": "" },
        { "text": "Crescent", "correct": false, "image": "" },
        { "text": "Shadow", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which phase is brightest?",
      "questionImage": "",
      "answers": [
        { "text": "Full moon", "correct": true, "image": "" },
        { "text": "Waning crescent", "correct": false, "image": "" },
        { "text": "New moon", "correct": false, "image": "" }
      ]
    }
  ]
},
  "moonphasesrock": {
  "slug": "moonphasesrock",
  "title": "Moon Phases Rock",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each phase to dark or lit.",
      "options": [
        { "id": "new", "text": "New moon", "image": "", "targetText": "Dark", "targetImage": "" },
        { "id": "crescent", "text": "Crescent", "image": "", "targetText": "Less than half lit", "targetImage": "" },
        { "id": "quarter", "text": "Quarter moon", "image": "", "targetText": "Half lit", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match phase to when we see it.",
      "options": [
        { "id": "new2", "text": "New moon", "image": "", "targetText": "Between Sun & Earth", "targetImage": "" },
        { "id": "gibbous", "text": "Gibbous", "image": "", "targetText": "More than half lit", "targetImage": "" },
        { "id": "full", "text": "Full moon", "image": "", "targetText": "Face all lit", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match phase to sequence word.",
      "options": [
        { "id": "waxcres", "text": "Waxing crescent", "image": "", "targetText": "Getting bigger", "targetImage": "" },
        { "id": "firstq", "text": "First quarter", "image": "", "targetText": "Halfway lit", "targetImage": "" },
        { "id": "waxgib", "text": "Waxing gibbous", "image": "", "targetText": "Almost full", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match waning phases to ideas.",
      "options": [
        { "id": "wanegib", "text": "Waning gibbous", "image": "", "targetText": "Past full", "targetImage": "" },
        { "id": "lastq", "text": "Last quarter", "image": "", "targetText": "Half lit", "targetImage": "" },
        { "id": "wanecre", "text": "Waning crescent", "image": "", "targetText": "Thin sliver", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match phase names to category.",
      "options": [
        { "id": "waxing", "text": "Waxing", "image": "", "targetText": "Growing", "targetImage": "" },
        { "id": "waning", "text": "Waning", "image": "", "targetText": "Shrinking", "targetImage": "" },
        { "id": "full2", "text": "Full moon", "image": "", "targetText": "All lit", "targetImage": "" }
      ]
    }
  ]
},
  "motion": {
    "slug": "motion",
    "title": "Motion",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Motion happens when…",
        "questionImage": "",
        "answers": [
          { "text": "Position changes", "correct": true, "image": "" },
          { "text": "It stays still", "correct": false, "image": "" },
          { "text": "It is parked", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If a car moves 10 feet, what happened?",
        "questionImage": "",
        "answers": [
          { "text": "Motion occurred", "correct": true, "image": "" },
          { "text": "Nothing changed", "correct": false, "image": "" },
          { "text": "It vanished", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which shows motion?",
        "questionImage": "",
        "answers": [
          { "text": "A rolling ball", "correct": true, "image": "" },
          { "text": "A closed book", "correct": false, "image": "" },
          { "text": "A parked bus", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. To change direction you must…",
        "questionImage": "",
        "answers": [
          { "text": "Use a force", "correct": true, "image": "" },
          { "text": "Change color", "correct": false, "image": "" },
          { "text": "Change size", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If something is in motion, it is…",
        "questionImage": "",
        "answers": [
          { "text": "Moving", "correct": true, "image": "" },
          { "text": "Sleeping", "correct": false, "image": "" },
          { "text": "Invisible", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "moving": {
  "slug": "moving",
  "title": "Moving",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. When did many Virginians move west?",
      "questionImage": "",
      "answers": [
        { "text": "After the American Revolution", "correct": true, "image": "" },
        { "text": "Before 1600", "correct": false, "image": "" },
        { "text": "After 1900", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What were Virginians seeking when they moved west?",
      "questionImage": "",
      "answers": [
        { "text": "Farmland", "correct": true, "image": "" },
        { "text": "Castles", "correct": false, "image": "" },
        { "text": "Beaches", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What else drew Virginians to move west?",
      "questionImage": "",
      "answers": [
        { "text": "New opportunities", "correct": true, "image": "" },
        { "text": "Snowstorms", "correct": false, "image": "" },
        { "text": "Famine", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did Virginians carry with them when they moved west?",
      "questionImage": "",
      "answers": [
        { "text": "Ideas", "correct": true, "image": "" },
        { "text": "Castles", "correct": false, "image": "" },
        { "text": "Oceans", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What else did Virginians take west with them?",
      "questionImage": "",
      "answers": [
        { "text": "Their cultures and traditions", "correct": true, "image": "" },
        { "text": "City walls", "correct": false, "image": "" },
        { "text": "Palaces", "correct": false, "image": "" }
      ]
    }
  ]
},
  "movingcapital": {
  "slug": "movingcapital",
  "title": "Moving Capital",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Where was Virginia’s first capital?",
      "questionImage": "",
      "answers": [
        { "text": "Jamestown", "correct": true, "image": "" },
        { "text": "Richmond", "correct": false, "image": "" },
        { "text": "Norfolk", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why did leaders decide to move the capital from Jamestown?",
      "questionImage": "",
      "answers": [
        { "text": "Diseases spread through the swampy land", "correct": true, "image": "" },
        { "text": "It was too cold in winter", "correct": false, "image": "" },
        { "text": "There were too many hills", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where did the capital move after Jamestown?",
      "questionImage": "",
      "answers": [
        { "text": "Williamsburg", "correct": true, "image": "" },
        { "text": "Yorktown", "correct": false, "image": "" },
        { "text": "Boston", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where did the capital move after Williamsburg?",
      "questionImage": "",
      "answers": [
        { "text": "Richmond", "correct": true, "image": "" },
        { "text": "Baltimore", "correct": false, "image": "" },
        { "text": "Atlanta", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why was Richmond chosen as the new capital?",
      "questionImage": "",
      "answers": [
        { "text": "It was more central and safer from attacks", "correct": true, "image": "" },
        { "text": "It had better ocean trade", "correct": false, "image": "" },
        { "text": "It had a bigger harbor", "correct": false, "image": "" }
      ]
    }
  ]
},
  "multiplydecimals": {
    "slug": "multiplydecimals",
    "title": "Multiply Decimals",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. 0.3 × 0.2 = ?",
        "answers": [
          { "text": "0.06", "correct": true },
          { "text": "0.6", "correct": false },
          { "text": "0.12", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 0.4 × 0.5 = ?",
        "answers": [
          { "text": "0.20", "correct": true },
          { "text": "0.9", "correct": false },
          { "text": "0.25", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 0.6 × 0.3 = ?",
        "answers": [
          { "text": "0.18", "correct": true },
          { "text": "0.48", "correct": false },
          { "text": "0.9", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 0.8 × 0.4 = ?",
        "answers": [
          { "text": "0.32", "correct": true },
          { "text": "0.12", "correct": false },
          { "text": "0.52", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. 0.7 × 0.2 = ?",
        "answers": [
          { "text": "0.14", "correct": true },
          { "text": "0.12", "correct": false },
          { "text": "0.7", "correct": false }
        ]
      }
    ]
  },
  "mythreerocks": {
  "slug": "mythreerocks",
  "title": "My Three Rocks",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which rock forms in layers, often near water?",
      "questionImage": "",
      "answers": [
        { "text": "Sedimentary", "correct": true, "image": "" },
        { "text": "Igneous", "correct": false, "image": "" },
        { "text": "Metamorphic", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which rock forms when lava cools and hardens?",
      "questionImage": "",
      "answers": [
        { "text": "Igneous", "correct": true, "image": "" },
        { "text": "Sedimentary", "correct": false, "image": "" },
        { "text": "Metamorphic", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Heat and pressure change other rocks into what?",
      "questionImage": "",
      "answers": [
        { "text": "Metamorphic", "correct": true, "image": "" },
        { "text": "Sand", "correct": false, "image": "" },
        { "text": "Soil", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which rock type can have fossils?",
      "questionImage": "",
      "answers": [
        { "text": "Sedimentary", "correct": true, "image": "" },
        { "text": "Igneous", "correct": false, "image": "" },
        { "text": "Metamorphic", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which list names the three main rock types?",
      "questionImage": "",
      "answers": [
        { "text": "Sed., ign., meta.", "correct": true, "image": "" },
        { "text": "Clay, silt, sand", "correct": false, "image": "" },
        { "text": "Coal, steel, glass", "correct": false, "image": "" }
      ]
    }
  ]
},
  "nativecontributions": {
    "slug": "nativecontributions",
    "title": "Native Contributions",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each crop to the correct category from the song.",
        "options": [
          { "id": "corn", "text": "Corn", "image": "", "targetText": "Farming", "targetImage": "" },
          { "id": "tobacco", "text": "Tobacco", "image": "", "targetText": "Farming", "targetImage": "" },
          { "id": "beans", "text": "Beans", "image": "", "targetText": "Farming", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each craft to the art form mentioned in the lyrics.",
        "options": [
          { "id": "pottery", "text": "Pottery", "image": "", "targetText": "Art", "targetImage": "" },
          { "id": "weaving", "text": "Weaving", "image": "", "targetText": "Art", "targetImage": "" },
          { "id": "carving", "text": "Carving", "image": "", "targetText": "Art", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each idea to the value described in the song.",
        "options": [
          { "id": "respect", "text": "Respect for nature", "image": "", "targetText": "Value", "targetImage": "" },
          { "id": "knowledge", "text": "Learning about the environment", "image": "", "targetText": "Value", "targetImage": "" },
          { "id": "sharing", "text": "Sharing with others", "image": "", "targetText": "Value", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each word to what Native culture continues to do over time.",
        "options": [
          { "id": "culture", "text": "Culture", "image": "", "targetText": "Lives on", "targetImage": "" },
          { "id": "traditions", "text": "Traditions", "image": "", "targetText": "Continue", "targetImage": "" },
          { "id": "stories", "text": "Stories", "image": "", "targetText": "Passed down", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each phrase to the idea that Native contributions are still part of life today.",
        "options": [
          { "id": "today", "text": "Used today", "image": "", "targetText": "Contributions", "targetImage": "" },
          { "id": "influence", "text": "Influences", "image": "", "targetText": "Modern life", "targetImage": "" },
          { "id": "present", "text": "Present in culture", "image": "", "targetText": "Everyday life", "targetImage": "" }
        ]
      }
    ]
  },
  "nativedifferences": {
    "slug": "nativedifferences",
    "title": "Native Differences",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. In which region did the Powhatan live according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Eastern Woodlands", "correct": true, "image": "" },
          { "text": "Plains", "correct": false, "image": "" },
          { "text": "Desert", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What kind of homes did the Lakota build as described in the lyrics?",
        "questionImage": "",
        "answers": [
          { "text": "Teepees", "correct": true, "image": "" },
          { "text": "Igloos", "correct": false, "image": "" },
          { "text": "Castles", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What were Pueblo homes made from according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "Clay", "correct": true, "image": "" },
          { "text": "Ice", "correct": false, "image": "" },
          { "text": "Bark", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What kinds of jobs did the Powhatan do as mentioned in the song?",
        "questionImage": "",
        "answers": [
          { "text": "Hunted, fished, and farmed", "correct": true, "image": "" },
          { "text": "Mined gold", "correct": false, "image": "" },
          { "text": "Built cities", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How did the Powhatan travel as mentioned in the lyrics?",
        "questionImage": "",
        "answers": [
          { "text": "Canoes", "correct": true, "image": "" },
          { "text": "Horses", "correct": false, "image": "" },
          { "text": "Trains", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "naturalresources": {
    "slug": "naturalresources",
    "title": "Natural Resources",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each item to the type of resource that can replace itself over time.",
        "options": [
          { "id": "trees", "text": "Trees", "image": "", "targetText": "Renewable", "targetImage": "" },
          { "id": "fish", "text": "Fish", "image": "", "targetText": "Renewable", "targetImage": "" },
          { "id": "horses", "text": "Horses", "image": "", "targetText": "Renewable", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each fuel to the resource type that takes millions of years to form.",
        "options": [
          { "id": "oil", "text": "Oil", "image": "", "targetText": "Nonrenewable", "targetImage": "" },
          { "id": "gas", "text": "Natural Gas", "image": "", "targetText": "Nonrenewable", "targetImage": "" },
          { "id": "coal", "text": "Coal", "image": "", "targetText": "Nonrenewable", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each energy source that will not run out in our lifetime to its type.",
        "options": [
          { "id": "sunlight", "text": "Sunlight", "image": "", "targetText": "Inexhaustible", "targetImage": "" },
          { "id": "wind", "text": "Wind", "image": "", "targetText": "Inexhaustible", "targetImage": "" },
          { "id": "water", "text": "Flowing Water", "image": "", "targetText": "Inexhaustible", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each metal to the resource type that can be used again after recycling.",
        "options": [
          { "id": "copper", "text": "Copper", "image": "", "targetText": "Recyclable", "targetImage": "" },
          { "id": "tin", "text": "Tin", "image": "", "targetText": "Recyclable", "targetImage": "" },
          { "id": "aluminum", "text": "Aluminum", "image": "", "targetText": "Recyclable", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each key idea to the correct resource category from the song.",
        "options": [
          { "id": "renew_fact", "text": "Plants and Animals", "image": "", "targetText": "Renewable", "targetImage": "" },
          { "id": "nonrenew_fact", "text": "Takes millions of years", "image": "", "targetText": "Nonrenewable", "targetImage": "" },
          { "id": "recycle_fact", "text": "Can be reused", "image": "", "targetText": "Recyclable", "targetImage": "" }
        ]
      }
    ]
  },
  "neighbors": {
  "slug": "neighbors",
  "title": "Neighbors",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Virginia to one of its neighbors.",
      "options": [
        { "id": "nc", "text": "North Carolina", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "tn", "text": "Tennessee", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "ky", "text": "Kentucky", "image": "", "targetText": "Neighbor", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Virginia to its other neighbors.",
      "options": [
        { "id": "wv", "text": "West Virginia", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "md", "text": "Maryland", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "nc2", "text": "North Carolina", "image": "", "targetText": "Neighbor", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match Tennessee, Kentucky, and West Virginia.",
      "options": [
        { "id": "tn2", "text": "Tennessee", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "ky2", "text": "Kentucky", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "wv2", "text": "West Virginia", "image": "", "targetText": "Neighbor", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match North Carolina, Maryland, and Kentucky.",
      "options": [
        { "id": "nc3", "text": "North Carolina", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "md2", "text": "Maryland", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "ky3", "text": "Kentucky", "image": "", "targetText": "Neighbor", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match West Virginia, Tennessee, and Maryland.",
      "options": [
        { "id": "wv3", "text": "West Virginia", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "tn3", "text": "Tennessee", "image": "", "targetText": "Neighbor", "targetImage": "" },
        { "id": "md3", "text": "Maryland", "image": "", "targetText": "Neighbor", "targetImage": "" }
      ]
    }
  ]
},
  "nightandday": {
    "slug": "nightandday",
    "title": "Night & Day",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Why do we have night and day?",
        "answers": [
          { "text": "Because Earth spins", "correct": true },
          { "text": "Because the sun goes away", "correct": false },
          { "text": "Because the moon eats the sun", "correct": false },
          { "text": "Because stars turn on and off", "correct": false }
        ]
      },
      {
        "question": "How long does it take Earth to spin once?",
        "answers": [
          { "text": "24 hours (1 day)", "correct": true },
          { "text": "1 hour", "correct": false },
          { "text": "1 week", "correct": false },
          { "text": "1 year", "correct": false }
        ]
      },
      {
        "question": "What side of Earth has day?",
        "answers": [
          { "text": "The side facing the sun", "correct": true },
          { "text": "The side facing the moon", "correct": false },
          { "text": "The side facing stars", "correct": false },
          { "text": "The side facing space", "correct": false }
        ]
      },
      {
        "question": "What side of Earth has night?",
        "answers": [
          { "text": "The side turned away from the sun", "correct": true },
          { "text": "The side with clouds", "correct": false },
          { "text": "The side with animals", "correct": false },
          { "text": "The side with plants", "correct": false }
        ]
      },
      {
        "question": "What makes the sun seem to move in the sky?",
        "answers": [
          { "text": "The Earth spins", "correct": true },
          { "text": "The sun moves around Earth", "correct": false },
          { "text": "The moon pushes it", "correct": false },
          { "text": "Clouds carry it", "correct": false }
        ]
      }
    ]
  },
  "nonstandard": {
  "slug": "nonstandard",
  "title": "Non-Standard",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What does 'non-standard measurement' mean?",
      "answers": [
        { "text": "Measuring with everyday objects like hands or blocks", "correct": true },
        { "text": "Measuring with a ruler only", "correct": false },
        { "text": "Measuring time with a clock", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which is a non-standard unit of measurement?",
      "answers": [
        { "text": "Paper clips", "correct": true },
        { "text": "Inches", "correct": false },
        { "text": "Centimeters", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. If you measure your desk with pencils, what kind of measurement are you using?",
      "answers": [
        { "text": "Non-standard measurement", "correct": true },
        { "text": "Standard measurement", "correct": false },
        { "text": "Temperature measurement", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which object would NOT be used for non-standard measurement?",
      "answers": [
        { "text": "A ruler", "correct": true },
        { "text": "Blocks", "correct": false },
        { "text": "Crayons", "correct": false }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why do we use non-standard units first when learning to measure?",
      "answers": [
        { "text": "To understand size and comparison before using rulers", "correct": true },
        { "text": "Because rulers don’t work", "correct": false },
        { "text": "So we can measure faster", "correct": false }
      ]
    }
  ]
},
  "north-america-features": {
  "slug": "north-america-features",
  "title": "North America Features",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which river flows into the Gulf of Mexico?",
      "questionImage": "",
      "answers": [
        { "text": "Mississippi River", "correct": true, "image": "" },
        { "text": "Colorado River", "correct": false, "image": "" },
        { "text": "St. Lawrence River", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which river connects the Great Lakes to the Atlantic Ocean?",
      "questionImage": "",
      "answers": [
        { "text": "St. Lawrence River", "correct": true, "image": "" },
        { "text": "Missouri River", "correct": false, "image": "" },
        { "text": "Columbia River", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What kind of mountains are the Appalachian Mountains?",
      "questionImage": "",
      "answers": [
        { "text": "Rounded Mountains", "correct": true, "image": "" },
        { "text": "Pointed Mountains", "correct": false, "image": "" },
        { "text": "Volcanic Mountains", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which natural landmark was carved by the Colorado River?",
      "questionImage": "",
      "answers": [
        { "text": "Grand Canyon", "correct": true, "image": "" },
        { "text": "Great Salt Lake", "correct": false, "image": "" },
        { "text": "Niagara Falls", "correct": false, "image": "" }
      ]
    }
  ]
},
  "ocean": {
  "slug": "ocean",
  "title": "Ocean",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Seawater is mixed with dissolved…",
      "questionImage": "",
      "answers": [
        { "text": "Gases", "correct": true, "image": "" },
        { "text": "Wood", "correct": false, "image": "" },
        { "text": "Glass", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Seawater also contains dissolved…",
      "questionImage": "",
      "answers": [
        { "text": "Solids (salts)", "correct": true, "image": "" },
        { "text": "Feathers", "correct": false, "image": "" },
        { "text": "Paper", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. As you go deeper, ocean temperature usually…",
      "questionImage": "",
      "answers": [
        { "text": "Decreases", "correct": true, "image": "" },
        { "text": "Increases", "correct": false, "image": "" },
        { "text": "Stays the same", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. As you go deeper, water pressure…",
      "questionImage": "",
      "answers": [
        { "text": "Increases", "correct": true, "image": "" },
        { "text": "Disappears", "correct": false, "image": "" },
        { "text": "Drops to zero", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The ocean is a mix of water and dissolved…",
      "questionImage": "",
      "answers": [
        { "text": "Gases & solids", "correct": true, "image": "" },
        { "text": "Smoke", "correct": false, "image": "" },
        { "text": "Plastic", "correct": false, "image": "" }
      ]
    }
  ]
},
  "oldways": {
  "slug": "oldways",
  "title": "Old Ways",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match settlers to what they brought.",
      "options": [
        { "id": "europeans", "text": "Europeans", "image": "", "targetText": "Customs", "targetImage": "" },
        { "id": "africans", "text": "Africans", "image": "", "targetText": "Beliefs", "targetImage": "" },
        { "id": "architecture", "text": "Settlers", "image": "", "targetText": "Architecture", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match groups to contributions.",
      "options": [
        { "id": "europeans2", "text": "Europeans", "image": "", "targetText": "Beliefs", "targetImage": "" },
        { "id": "africans2", "text": "Africans", "image": "", "targetText": "Customs", "targetImage": "" },
        { "id": "settlers2", "text": "Settlers", "image": "", "targetText": "Old ways", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match regions to influences.",
      "options": [
        { "id": "europe3", "text": "Europeans", "image": "", "targetText": "Customs", "targetImage": "" },
        { "id": "africa3", "text": "Africans", "image": "", "targetText": "Architecture", "targetImage": "" },
        { "id": "virginia", "text": "Virginia", "image": "", "targetText": "Mix", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match old ways to settlers.",
      "options": [
        { "id": "beliefs", "text": "Beliefs", "image": "", "targetText": "Europeans", "targetImage": "" },
        { "id": "customs", "text": "Customs", "image": "", "targetText": "Africans", "targetImage": "" },
        { "id": "arch", "text": "Architecture", "image": "", "targetText": "Both", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match contributions to groups.",
      "options": [
        { "id": "euro4", "text": "Europeans", "image": "", "targetText": "Beliefs", "targetImage": "" },
        { "id": "afro4", "text": "Africans", "image": "", "targetText": "Customs", "targetImage": "" },
        { "id": "settle4", "text": "Settlers", "image": "", "targetText": "Architecture", "targetImage": "" }
      ]
    }
  ]
},
  "ordinalnumbers": {
    "slug": "ordinalnumbers",
    "title": "Ordinal Numbers",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What position does 'first' represent?",
        "answers": [
          { "text": "1st", "correct": true },
          { "text": "2nd", "correct": false },
          { "text": "3rd", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If you finish a race in 2nd place, what is your ordinal number?",
        "answers": [
          { "text": "Second", "correct": true },
          { "text": "Third", "correct": false },
          { "text": "First", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which ordinal number comes right after fifth?",
        "answers": [
          { "text": "Sixth", "correct": true },
          { "text": "Fourth", "correct": false },
          { "text": "Seventh", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. If the blue car finished 8th and the red car finished 9th, which car came first?",
        "answers": [
          { "text": "The blue car", "correct": true },
          { "text": "The red car", "correct": false },
          { "text": "They tied", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the ordinal number for the position after tenth?",
        "answers": [
          { "text": "Eleventh", "correct": true },
          { "text": "Ninth", "correct": false },
          { "text": "Twelfth", "correct": false }
        ]
      }
    ]
  },
  "pastandpresent": {
    "slug": "pastandpresent",
    "title": "Past and Present",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. In the past, how were most buildings described in the song?",
        "questionImage": "",
        "answers": [
          { "text": "Smaller", "correct": true, "image": "" },
          { "text": "Taller", "correct": false, "image": "" },
          { "text": "Same size", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. According to the lyrics, how do most people wash clothes in the present?",
        "questionImage": "",
        "answers": [
          { "text": "With machines", "correct": true, "image": "" },
          { "text": "In a river", "correct": false, "image": "" },
          { "text": "By hand", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What tool did people use for writing and typing in the past?",
        "questionImage": "",
        "answers": [
          { "text": "Typewriter", "correct": true, "image": "" },
          { "text": "Tablet", "correct": false, "image": "" },
          { "text": "Phone", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. In the song, what is an invention described as?",
        "questionImage": "",
        "answers": [
          { "text": "A new idea", "correct": true, "image": "" },
          { "text": "A rule", "correct": false, "image": "" },
          { "text": "A holiday", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does the word 'population' mean in the lyrics?",
        "questionImage": "",
        "answers": [
          { "text": "Number of people", "correct": true, "image": "" },
          { "text": "Weather", "correct": false, "image": "" },
          { "text": "Animals", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "photosynthesis": {
    "slug": "photosynthesis",
    "title": "Photosynthesis",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What do plants use to start photosynthesis?",
        "questionImage": "",
        "answers": [
          { "text": "Sunlight", "correct": true, "image": "" },
          { "text": "Moonlight", "correct": false, "image": "" },
          { "text": "Fire", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do roots collect for photosynthesis?",
        "questionImage": "",
        "answers": [
          { "text": "Water", "correct": true, "image": "" },
          { "text": "Sand", "correct": false, "image": "" },
          { "text": "Metal", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What gas do plants take from the air?",
        "questionImage": "",
        "answers": [
          { "text": "Carbon dioxide", "correct": true, "image": "" },
          { "text": "Oxygen", "correct": false, "image": "" },
          { "text": "Helium", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What makes plants green?",
        "questionImage": "",
        "answers": [
          { "text": "Chlorophyll", "correct": true, "image": "" },
          { "text": "Nitrogen", "correct": false, "image": "" },
          { "text": "Salt", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What gas do plants release?",
        "questionImage": "",
        "answers": [
          { "text": "Oxygen", "correct": true, "image": "" },
          { "text": "Carbon dioxide", "correct": false, "image": "" },
          { "text": "Methane", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "pictograph": {
    "slug": "pictograph",
    "title": "Pictograph",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is a pictograph?",
        "answers": [
          { "text": "A chart that uses pictures or symbols to show data", "correct": true },
          { "text": "A graph that uses bars to show numbers", "correct": false },
          { "text": "A graph that shows data with lines", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does each picture or symbol in a pictograph represent?",
        "answers": [
          { "text": "An amount of data", "correct": true },
          { "text": "A color in the graph", "correct": false },
          { "text": "A shape with sides", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the key in a pictograph?",
        "answers": [
          { "text": "It shows what each picture or symbol stands for", "correct": true },
          { "text": "It tells you the title of the graph", "correct": false },
          { "text": "It counts how many pictures there are", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Why are pictographs easy to read?",
        "answers": [
          { "text": "Because they use pictures to show information", "correct": true },
          { "text": "Because they only show numbers", "correct": false },
          { "text": "Because they use no labels", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does a pictograph use to display data?",
        "answers": [
          { "text": "Pictures and symbols", "correct": true },
          { "text": "Lines and shapes", "correct": false },
          { "text": "Words and sentences", "correct": false }
        ]
      }
    ]
  },
  "placevalue": {
    "slug": "placevalue",
    "title": "Place Value",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What does place value tell us?",
        "answers": [
          { "text": "How much a digit is worth based on its place", "correct": true },
          { "text": "The color of the number", "correct": false },
          { "text": "The size of the number", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which place comes after the ones place?",
        "answers": [
          { "text": "Tens place", "correct": true },
          { "text": "Hundreds place", "correct": false },
          { "text": "Thousands place", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which place comes after the tens place?",
        "answers": [
          { "text": "Hundreds place", "correct": true },
          { "text": "Ones place", "correct": false },
          { "text": "Thousands place", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What happens when you move one place to the left?",
        "answers": [
          { "text": "The value becomes 10 times greater", "correct": true },
          { "text": "The value becomes smaller", "correct": false },
          { "text": "Nothing changes", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What comes after the hundreds place?",
        "answers": [
          { "text": "Thousands place", "correct": true },
          { "text": "Ones place", "correct": false },
          { "text": "Tens place", "correct": false }
        ]
      }
    ]
  },
  "plantlifecycle": {
  "slug": "plantlifecycle",
  "title": "Plant Life Cycle",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What protects the seed and the embryo inside?",
      "questionImage": "",
      "answers": [
        { "text": "Seed coat", "correct": true, "image": "" },
        { "text": "Leaf", "correct": false, "image": "" },
        { "text": "Bark", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. During germination, what comes out first and grows down?",
      "questionImage": "",
      "answers": [
        { "text": "The root", "correct": true, "image": "" },
        { "text": "The leaf", "correct": false, "image": "" },
        { "text": "The flower", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which set helps a plant grow?",
      "questionImage": "",
      "answers": [
        { "text": "Water, sun, soil, air", "correct": true, "image": "" },
        { "text": "Candy and paint", "correct": false, "image": "" },
        { "text": "Rocks and metal", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What do we call a small plant with a few leaves?",
      "questionImage": "",
      "answers": [
        { "text": "Seedling", "correct": true, "image": "" },
        { "text": "Sprout", "correct": false, "image": "" },
        { "text": "Seed coat", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What helps plants make more plants?",
      "questionImage": "",
      "answers": [
        { "text": "Pollination", "correct": true, "image": "" },
        { "text": "Hibernation", "correct": false, "image": "" },
        { "text": "Migration", "correct": false, "image": "" }
      ]
    }
  ]
},
  "plantparts": {
    "slug": "plantparts",
    "title": "Plant Parts",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#d4f5b2" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the plant part with its job.",
        "options": [
          { "id": "roots", "text": "Roots", "targetText": "Take in water and hold plant down" },
          { "id": "stem", "text": "Stem", "targetText": "Carries water to leaves" },
          { "id": "leaves", "text": "Leaves", "targetText": "Make food with sunlight" },
          { "id": "flowers", "text": "Flowers", "targetText": "Make seeds" }
        ]
      },
      {
        "question": "Match the plant part with what it makes.",
        "options": [
          { "id": "flower", "text": "Flower", "targetText": "Seeds" },
          { "id": "fruit", "text": "Fruit", "targetText": "Holds the seeds" },
          { "id": "seed", "text": "Seed", "targetText": "Baby plant (embryo)" }
        ]
      },
      {
        "question": "Match the plant part to its place on the plant.",
        "options": [
          { "id": "roots", "text": "Roots", "targetText": "Under the soil" },
          { "id": "stem", "text": "Stem", "targetText": "Middle of the plant" },
          { "id": "leaves", "text": "Leaves", "targetText": "Green and on the sides" },
          { "id": "flowers", "text": "Flowers", "targetText": "Bright colors at the top" }
        ]
      },
      {
        "question": "Match the part to what it needs most.",
        "options": [
          { "id": "roots", "text": "Roots", "targetText": "Soil and water" },
          { "id": "leaves", "text": "Leaves", "targetText": "Sunlight" },
          { "id": "stem", "text": "Stem", "targetText": "To carry food and water" },
          { "id": "seed", "text": "Seed", "targetText": "To grow into new plant" }
        ]
      },
      {
        "question": "Match the plant part to how it helps us.",
        "options": [
          { "id": "fruit", "text": "Fruit", "targetText": "Food we eat" },
          { "id": "leaves", "text": "Leaves", "targetText": "Make oxygen to breathe" },
          { "id": "stem", "text": "Stem", "targetText": "Some are food (celery)" },
          { "id": "flowers", "text": "Flowers", "targetText": "Look pretty and smell nice" }
        ]
      }
    ]
  },
  "plantsandanimalsneedtheirspace": {
    "slug": "plantsandanimalsneedtheirspace",
    "title": "Plants and Animals Need Their Space",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#f2e6ff" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the need with plant or animal.",
        "options": [
          { "id": "plants_sunlight", "text": "Plants need sunlight", "targetText": "To grow" },
          { "id": "plants_bees", "text": "Plants need bees", "targetText": "To spread seeds" },
          { "id": "animals_water", "text": "Animals need water", "targetText": "To drink" },
          { "id": "animals_shelter", "text": "Animals need shelter", "targetText": "To stay safe" }
        ]
      },
      {
        "question": "Match the space with who needs it.",
        "options": [
          { "id": "plants", "text": "Plants", "targetText": "Space to grow" },
          { "id": "animals", "text": "Animals", "targetText": "Space to live and move" }
        ]
      },
      {
        "question": "Match the home with the animal.",
        "options": [
          { "id": "bees", "text": "Bees", "targetText": "Hive" },
          { "id": "ants", "text": "Ants", "targetText": "Ant farm" },
          { "id": "fish", "text": "Fish", "targetText": "Water" },
          { "id": "birds", "text": "Birds", "targetText": "Nest" }
        ]
      },
      {
        "question": "Match the change to what it affects.",
        "options": [
          { "id": "too_hot", "text": "Too hot", "targetText": "Plants dry out" },
          { "id": "no_water", "text": "No water", "targetText": "Animals thirsty" },
          { "id": "no_space", "text": "No space", "targetText": "Plants can’t grow" }
        ]
      },
      {
        "question": "Match the word to the meaning.",
        "options": [
          { "id": "ecosystem", "text": "Ecosystem", "targetText": "Home for plants and animals" },
          { "id": "shelter", "text": "Shelter", "targetText": "Safe place to live" },
          { "id": "sunlight", "text": "Sunlight", "targetText": "Energy from the sun" }
        ]
      }
    ]
  },
  "plateboundaries": {
  "slug": "plateboundaries",
  "title": "Plate Boundaries",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. When plates move together, the boundary is called…",
      "questionImage": "",
      "answers": [
        { "text": "Convergent", "correct": true, "image": "" },
        { "text": "Divergent", "correct": false, "image": "" },
        { "text": "Transform", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When plates move apart, the boundary is called…",
      "questionImage": "",
      "answers": [
        { "text": "Divergent", "correct": true, "image": "" },
        { "text": "Convergent", "correct": false, "image": "" },
        { "text": "Stationary", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When plates slide past each other, the boundary is…",
      "questionImage": "",
      "answers": [
        { "text": "Transform", "correct": true, "image": "" },
        { "text": "Divergent", "correct": false, "image": "" },
        { "text": "Circular", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What often happens at plate boundaries?",
      "questionImage": "",
      "answers": [
        { "text": "Earthquakes & volcanoes", "correct": true, "image": "" },
        { "text": "Rainbows & fog", "correct": false, "image": "" },
        { "text": "Tides & waves only", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Moving apart plates can form undersea…",
      "questionImage": "",
      "answers": [
        { "text": "Mountains/ridges", "correct": true, "image": "" },
        { "text": "Caves in the sky", "correct": false, "image": "" },
        { "text": "Islands of ice cream", "correct": false, "image": "" }
      ]
    }
  ]
},
  "pledge": {
    "slug": "pledge",
    "title": "Pledge",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is the title of the person who leads the United States government?",
        "questionImage": "",
        "answers": [
          { "text": "President", "correct": true, "image": "" },
          { "text": "King", "correct": false, "image": "" },
          { "text": "Duke", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What are the three colors on the flag of the United States?",
        "questionImage": "",
        "answers": [
          { "text": "Red, white, and blue", "correct": true, "image": "" },
          { "text": "Green and gold", "correct": false, "image": "" },
          { "text": "Black and white", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What shapes appear as symbols in the blue field of the flag?",
        "questionImage": "",
        "answers": [
          { "text": "White stars", "correct": true, "image": "" },
          { "text": "Green stars", "correct": false, "image": "" },
          { "text": "No stars", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do we recite together in schools to show love for our country?",
        "questionImage": "",
        "answers": [
          { "text": "Pledge of Allegiance", "correct": true, "image": "" },
          { "text": "National Poem", "correct": false, "image": "" },
          { "text": "Library Oath", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. To whom or what do we give our pledge during the Pledge of Allegiance?",
        "questionImage": "",
        "answers": [
          { "text": "The Flag of the United States", "correct": true, "image": "" },
          { "text": "Our school", "correct": false, "image": "" },
          { "text": "Our town", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "pollution": {
    "slug": "pollution",
    "title": "Pollution",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#ffe6e6" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the kind of pollution to a cause.",
        "options": [
          { "id": "air", "text": "Air pollution", "targetText": "Car exhaust, burning fuel" },
          { "id": "water", "text": "Water pollution", "targetText": "Poison/oil in water" },
          { "id": "soil", "text": "Soil pollution", "targetText": "Weed and bug killers" }
        ]
      },
      {
        "question": "Match the action to help the planet.",
        "options": [
          { "id": "trash_can", "text": "Use a trash can", "targetText": "Keeps ground clean" },
          { "id": "no_litter", "text": "Do not litter", "targetText": "Protects animals" },
          { "id": "plant_tree", "text": "Plant a tree", "targetText": "Helps air be clean" }
        ]
      },
      {
        "question": "Match the problem to what it hurts.",
        "options": [
          { "id": "dirty_air", "text": "Dirty air", "targetText": "Hard to breathe" },
          { "id": "dirty_water", "text": "Dirty water", "targetText": "Fish get sick" },
          { "id": "dirty_soil", "text": "Dirty soil", "targetText": "Plants can’t grow well" }
        ]
      },
      {
        "question": "Match the word to the meaning.",
        "options": [
          { "id": "contaminants", "text": "Contaminants", "targetText": "Harmful things" },
          { "id": "environment", "text": "Environment", "targetText": "Our air, water, and land" }
        ]
      },
      {
        "question": "Match the better choice.",
        "options": [
          { "id": "walk", "text": "Walk or bike", "targetText": "Less air pollution" },
          { "id": "pick_up", "text": "Pick up litter", "targetText": "Cleaner parks" },
          { "id": "stop_pouring", "text": "Don’t pour oil outside", "targetText": "Protects water" }
        ]
      }
    ]
  },
  "polygons": {
    "slug": "polygons",
    "title": "Polygons",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is a polygon?",
        "answers": [
          { "text": "A closed, two-dimensional shape made of straight lines", "correct": true },
          { "text": "A shape made of curves", "correct": false },
          { "text": "A solid, three-dimensional figure", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How do polygons get their names?",
        "answers": [
          { "text": "By the number of sides and angles they have", "correct": true },
          { "text": "By their color", "correct": false },
          { "text": "By their size", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does a triangle have?",
        "answers": [
          { "text": "3", "correct": true },
          { "text": "4", "correct": false },
          { "text": "5", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does a pentagon have?",
        "answers": [
          { "text": "5", "correct": true },
          { "text": "6", "correct": false },
          { "text": "8", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does an octagon have?",
        "answers": [
          { "text": "8", "correct": true },
          { "text": "7", "correct": false },
          { "text": "9", "correct": false }
        ]
      }
    ]
  },
  "precipitation": {
    "slug": "precipitation",
    "title": "Precipitation",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What is precipitation?",
        "answers": [
          { "text": "Rain, sleet, snow, or hail", "correct": true },
          { "text": "Sunshine and clouds", "correct": false },
          { "text": "Wind and air", "correct": false },
          { "text": "Fog only", "correct": false }
        ]
      },
      {
        "question": "What is rain?",
        "answers": [
          { "text": "Water drops falling from the sky", "correct": true },
          { "text": "Tiny rocks", "correct": false },
          { "text": "Sunshine", "correct": false },
          { "text": "Cloud pieces", "correct": false }
        ]
      },
      {
        "question": "What is snow?",
        "answers": [
          { "text": "Soft white ice crystals", "correct": true },
          { "text": "Falling leaves", "correct": false },
          { "text": "Hot steam", "correct": false },
          { "text": "Big water drops", "correct": false }
        ]
      },
      {
        "question": "What is sleet?",
        "answers": [
          { "text": "Small ice pellets", "correct": true },
          { "text": "Windy air", "correct": false },
          { "text": "Warm rain", "correct": false },
          { "text": "Bright light", "correct": false }
        ]
      },
      {
        "question": "What is hail?",
        "answers": [
          { "text": "Large ice balls from clouds", "correct": true },
          { "text": "Tiny water mist", "correct": false },
          { "text": "Falling sand", "correct": false },
          { "text": "Raindrops only at night", "correct": false }
        ]
      }
    ]
  },
  "producer": {
    "slug": "producer",
    "title": "Producer",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each economic role to what it does.",
        "options": [
          { "id": "producer_goods", "text": "Producer", "image": "", "targetText": "Makes goods", "targetImage": "" },
          { "id": "producer_services", "text": "Producer", "image": "", "targetText": "Gives services", "targetImage": "" },
          { "id": "consumer_uses", "text": "Consumer", "image": "", "targetText": "Uses products", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each example to whether it shows a producer or consumer.",
        "options": [
          { "id": "baker", "text": "Baker", "image": "", "targetText": "Producer", "targetImage": "" },
          { "id": "teacher", "text": "Teacher", "image": "", "targetText": "Producer", "targetImage": "" },
          { "id": "shopper", "text": "Shopper", "image": "", "targetText": "Consumer", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each word to what it means in the economy.",
        "options": [
          { "id": "scarcity", "text": "Scarcity", "image": "", "targetText": "Not enough of something", "targetImage": "" },
          { "id": "choice", "text": "Choice", "image": "", "targetText": "Picking one thing", "targetImage": "" },
          { "id": "resource", "text": "Resource", "image": "", "targetText": "Something used to make goods", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each type of resource to what it is used for.",
        "options": [
          { "id": "human_resource", "text": "Human", "image": "", "targetText": "Workers and skills", "targetImage": "" },
          { "id": "natural_resource", "text": "Natural", "image": "", "targetText": "From nature", "targetImage": "" },
          { "id": "capital_resource", "text": "Capital", "image": "", "targetText": "Tools and machines", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each concept to what it helps people do in the economy.",
        "options": [
          { "id": "buy_sell", "text": "Buy and sell", "image": "", "targetText": "Trade goods", "targetImage": "" },
          { "id": "save_spend", "text": "Save and spend", "image": "", "targetText": "Use money", "targetImage": "" },
          { "id": "work_earn", "text": "Work and earn", "image": "", "targetText": "Make income", "targetImage": "" }
        ]
      }
    ]
  },
  "puebloandlakota": {
    "slug": "puebloandlakota",
    "title": "Pueblo and Lakota",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each Native group to the region where they lived.",
        "options": [
          { "id": "pueblo", "text": "Pueblo", "image": "", "targetText": "Southwest", "targetImage": "" },
          { "id": "lakota", "text": "Lakota", "image": "", "targetText": "Plains", "targetImage": "" },
          { "id": "powhatan", "text": "Powhatan", "image": "", "targetText": "Eastern Woodlands", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each group to the type of homes they built.",
        "options": [
          { "id": "pueblo_home", "text": "Pueblo", "image": "", "targetText": "Clay homes", "targetImage": "" },
          { "id": "lakota_home", "text": "Lakota", "image": "", "targetText": "Teepees", "targetImage": "" },
          { "id": "powhatan_home", "text": "Powhatan", "image": "", "targetText": "Wood houses", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each group to the kind of work they did.",
        "options": [
          { "id": "pueblo_work", "text": "Pueblo", "image": "", "targetText": "Farmed and hunted", "targetImage": "" },
          { "id": "lakota_work", "text": "Lakota", "image": "", "targetText": "Hunted buffalo", "targetImage": "" },
          { "id": "powhatan_work", "text": "Powhatan", "image": "", "targetText": "Fished and farmed", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each group to their main way of travel.",
        "options": [
          { "id": "pueblo_travel", "text": "Pueblo", "image": "", "targetText": "Walked", "targetImage": "" },
          { "id": "lakota_travel", "text": "Lakota", "image": "", "targetText": "Rode horses", "targetImage": "" },
          { "id": "powhatan_travel", "text": "Powhatan", "image": "", "targetText": "Canoes", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each art or craft to the group known for it.",
        "options": [
          { "id": "pueblo_art", "text": "Pottery", "image": "", "targetText": "Pueblo", "targetImage": "" },
          { "id": "lakota_art", "text": "Beadwork", "image": "", "targetText": "Lakota", "targetImage": "" },
          { "id": "powhatan_art", "text": "Carving", "image": "", "targetText": "Powhatan", "targetImage": "" }
        ]
      }
    ]
  },
  "quadrilaterals": {
    "slug": "quadrilaterals",
    "title": "Quadrilaterals",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is a quadrilateral?",
        "answers": [
          { "text": "A polygon with four sides", "correct": true },
          { "text": "A polygon with three sides", "correct": false },
          { "text": "A shape with five sides", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does a quadrilateral have?",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "3", "correct": false },
          { "text": "5", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What makes a rectangle a quadrilateral?",
        "answers": [
          { "text": "It has four right angles and opposite sides equal", "correct": true },
          { "text": "It has all sides equal but no right angles", "correct": false },
          { "text": "It has only three sides", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What makes a square different from a rectangle?",
        "answers": [
          { "text": "All four sides of a square are equal", "correct": true },
          { "text": "A square has only one pair of parallel sides", "correct": false },
          { "text": "A square has no right angles", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What defines a parallelogram?",
        "answers": [
          { "text": "A shape with two pairs of parallel sides", "correct": true },
          { "text": "A shape with three equal sides", "correct": false },
          { "text": "A shape with all right angles", "correct": false }
        ]
      }
    ]
  },
  "reconstruction": {
  "slug": "reconstruction",
  "title": "Reconstruction",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What period followed the Civil War?",
      "questionImage": "",
      "answers": [
        { "text": "Reconstruction", "correct": true, "image": "" },
        { "text": "Depression", "correct": false, "image": "" },
        { "text": "Colonial", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What was destroyed in Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Railroads", "correct": true, "image": "" },
        { "text": "Airports", "correct": false, "image": "" },
        { "text": "Skyscrapers", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What helped freed African Americans?",
      "questionImage": "",
      "answers": [
        { "text": "Freedmen’s Bureau", "correct": true, "image": "" },
        { "text": "Congress", "correct": false, "image": "" },
        { "text": "Supreme Court", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the Freedmen’s Bureau provide?",
      "questionImage": "",
      "answers": [
        { "text": "Food and schools", "correct": true, "image": "" },
        { "text": "Weapons", "correct": false, "image": "" },
        { "text": "Taxes", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What else did the economy lose?",
      "questionImage": "",
      "answers": [
        { "text": "Crops", "correct": true, "image": "" },
        { "text": "Oceans", "correct": false, "image": "" },
        { "text": "Mines", "correct": false, "image": "" }
      ]
    }
  ]
},
  "reducereuseandrecycle": {
    "slug": "reducereuseandrecycle",
    "title": "Reduce, Reuse, and Recycle",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What does “reduce” mean?",
        "answers": [
          { "text": "Use less so we make less trash", "correct": true },
          { "text": "Throw more away", "correct": false },
          { "text": "Make bigger bags", "correct": false },
          { "text": "Break things", "correct": false }
        ]
      },
      {
        "question": "What does “reuse” mean?",
        "answers": [
          { "text": "Use something again", "correct": true },
          { "text": "Throw it away right away", "correct": false },
          { "text": "Hide it in a drawer", "correct": false },
          { "text": "Buy a new one every time", "correct": false }
        ]
      },
      {
        "question": "What does “recycle” mean?",
        "answers": [
          { "text": "Turn old things into new things", "correct": true },
          { "text": "Put trash on the ground", "correct": false },
          { "text": "Burn everything", "correct": false },
          { "text": "Keep it forever", "correct": false }
        ]
      },
      {
        "question": "Which is a good way to reduce?",
        "answers": [
          { "text": "Say no to extra store bags", "correct": true },
          { "text": "Use five cups for one drink", "correct": false },
          { "text": "Take more napkins than you need", "correct": false },
          { "text": "Leave lights on all day", "correct": false }
        ]
      },
      {
        "question": "Which can you recycle?",
        "answers": [
          { "text": "Paper and many plastics", "correct": true },
          { "text": "Leftover soup", "correct": false },
          { "text": "Banana peels", "correct": false },
          { "text": "Sand", "correct": false }
        ]
      }
    ]
  },
  "reflection": {
  "slug": "reflection",
  "title": "Reflection",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Reflection happens when light?",
      "questionImage": "",
      "answers": [
        { "text": "Bounces", "correct": true, "image": "" },
        { "text": "Bends", "correct": false, "image": "" },
        { "text": "Stops", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Smooth surfaces cause?",
      "questionImage": "",
      "answers": [
        { "text": "More reflection", "correct": true, "image": "" },
        { "text": "Less light", "correct": false, "image": "" },
        { "text": "No light", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Rough surfaces cause?",
      "questionImage": "",
      "answers": [
        { "text": "Scattering", "correct": true, "image": "" },
        { "text": "Clear mirror", "correct": false, "image": "" },
        { "text": "Absorption", "correct": false, "image": "" }
      ]
    }
  ]
},
  "refraction": {
  "slug": "refraction",
  "title": "Refraction",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Refraction is when light?",
      "questionImage": "",
      "answers": [
        { "text": "Bends", "correct": true, "image": "" },
        { "text": "Bounces", "correct": false, "image": "" },
        { "text": "Stops", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Light bends when moving from air to?",
      "questionImage": "",
      "answers": [
        { "text": "Water", "correct": true, "image": "" },
        { "text": "Sky", "correct": false, "image": "" },
        { "text": "Mirror", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Light speeds up when returning to?",
      "questionImage": "",
      "answers": [
        { "text": "Air", "correct": true, "image": "" },
        { "text": "Metal", "correct": false, "image": "" },
        { "text": "Soil", "correct": false, "image": "" }
      ]
    }
  ]
},
  "resources": {
  "slug": "resources",
  "title": "Resources",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What kinds of foods did most people use in Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Local produce", "correct": true, "image": "" },
        { "text": "Imported fruit", "correct": false, "image": "" },
        { "text": "Canned meals", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What kinds of meat did they use?",
      "questionImage": "",
      "answers": [
        { "text": "Local meats", "correct": true, "image": "" },
        { "text": "Exotic fish", "correct": false, "image": "" },
        { "text": "No meat at all", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What type of homes did most people live in?",
      "questionImage": "",
      "answers": [
        { "text": "One-room homes", "correct": true, "image": "" },
        { "text": "Large mansions", "correct": false, "image": "" },
        { "text": "Stone castles", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What cloth did many people use for clothing?",
      "questionImage": "",
      "answers": [
        { "text": "Cotton", "correct": true, "image": "" },
        { "text": "Silk", "correct": false, "image": "" },
        { "text": "Nylon", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What other materials were used to make clothes?",
      "questionImage": "",
      "answers": [
        { "text": "Wool and leather", "correct": true, "image": "" },
        { "text": "Plastic", "correct": false, "image": "" },
        { "text": "Rubber", "correct": false, "image": "" }
      ]
    }
  ]
},
  "responsiblecitizen": {
    "slug": "responsiblecitizen",
    "title": "Responsible Citizen",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. According to the song, what should responsible citizens do about laws?",
        "questionImage": "",
        "answers": [
          { "text": "Obey laws", "correct": true, "image": "" },
          { "text": "Break laws", "correct": false, "image": "" },
          { "text": "Ignore laws", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When called for a civic duty, which role might a citizen serve?",
        "questionImage": "",
        "answers": [
          { "text": "Serve on a jury", "correct": true, "image": "" },
          { "text": "Attend a picnic", "correct": false, "image": "" },
          { "text": "Go to a parade", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What regular duty do responsible citizens pay as mentioned in the lyrics?",
        "questionImage": "",
        "answers": [
          { "text": "Pay taxes", "correct": true, "image": "" },
          { "text": "Skip taxes", "correct": false, "image": "" },
          { "text": "Hide taxes", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When might responsible citizens serve in the armed forces according to the song?",
        "questionImage": "",
        "answers": [
          { "text": "If called to serve", "correct": true, "image": "" },
          { "text": "Only on weekends", "correct": false, "image": "" },
          { "text": "Never", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What should each of us aim to be based on the chorus?",
        "questionImage": "",
        "answers": [
          { "text": "A responsible citizen", "correct": true, "image": "" },
          { "text": "A careless driver", "correct": false, "image": "" },
          { "text": "A litter bug", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "rivers": {
  "slug": "rivers",
  "title": "Rivers",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each river to a city.",
      "options": [
        { "id": "potomac", "text": "Potomac", "image": "", "targetText": "Alexandria", "targetImage": "" },
        { "id": "rapp", "text": "Rappahannock", "image": "", "targetText": "Fredericksburg", "targetImage": "" },
        { "id": "york", "text": "York", "image": "", "targetText": "Yorktown", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match rivers to other cities.",
      "options": [
        { "id": "james", "text": "James", "image": "", "targetText": "Richmond/Jamestown", "targetImage": "" },
        { "id": "potomac2", "text": "Potomac", "image": "", "targetText": "Alexandria", "targetImage": "" },
        { "id": "rapp2", "text": "Rappahannock", "image": "", "targetText": "Fredericksburg", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match rivers to where they flow.",
      "options": [
        { "id": "potomac3", "text": "Potomac", "image": "", "targetText": "Chesapeake Bay", "targetImage": "" },
        { "id": "york2", "text": "York", "image": "", "targetText": "Chesapeake Bay", "targetImage": "" },
        { "id": "james2", "text": "James", "image": "", "targetText": "Chesapeake Bay", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match rivers to their uses.",
      "options": [
        { "id": "food", "text": "Food", "image": "", "targetText": "Rivers gave", "targetImage": "" },
        { "id": "pathway", "text": "Pathway", "image": "", "targetText": "Exploration", "targetImage": "" },
        { "id": "potomac4", "text": "Potomac", "image": "", "targetText": "City location", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match James, York, and Rappahannock.",
      "options": [
        { "id": "james3", "text": "James", "image": "", "targetText": "River", "targetImage": "" },
        { "id": "york3", "text": "York", "image": "", "targetText": "River", "targetImage": "" },
        { "id": "rapp3", "text": "Rappahannock", "image": "", "targetText": "River", "targetImage": "" }
      ]
    }
  ]
},
  "rockcycle": {
  "slug": "rockcycle",
  "title": "Rock Cycle",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Cooling magma makes which rock?",
      "questionImage": "",
      "answers": [
        { "text": "Igneous", "correct": true, "image": "" },
        { "text": "Sedimentary", "correct": false, "image": "" },
        { "text": "Metamorphic", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Bits of rock pressed in layers form what?",
      "questionImage": "",
      "answers": [
        { "text": "Sedimentary", "correct": true, "image": "" },
        { "text": "Igneous", "correct": false, "image": "" },
        { "text": "Metal", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Heat and pressure deep underground form which rock?",
      "questionImage": "",
      "answers": [
        { "text": "Metamorphic", "correct": true, "image": "" },
        { "text": "Clay", "correct": false, "image": "" },
        { "text": "Igneous", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What does the rock cycle show?",
      "questionImage": "",
      "answers": [
        { "text": "Rocks keep changing", "correct": true, "image": "" },
        { "text": "Rocks never change", "correct": false, "image": "" },
        { "text": "Only one rock exists", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When magma cools slowly, what forms inside the rock?",
      "questionImage": "",
      "answers": [
        { "text": "Crystals", "correct": true, "image": "" },
        { "text": "Fossils", "correct": false, "image": "" },
        { "text": "Clouds", "correct": false, "image": "" }
      ]
    }
  ]
},
  "seasons": {
    "slug": "seasons",
    "title": "Seasons",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#fff0f5" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the season to the month feeling.",
        "options": [
          { "id": "spring", "text": "Spring", "targetText": "Warmer, plants grow" },
          { "id": "summer", "text": "Summer", "targetText": "Hottest days" },
          { "id": "fall", "text": "Fall (Autumn)", "targetText": "Cooler, leaves fall" },
          { "id": "winter", "text": "Winter", "targetText": "Coldest days" }
        ]
      },
      {
        "question": "Match the activity to the best season.",
        "options": [
          { "id": "snowman", "text": "Build a snowman", "targetText": "Winter" },
          { "id": "swim", "text": "Go swimming", "targetText": "Summer" },
          { "id": "leafpile", "text": "Jump in leaf piles", "targetText": "Fall" },
          { "id": "plant", "text": "Plant seeds", "targetText": "Spring" }
        ]
      },
      {
        "question": "Match the season to what we wear.",
        "options": [
          { "id": "coat", "text": "Big coat", "targetText": "Winter" },
          { "id": "tshirt", "text": "T-shirt and shorts", "targetText": "Summer" },
          { "id": "rainboots", "text": "Rain boots", "targetText": "Spring" },
          { "id": "sweater", "text": "Sweater", "targetText": "Fall" }
        ]
      },
      {
        "question": "Match the word to the idea.",
        "options": [
          { "id": "tilt", "text": "Tilt of Earth", "targetText": "Helps make seasons" },
          { "id": "daylength", "text": "Day length", "targetText": "More sun in summer" }
        ]
      },
      {
        "question": "Match the picture idea to the season.",
        "options": [
          { "id": "flowers", "text": "Flowers blooming", "targetText": "Spring" },
          { "id": "beach", "text": "Beach and sun", "targetText": "Summer" },
          { "id": "leaves", "text": "Orange leaves", "targetText": "Fall" },
          { "id": "snow", "text": "Snowflakes", "targetText": "Winter" }
        ]
      }
    ]
  },
  "settled": {
    "slug": "settled",
    "title": "Settled",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      { 
        "question": "Read the question, then choose the correct answer. In what year was the first permanent English settlement at Jamestown established?",
        "questionImage": "",
        "answers": [
          { "text": "1607", "correct": true, "image": "" },
          { "text": "1776", "correct": false, "image": "" },
          { "text": "1492", "correct": false, "image": "" }
        ]
      },
      { 
        "question": "Read the question, then choose the correct answer. What was the main goal of the settlers who started Jamestown?",
        "questionImage": "",
        "answers": [
          { "text": "To find wealth", "correct": true, "image": "" },
          { "text": "To play sports", "correct": false, "image": "" },
          { "text": "To make art", "correct": false, "image": "" }
        ]
      },
      { 
        "question": "Read the question, then choose the correct answer. What valuable resources did many Jamestown settlers hope to find?",
        "questionImage": "",
        "answers": [
          { "text": "Gold and silver", "correct": true, "image": "" },
          { "text": "Spices", "correct": false, "image": "" },
          { "text": "Tea", "correct": false, "image": "" }
        ]
      },
      { 
        "question": "Read the question, then choose the correct answer. What kind of landform was chosen for the Jamestown settlement site?",
        "questionImage": "",
        "answers": [
          { "text": "Peninsula", "correct": true, "image": "" },
          { "text": "Island", "correct": false, "image": "" },
          { "text": "Desert", "correct": false, "image": "" }
        ]
      },
      { 
        "question": "Read the question, then choose the correct answer. Which company paid for the trip to start the Jamestown colony?",
        "questionImage": "",
        "answers": [
          { "text": "Virginia Company", "correct": true, "image": "" },
          { "text": "Parliament", "correct": false, "image": "" },
          { "text": "Colonists", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "settlersandnatives": {
  "slug": "settlersandnatives",
  "title": "Settlers and Natives",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match who taught survival skills.",
      "options": [
        { "id": "powhatan", "text": "Chief Powhatan", "image": "", "targetText": "Survival skills", "targetImage": "" },
        { "id": "pocahontas", "text": "Pocahontas", "image": "", "targetText": "Contact", "targetImage": "" },
        { "id": "johnsmith", "text": "John Smith", "image": "", "targetText": "Trade began", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match what settlers learned.",
      "options": [
        { "id": "corn", "text": "Plant corn", "image": "", "targetText": "From Natives", "targetImage": "" },
        { "id": "skills", "text": "Survival", "image": "", "targetText": "From Powhatan", "targetImage": "" },
        { "id": "contact", "text": "Pocahontas", "image": "", "targetText": "Contact", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match what the Natives traded.",
      "options": [
        { "id": "tools", "text": "Tools", "image": "", "targetText": "For food", "targetImage": "" },
        { "id": "copper", "text": "Copper", "image": "", "targetText": "For goods", "targetImage": "" },
        { "id": "english", "text": "English", "image": "", "targetText": "Trade partner", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match Native groups with exchanges.",
      "options": [
        { "id": "powhatan2", "text": "Powhatan", "image": "", "targetText": "Skills", "targetImage": "" },
        { "id": "pocahontas2", "text": "Pocahontas", "image": "", "targetText": "Contact", "targetImage": "" },
        { "id": "settlers", "text": "Settlers", "image": "", "targetText": "Learned corn", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the matching item from the bottom row (B). Match leaders to their roles.",
      "options": [
        { "id": "powhatan3", "text": "Powhatan", "image": "", "targetText": "Chief", "targetImage": "" },
        { "id": "pocahontas3", "text": "Pocahontas", "image": "", "targetText": "Daughter", "targetImage": "" },
        { "id": "johnsmith2", "text": "John Smith", "image": "", "targetText": "Captain", "targetImage": "" }
      ]
    }
  ]
},
  "settlersmoving": {
  "slug": "settlersmoving",
  "title": "Settlers Moving",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. When did many settlers move west?",
      "questionImage": "",
      "answers": [
        { "text": "1801–1861", "correct": true, "image": "" },
        { "text": "1700–1750", "correct": false, "image": "" },
        { "text": "1900–1920", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What land did settlers seek?",
      "questionImage": "",
      "answers": [
        { "text": "Cheap/fertile", "correct": true, "image": "" },
        { "text": "Rocky", "correct": false, "image": "" },
        { "text": "Frozen", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What helped people move faster?",
      "questionImage": "",
      "answers": [
        { "text": "Rivers/canals", "correct": true, "image": "" },
        { "text": "Footpaths", "correct": false, "image": "" },
        { "text": "Sand dunes", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which was an economic reason?",
      "questionImage": "",
      "answers": [
        { "text": "Gold Rush", "correct": true, "image": "" },
        { "text": "Snowballing", "correct": false, "image": "" },
        { "text": "Kite flying", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What belief supported expansion?",
      "questionImage": "",
      "answers": [
        { "text": "Good for country", "correct": true, "image": "" },
        { "text": "Bad idea", "correct": false, "image": "" },
        { "text": "Stay put", "correct": false, "image": "" }
      ]
    }
  ]
},
  "shapes": {
    "slug": "shapes",
    "title": "Shapes",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. How many sides does a triangle have?",
        "answers": [
          { "text": "3", "correct": true },
          { "text": "4", "correct": false },
          { "text": "5", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does a rectangle have?",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "3", "correct": false },
          { "text": "5", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does a square have?",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "6", "correct": false },
          { "text": "8", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does a pentagon have?",
        "answers": [
          { "text": "5", "correct": true },
          { "text": "6", "correct": false },
          { "text": "4", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How many sides does an octagon have?",
        "answers": [
          { "text": "8", "correct": true },
          { "text": "6", "correct": false },
          { "text": "5", "correct": false }
        ]
      }
    ]
  },
  "shortlonglinethemup": {
    "slug": "shortlonglinethemup",
    "title": "Short, Long, Line Them Up",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "A red straw is 5 paperclips long. A blue straw is 3 paperclips long. Which is longer?",
        "answers": [
          { "text": "Red straw", "correct": true },
          { "text": "Blue straw", "correct": false },
          { "text": "They’re the same", "correct": false },
          { "text": "Not enough info", "correct": false }
        ]
      },
      {
        "question": "Put these by length (short to long): 2, 4, 3 units.",
        "answers": [
          { "text": "2, 3, 4", "correct": true },
          { "text": "4, 3, 2", "correct": false },
          { "text": "3, 2, 4", "correct": false },
          { "text": "2, 4, 3", "correct": false }
        ]
      },
      {
        "question": "Two lines start at the same point. The one that reaches farther is ____.",
        "answers": [
          { "text": "longer", "correct": true },
          { "text": "shorter", "correct": false },
          { "text": "the same", "correct": false },
          { "text": "curved", "correct": false }
        ]
      }
    ]
  },
  "sides": {
  "slug": "sides",
  "title": "Sides",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each group to its position during the Revolution.",
      "options": [
        { "id": "patriots", "text": "Patriots", "image": "", "targetText": "Independence", "targetImage": "" },
        { "id": "loyalists", "text": "Loyalists", "image": "", "targetText": "Great Britain", "targetImage": "" },
        { "id": "neutrals", "text": "Neutrals", "image": "", "targetText": "No side", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each group to the force they supported.",
      "options": [
        { "id": "patriots2", "text": "Patriots", "image": "", "targetText": "Continental Army", "targetImage": "" },
        { "id": "loyalists2", "text": "Loyalists", "image": "", "targetText": "British Crown", "targetImage": "" },
        { "id": "neutrals2", "text": "Neutrals", "image": "", "targetText": "Undecided", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each description to the correct group.",
      "options": [
        { "id": "fought", "text": "Fought Britain", "image": "", "targetText": "Patriots", "targetImage": "" },
        { "id": "stayed", "text": "Stayed loyal to the king", "image": "", "targetText": "Loyalists", "targetImage": "" },
        { "id": "neither", "text": "Did not choose a side", "image": "", "targetText": "Neutrals", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each goal to the group that wanted it.",
      "options": [
        { "id": "freedom", "text": "Independence", "image": "", "targetText": "Patriots", "targetImage": "" },
        { "id": "king", "text": "Support the king", "image": "", "targetText": "Loyalists", "targetImage": "" },
        { "id": "peace", "text": "Avoid war", "image": "", "targetText": "Neutrals", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row (A) and drop it on the item from the bottom row (B) that matches. Match each side to its allegiance.",
      "options": [
        { "id": "usa", "text": "New nation", "image": "", "targetText": "Patriots", "targetImage": "" },
        { "id": "gb", "text": "Great Britain", "image": "", "targetText": "Loyalists", "targetImage": "" },
        { "id": "none", "text": "No allegiance", "image": "", "targetText": "Neutrals", "targetImage": "" }
      ]
    }
  ]
},
  "simplemachines": {
    "slug": "simplemachines",
    "title": "Simple Machines",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each machine to what it does.",
        "options": [
          { "id": "lever", "text": "Lever", "image": "", "targetText": "Helps lift with a bar", "targetImage": "" },
          { "id": "pulley", "text": "Pulley", "image": "", "targetText": "Lifts with rope & wheel", "targetImage": "" },
          { "id": "wheelaxle", "text": "Wheel & axle", "image": "", "targetText": "Rolls to move loads", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match the name to the example.",
        "options": [
          { "id": "incline", "text": "Inclined plane", "image": "", "targetText": "Ramp", "targetImage": "" },
          { "id": "wedge", "text": "Wedge", "image": "", "targetText": "Doorstop/axe head", "targetImage": "" },
          { "id": "screw", "text": "Screw", "image": "", "targetText": "Jar lid/bolt", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each machine to its job.",
        "options": [
          { "id": "wedgeJob", "text": "Wedge", "image": "", "targetText": "Splits or cuts", "targetImage": "" },
          { "id": "inclineJob", "text": "Inclined plane", "image": "", "targetText": "Moves up with less force", "targetImage": "" },
          { "id": "wheelJob", "text": "Wheel & axle", "image": "", "targetText": "Reduces friction", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match parts to the machine.",
        "options": [
          { "id": "rope", "text": "Rope", "image": "", "targetText": "Pulley", "targetImage": "" },
          { "id": "fulcrum", "text": "Fulcrum", "image": "", "targetText": "Lever", "targetImage": "" },
          { "id": "threads", "text": "Threads", "image": "", "targetText": "Screw", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each machine to a simple picture idea.",
        "options": [
          { "id": "seesaw", "text": "Seesaw", "image": "", "targetText": "Lever", "targetImage": "" },
          { "id": "flagpole", "text": "Flagpole", "image": "", "targetText": "Pulley", "targetImage": "" },
          { "id": "roller", "text": "Roller", "image": "", "targetText": "Wheel & axle", "targetImage": "" }
        ]
      }
    ]
  },
  "soil": {
    "slug": "soil",
    "title": "Soil",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Soil is a mixture of…",
        "questionImage": "",
        "answers": [
          { "text": "Organic matter, air, water", "correct": true, "image": "" },
          { "text": "Only rocks", "correct": false, "image": "" },
          { "text": "Only sand", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does soil give to plants?",
        "questionImage": "",
        "answers": [
          { "text": "Nutrients", "correct": true, "image": "" },
          { "text": "Music", "correct": false, "image": "" },
          { "text": "Wings", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What breaks down dead things in soil?",
        "questionImage": "",
        "answers": [
          { "text": "Microbes", "correct": true, "image": "" },
          { "text": "Clouds", "correct": false, "image": "" },
          { "text": "Stars", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Animals use soil for…",
        "questionImage": "",
        "answers": [
          { "text": "Homes", "correct": true, "image": "" },
          { "text": "Flying", "correct": false, "image": "" },
          { "text": "Swimming", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What causes rocks to break into soil?",
        "questionImage": "",
        "answers": [
          { "text": "Weathering", "correct": true, "image": "" },
          { "text": "Cooking", "correct": false, "image": "" },
          { "text": "Painting", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "soilsoilwhatcanyoudo": {
    "slug": "soilsoilwhatcanyoudo",
    "title": "Soil Soil What Can You Do",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Sandy soil is…",
        "questionImage": "",
        "answers": [
          { "text": "Loose and light", "correct": true, "image": "" },
          { "text": "Heavy", "correct": false, "image": "" },
          { "text": "Sticky", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Sandy soil holds…",
        "questionImage": "",
        "answers": [
          { "text": "Little water", "correct": true, "image": "" },
          { "text": "Lots of air", "correct": false, "image": "" },
          { "text": "No sand", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Clay soil is…",
        "questionImage": "",
        "answers": [
          { "text": "Heavy and sticky", "correct": true, "image": "" },
          { "text": "Very loose", "correct": false, "image": "" },
          { "text": "Always dry", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. The best soil for plants is…",
        "questionImage": "",
        "answers": [
          { "text": "Loam", "correct": true, "image": "" },
          { "text": "Clay", "correct": false, "image": "" },
          { "text": "Sand", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Loam usually…",
        "questionImage": "",
        "answers": [
          { "text": "Holds and drains", "correct": true, "image": "" },
          { "text": "Blocks air", "correct": false, "image": "" },
          { "text": "Has no nutrients", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "soundvibration": {
  "slug": "soundvibration",
  "title": "Sound Vibration",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Sound comes from?",
      "questionImage": "",
      "answers": [
        { "text": "Vibration", "correct": true, "image": "" },
        { "text": "Reflection", "correct": false, "image": "" },
        { "text": "Refraction", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Plucking a guitar string shows?",
      "questionImage": "",
      "answers": [
        { "text": "Vibration makes sound", "correct": true, "image": "" },
        { "text": "Light bends", "correct": false, "image": "" },
        { "text": "Heat forms", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Your vocal cords produce sound by?",
      "questionImage": "",
      "answers": [
        { "text": "Vibrating", "correct": true, "image": "" },
        { "text": "Cooling", "correct": false, "image": "" },
        { "text": "Stretching", "correct": false, "image": "" }
      ]
    }
  ]
},
  "south-america-features": {
    "slug": "south-america-features",
    "title": "South America Features",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Which is the second longest river in the world that flows through South America?",
        "questionImage": "",
        "answers": [
          { "text": "Amazon River", "correct": true, "image": "" },
          { "text": "Nile River", "correct": false, "image": "" },
          { "text": "Mississippi River", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What are the Andes Mountains known for?",
        "questionImage": "",
        "answers": [
          { "text": "Being the longest mountain range in the world", "correct": true, "image": "" },
          { "text": "Being the tallest mountain in the world", "correct": false, "image": "" },
          { "text": "Being a small group of hills", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is the largest rainforest in the world located in South America?",
        "questionImage": "",
        "answers": [
          { "text": "Amazon Rainforest", "correct": true, "image": "" },
          { "text": "Congo Rainforest", "correct": false, "image": "" },
          { "text": "Taiga Forest", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which desert in South America is one of the driest places on Earth?",
        "questionImage": "",
        "answers": [
          { "text": "Atacama Desert", "correct": true, "image": "" },
          { "text": "Sahara Desert", "correct": false, "image": "" },
          { "text": "Kalahari Desert", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which highland area is home to the Inca civilization’s famous site Machu Picchu?",
        "questionImage": "",
        "answers": [
          { "text": "Andes Mountains", "correct": true, "image": "" },
          { "text": "Rocky Mountains", "correct": false, "image": "" },
          { "text": "Himalayas", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "suntopluto": {
  "slug": "suntopluto",
  "title": "Sun to Pluto",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each planet to a fact (set 1).",
      "options": [
        { "id": "mercury", "text": "Mercury", "image": "", "targetText": "Closest to Sun", "targetImage": "" },
        { "id": "venus", "text": "Venus", "image": "", "targetText": "Thick clouds", "targetImage": "" },
        { "id": "earth", "text": "Earth", "image": "", "targetText": "One moon", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each planet to a fact (set 2).",
      "options": [
        { "id": "mars", "text": "Mars", "image": "", "targetText": "Red planet", "targetImage": "" },
        { "id": "jupiter", "text": "Jupiter", "image": "", "targetText": "Biggest planet", "targetImage": "" },
        { "id": "saturn", "text": "Saturn", "image": "", "targetText": "Rings", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match each planet to a fact (set 3).",
      "options": [
        { "id": "uranus", "text": "Uranus", "image": "", "targetText": "Tilts on side", "targetImage": "" },
        { "id": "neptune", "text": "Neptune", "image": "", "targetText": "Strong winds", "targetImage": "" },
        { "id": "pluto", "text": "Pluto", "image": "", "targetText": "Dwarf planet", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match object to role or place.",
      "options": [
        { "id": "sun", "text": "Sun", "image": "", "targetText": "Gives energy", "targetImage": "" },
        { "id": "mercury2", "text": "Mercury", "image": "", "targetText": "Smallest planet", "targetImage": "" },
        { "id": "venus2", "text": "Venus", "image": "", "targetText": "2nd from Sun", "targetImage": "" }
      ]
    },
    {
      "question": "Drag or tap any item from the top row (A) and drop it on the matching item in the bottom row (B). Match more facts.",
      "options": [
        { "id": "earth2", "text": "Earth", "image": "", "targetText": "Water & land", "targetImage": "" },
        { "id": "jupiter2", "text": "Jupiter", "image": "", "targetText": "Red Spot storm", "targetImage": "" },
        { "id": "mars2", "text": "Mars", "image": "", "targetText": "4th planet", "targetImage": "" }
      ]
    }
  ]
},
  "surfacechange": {
  "slug": "surfacechange",
  "title": "Surface Change",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which process breaks rocks into smaller pieces over time?",
      "questionImage": "",
      "answers": [
        { "text": "Weathering", "correct": true, "image": "" },
        { "text": "Melting", "correct": false, "image": "" },
        { "text": "Boiling", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which process moves broken rock and soil from place to place?",
      "questionImage": "",
      "answers": [
        { "text": "Erosion", "correct": true, "image": "" },
        { "text": "Welding", "correct": false, "image": "" },
        { "text": "Painting", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which type of weathering happens when water dissolves minerals in rock?",
      "questionImage": "",
      "answers": [
        { "text": "Chemical weathering", "correct": true, "image": "" },
        { "text": "Mechanical weathering", "correct": false, "image": "" },
        { "text": "Musical weathering", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. When ice or moving water breaks rock apart, what kind of weathering is this?",
      "questionImage": "",
      "answers": [
        { "text": "Mechanical weathering", "correct": true, "image": "" },
        { "text": "Chemical weathering", "correct": false, "image": "" },
        { "text": "Magnetic weathering", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What usually forms a canyon over a long time?",
      "questionImage": "",
      "answers": [
        { "text": "River erosion", "correct": true, "image": "" },
        { "text": "An earthquake", "correct": false, "image": "" },
        { "text": "Lightning", "correct": false, "image": "" }
      ]
    }
  ]
},
  "survivingseasons": {
  "slug": "survivingseasons",
  "title": "Surviving Seasons",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What did Virginia Indians hunt during the winter?",
      "questionImage": "",
      "answers": [
        { "text": "Birds and other animals", "correct": true, "image": "" },
        { "text": "Corn", "correct": false, "image": "" },
        { "text": "Squash", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What foods were gathered in the spring?",
      "questionImage": "",
      "answers": [
        { "text": "Fish and berries", "correct": true, "image": "" },
        { "text": "Snow and ice", "correct": false, "image": "" },
        { "text": "Sand and shells", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What crops were grown during the summer?",
      "questionImage": "",
      "answers": [
        { "text": "Beans and corn", "correct": true, "image": "" },
        { "text": "Rice", "correct": false, "image": "" },
        { "text": "Apples", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did they do in the fall?",
      "questionImage": "",
      "answers": [
        { "text": "Harvest crops", "correct": true, "image": "" },
        { "text": "Build houses", "correct": false, "image": "" },
        { "text": "Sail ships", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did Virginia Indians store to survive the winter months?",
      "questionImage": "",
      "answers": [
        { "text": "Food", "correct": true, "image": "" },
        { "text": "Wood", "correct": false, "image": "" },
        { "text": "Clothing", "correct": false, "image": "" }
      ]
    }
  ]
},
  "takingaway": {
    "slug": "takingaway",
    "title": "Taking Away",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What is 9 − 2?",
        "answers": [
          { "text": "7", "correct": true },
          { "text": "6", "correct": false },
          { "text": "8", "correct": false },
          { "text": "9", "correct": false }
        ]
      },
      {
        "question": "You had 8 cookies and ate 3. How many left?",
        "answers": [
          { "text": "5", "correct": true },
          { "text": "6", "correct": false },
          { "text": "4", "correct": false },
          { "text": "3", "correct": false }
        ]
      },
      {
        "question": "What is 10 − 6?",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "5", "correct": false },
          { "text": "3", "correct": false },
          { "text": "6", "correct": false }
        ]
      }
    ]
  },
  "tellingtime": {
    "slug": "tellingtime",
    "title": "Telling Time",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What does the little hand on a clock show?",
        "answers": [
          { "text": "The hour", "correct": true },
          { "text": "The minutes", "correct": false },
          { "text": "The seconds", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What does the big hand on a clock show?",
        "answers": [
          { "text": "The minutes", "correct": true },
          { "text": "The hour", "correct": false },
          { "text": "The day", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When the little hand is on 3 and the big hand is on 12, what time is it?",
        "answers": [
          { "text": "3:00", "correct": true },
          { "text": "12:30", "correct": false },
          { "text": "3:30", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When the big hand points to the 3, how many minutes have passed?",
        "answers": [
          { "text": "15 minutes", "correct": true },
          { "text": "10 minutes", "correct": false },
          { "text": "20 minutes", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. When the big hand points to the 6, what does that mean?",
        "answers": [
          { "text": "30 minutes past the hour", "correct": true },
          { "text": "10 minutes past the hour", "correct": false },
          { "text": "5 minutes past the hour", "correct": false }
        ]
      }
    ]
  },
  "thearrival": {
  "slug": "thearrival",
  "title": "The Arrival",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. When did African men and women first arrive in Jamestown?",
      "questionImage": "",
      "answers": [
        { "text": "1619", "correct": true, "image": "" },
        { "text": "1607", "correct": false, "image": "" },
        { "text": "1700", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who arrived in Jamestown in 1619?",
      "questionImage": "",
      "answers": [
        { "text": "Africans", "correct": true, "image": "" },
        { "text": "Pilgrims", "correct": false, "image": "" },
        { "text": "Spanish settlers", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What was the legal status of Africans when they arrived?",
      "questionImage": "",
      "answers": [
        { "text": "Enslaved people or indentured servants", "correct": true, "image": "" },
        { "text": "Landowners", "correct": false, "image": "" },
        { "text": "Colonial governors", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What industry did Africans help expand in Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Tobacco", "correct": true, "image": "" },
        { "text": "Steel", "correct": false, "image": "" },
        { "text": "Silk", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The arrival of more women in Jamestown made what possible?",
      "questionImage": "",
      "answers": [
        { "text": "Families and a more stable community", "correct": true, "image": "" },
        { "text": "Empires", "correct": false, "image": "" },
        { "text": "Battles", "correct": false, "image": "" }
      ]
    }
  ]
},
  "theconstitution": {
  "slug": "theconstitution",
  "title": "The Constitution",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What is the Constitution?",
      "questionImage": "",
      "answers": [
        { "text": "Highest law", "correct": true, "image": "" },
        { "text": "Newspaper", "correct": false, "image": "" },
        { "text": "Map", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which three branches does it set up?",
      "questionImage": "",
      "answers": [
        { "text": "Pres/Cong/Courts", "correct": true, "image": "" },
        { "text": "King/Army/Church", "correct": false, "image": "" },
        { "text": "Mayor/Council/Jury", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. In what year was the plan made?",
      "questionImage": "",
      "answers": [
        { "text": "1787", "correct": true, "image": "" },
        { "text": "1776", "correct": false, "image": "" },
        { "text": "1791", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What are the first ten amendments called?",
      "questionImage": "",
      "answers": [
        { "text": "Bill of Rights", "correct": true, "image": "" },
        { "text": "Code of Laws", "correct": false, "image": "" },
        { "text": "Federal Rules", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How many amendments passed in total?",
      "questionImage": "",
      "answers": [
        { "text": "27", "correct": true, "image": "" },
        { "text": "10", "correct": false, "image": "" },
        { "text": "50", "correct": false, "image": "" }
      ]
    }
  ]
},
  "thedeclaration": {
  "slug": "thedeclaration",
  "title": "The Declaration of Independence",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What document listed reasons for independence?",
      "questionImage": "",
      "answers": [
        { "text": "Declaration", "correct": true, "image": "" },
        { "text": "Bill", "correct": false, "image": "" },
        { "text": "Treaty", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who was an author of the Declaration?",
      "questionImage": "",
      "answers": [
        { "text": "Jefferson", "correct": true, "image": "" },
        { "text": "Hamilton", "correct": false, "image": "" },
        { "text": "Madison", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. All people are created what?",
      "questionImage": "",
      "answers": [
        { "text": "Equal", "correct": true, "image": "" },
        { "text": "Royal", "correct": false, "image": "" },
        { "text": "Poor", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which right is named in the lyrics?",
      "questionImage": "",
      "answers": [
        { "text": "Life", "correct": true, "image": "" },
        { "text": "Silence", "correct": false, "image": "" },
        { "text": "Titles", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which goal is in the Declaration?",
      "questionImage": "",
      "answers": [
        { "text": "Happiness", "correct": true, "image": "" },
        { "text": "Conquest", "correct": false, "image": "" },
        { "text": "Empire", "correct": false, "image": "" }
      ]
    }
  ]
},
  "theearth": {
  "slug": "theearth",
  "title": "The Earth",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. One full spin (rotation) of Earth takes…",
      "questionImage": "",
      "answers": [
        { "text": "24 hours", "correct": true, "image": "" },
        { "text": "24 days", "correct": false, "image": "" },
        { "text": "1 year", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Seasons happen mainly because of Earth’s…",
      "questionImage": "",
      "answers": [
        { "text": "Tilt", "correct": true, "image": "" },
        { "text": "Clouds", "correct": false, "image": "" },
        { "text": "Wind", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Earth’s shape is…",
      "questionImage": "",
      "answers": [
        { "text": "Spherical", "correct": true, "image": "" },
        { "text": "Flat", "correct": false, "image": "" },
        { "text": "Square", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The main gas in our air is…",
      "questionImage": "",
      "answers": [
        { "text": "Nitrogen", "correct": true, "image": "" },
        { "text": "Oxygen", "correct": false, "image": "" },
        { "text": "Carbon dioxide", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Two forces that affect Earth are…",
      "questionImage": "",
      "answers": [
        { "text": "Gravity & magnetism", "correct": true, "image": "" },
        { "text": "Light & sound", "correct": false, "image": "" },
        { "text": "Heat & cold", "correct": false, "image": "" }
      ]
    }
  ]
},
  "thegovernment": {
    "slug": "thegovernment",
    "title": "The Government",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Why do governments make laws for everyone?",
        "questionImage": "",
        "answers": [
          { "text": "To protect people’s rights and property", "correct": true, "image": "" },
          { "text": "To sell products", "correct": false, "image": "" },
          { "text": "To make games", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What is one reason laws are made?",
        "questionImage": "",
        "answers": [
          { "text": "To keep people safe", "correct": true, "image": "" },
          { "text": "To create noise", "correct": false, "image": "" },
          { "text": "To block travel", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which part of government puts laws into action?",
        "questionImage": "",
        "answers": [
          { "text": "The group that carries out laws", "correct": true, "image": "" },
          { "text": "The group that sings laws", "correct": false, "image": "" },
          { "text": "The group that hides laws", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which part of government decides whether laws have been broken?",
        "questionImage": "",
        "answers": [
          { "text": "The courts that decide in trials", "correct": true, "image": "" },
          { "text": "The people who paint signs", "correct": false, "image": "" },
          { "text": "The workers who build roads", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Besides safety, what is another purpose of laws?",
        "questionImage": "",
        "answers": [
          { "text": "To maintain order", "correct": true, "image": "" },
          { "text": "To make noise", "correct": false, "image": "" },
          { "text": "To raise prices", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "themoon": {
  "slug": "themoon",
  "title": "The Moon",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Bright, bumpy areas on the Moon are called…",
      "questionImage": "",
      "answers": [
        { "text": "Highlands", "correct": true, "image": "" },
        { "text": "Oceans", "correct": false, "image": "" },
        { "text": "Clouds", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Dark spots called mare were filled with…",
      "questionImage": "",
      "answers": [
        { "text": "Lava", "correct": true, "image": "" },
        { "text": "Water", "correct": false, "image": "" },
        { "text": "Ice", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The Moon has almost no…",
      "questionImage": "",
      "answers": [
        { "text": "Atmosphere", "correct": true, "image": "" },
        { "text": "Rocks", "correct": false, "image": "" },
        { "text": "Craters", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who first walked on the Moon?",
      "questionImage": "",
      "answers": [
        { "text": "Armstrong", "correct": true, "image": "" },
        { "text": "Glenn", "correct": false, "image": "" },
        { "text": "Gagarin", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which mission landed in 1969?",
      "questionImage": "",
      "answers": [
        { "text": "Apollo 11", "correct": true, "image": "" },
        { "text": "Apollo 1", "correct": false, "image": "" },
        { "text": "Apollo 13", "correct": false, "image": "" }
      ]
    }
  ]
},
  "thepast": {
  "slug": "thepast",
  "title": "The Past",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What do we use to learn about people from long ago?",
      "questionImage": "",
      "answers": [
        { "text": "Archaeology", "correct": true, "image": "" },
        { "text": "Astrology", "correct": false, "image": "" },
        { "text": "Biology", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What do we call someone who studies the past?",
      "questionImage": "",
      "answers": [
        { "text": "Archaeologist", "correct": true, "image": "" },
        { "text": "Astronaut", "correct": false, "image": "" },
        { "text": "Artist", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What archaeological site is located in southeastern Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Cactus Hill", "correct": true, "image": "" },
        { "text": "Jamestown", "correct": false, "image": "" },
        { "text": "Yorktown", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. About how old is the Cactus Hill site?",
      "questionImage": "",
      "answers": [
        { "text": "18,000 years", "correct": true, "image": "" },
        { "text": "200 years", "correct": false, "image": "" },
        { "text": "500 years", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did archaeologists find at Cactus Hill?",
      "questionImage": "",
      "answers": [
        { "text": "Evidence of early people", "correct": true, "image": "" },
        { "text": "Gold and treasure", "correct": false, "image": "" },
        { "text": "Old maps", "correct": false, "image": "" }
      ]
    }
  ]
},
  "thesun": {
  "slug": "thesun",
  "title": "The Sun",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. About how many Earths could fit inside the Sun?",
      "questionImage": "",
      "answers": [
        { "text": "About 1 million", "correct": true, "image": "" },
        { "text": "About 1,000", "correct": false, "image": "" },
        { "text": "About 100", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The Sun is mostly which two elements?",
      "questionImage": "",
      "answers": [
        { "text": "Hydrogen & helium", "correct": true, "image": "" },
        { "text": "Iron & lead", "correct": false, "image": "" },
        { "text": "Sodium & chlorine", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The Sun’s energy comes from hydrogen changing to…",
      "questionImage": "",
      "answers": [
        { "text": "Helium", "correct": true, "image": "" },
        { "text": "Oxygen", "correct": false, "image": "" },
        { "text": "Carbon", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Sunspots are seen on the…",
      "questionImage": "",
      "answers": [
        { "text": "Photosphere", "correct": true, "image": "" },
        { "text": "Corona", "correct": false, "image": "" },
        { "text": "Mantle", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The Sun’s outermost layer is the…",
      "questionImage": "",
      "answers": [
        { "text": "Corona", "correct": true, "image": "" },
        { "text": "Core", "correct": false, "image": "" },
        { "text": "Chromosphere", "correct": false, "image": "" }
      ]
    }
  ]
},
  "thesunbringslight": {
    "slug": "thesunbringslight",
    "title": "The Sun Brings Light",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#fff2cc" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match what the sun gives with its effect.",
        "options": [
          { "id": "light", "text": "Light", "targetText": "Helps plants grow" },
          { "id": "heat", "text": "Heat", "targetText": "Keeps Earth warm" },
          { "id": "energy", "text": "Energy", "targetText": "Powers life on Earth" }
        ]
      },
      {
        "question": "Match the word with what it does.",
        "options": [
          { "id": "reflect", "text": "Reflect", "targetText": "Bounces back into space" },
          { "id": "absorb", "text": "Absorb", "targetText": "Taken in by Earth" }
        ]
      },
      {
        "question": "Match the sun effect with what we see.",
        "options": [
          { "id": "plants", "text": "Plants grow tall", "targetText": "Sun gives light" },
          { "id": "oceans", "text": "Oceans glow", "targetText": "Sun gives heat" }
        ]
      },
      {
        "question": "Match the thing with how it feels from the sun.",
        "options": [
          { "id": "land", "text": "Land", "targetText": "Gets warm" },
          { "id": "water", "text": "Water", "targetText": "Heats and cools slowly" },
          { "id": "air", "text": "Air", "targetText": "Feels hot or cold" }
        ]
      },
      {
        "question": "Match the sun fact with the right word.",
        "options": [
          { "id": "star", "text": "Star", "targetText": "The sun is one" },
          { "id": "life", "text": "Life", "targetText": "Needs the sun" },
          { "id": "patterns", "text": "Patterns", "targetText": "Warmth helps life begin" }
        ]
      }
    ]
  },
  "theybuilt": {
    "slug": "theybuilt",
    "title": "They Built",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the directions, then drag each name to what it built. Match each civilization to its structure.",
        "options": [
          { "id": "greece1", "text": "Ancient Greece", "image": "", "targetText": "Parthenon", "targetImage": "" },
          { "id": "rome1", "text": "Ancient Rome", "image": "", "targetText": "Coliseum", "targetImage": "" },
          { "id": "china1", "text": "Ancient China", "image": "", "targetText": "Great Wall", "targetImage": "" }
        ]
      },
      {
        "question": "Read the directions, then drag each name to what it used for water. Match each civilization to how it got or used water.",
        "options": [
          { "id": "rome2", "text": "Ancient Rome", "image": "", "targetText": "Aqueducts", "targetImage": "" },
          { "id": "egypt1", "text": "Ancient Egypt", "image": "", "targetText": "Nile River", "targetImage": "" },
          { "id": "china2", "text": "Ancient China", "image": "", "targetText": "Huang He River", "targetImage": "" }
        ]
      },
      {
        "question": "Read the directions, then drag each name to what the people built for learning or gathering.",
        "options": [
          { "id": "greece2", "text": "Ancient Greece", "image": "", "targetText": "Theaters", "targetImage": "" },
          { "id": "rome3", "text": "Ancient Rome", "image": "", "targetText": "Forums", "targetImage": "" },
          { "id": "mali1", "text": "Mali Empire", "image": "", "targetText": "Timbuktu schools", "targetImage": "" }
        ]
      },
      {
        "question": "Read the directions, then drag each name to what they traded or used for trade.",
        "options": [
          { "id": "mali2", "text": "Mali Empire", "image": "", "targetText": "Gold and salt", "targetImage": "" },
          { "id": "rome4", "text": "Ancient Rome", "image": "", "targetText": "Coins", "targetImage": "" },
          { "id": "greece3", "text": "Ancient Greece", "image": "", "targetText": "Olive oil", "targetImage": "" }
        ]
      },
      {
        "question": "Read the directions, then drag each name to what it is known for building.",
        "options": [
          { "id": "china3", "text": "Ancient China", "image": "", "targetText": "Compass", "targetImage": "" },
          { "id": "egypt2", "text": "Ancient Egypt", "image": "", "targetText": "Pyramids", "targetImage": "" },
          { "id": "rome5", "text": "Ancient Rome", "image": "", "targetText": "Roads", "targetImage": "" }
        ]
      }
    ]
  },
  "thingsplantsneed": {
    "slug": "thingsplantsneed",
    "title": "Things Plants Need",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What do plants need to live?",
        "answers": [
          { "text": "Water, air, light, shelter, space", "correct": true },
          { "text": "Toys and clothes", "correct": false },
          { "text": "Computers and books", "correct": false },
          { "text": "Cars and bikes", "correct": false }
        ]
      },
      {
        "question": "Why do plants need sunlight?",
        "answers": [
          { "text": "It helps them grow", "correct": true },
          { "text": "It helps them run fast", "correct": false },
          { "text": "It makes them shiny", "correct": false },
          { "text": "It helps them sleep", "correct": false }
        ]
      },
      {
        "question": "What helps plants drink water?",
        "answers": [
          { "text": "Roots", "correct": true },
          { "text": "Leaves", "correct": false },
          { "text": "Flowers", "correct": false },
          { "text": "Fruit", "correct": false }
        ]
      },
      {
        "question": "What do plants breathe in?",
        "answers": [
          { "text": "Air", "correct": true },
          { "text": "Milk", "correct": false },
          { "text": "Juice", "correct": false },
          { "text": "Sand", "correct": false }
        ]
      },
      {
        "question": "What do plants need space for?",
        "answers": [
          { "text": "To grow tall and strong", "correct": true },
          { "text": "To play soccer", "correct": false },
          { "text": "To ride bikes", "correct": false },
          { "text": "To take naps", "correct": false }
        ]
      }
    ]
  },
  "tides": {
  "slug": "tides",
  "title": "Tides",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What mainly causes ocean tides on Earth?",
      "questionImage": "",
      "answers": [
        { "text": "Gravity", "correct": true, "image": "" },
        { "text": "Wind", "correct": false, "image": "" },
        { "text": "Light", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. One high tide is on the side facing the…",
      "questionImage": "",
      "answers": [
        { "text": "Moon", "correct": true, "image": "" },
        { "text": "Poles", "correct": false, "image": "" },
        { "text": "Mountains", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. The other high tide is on the…",
      "questionImage": "",
      "answers": [
        { "text": "Opposite side", "correct": true, "image": "" },
        { "text": "Equator only", "correct": false, "image": "" },
        { "text": "No-ocean side", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Why do oceans change level more than land?",
      "questionImage": "",
      "answers": [
        { "text": "Water flows", "correct": true, "image": "" },
        { "text": "Land is heavier", "correct": false, "image": "" },
        { "text": "Sun is hotter", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Low tides happen where the pulls are…",
      "questionImage": "",
      "answers": [
        { "text": "Weaker/balanced", "correct": true, "image": "" },
        { "text": "Exploding", "correct": false, "image": "" },
        { "text": "Frozen", "correct": false, "image": "" }
      ]
    }
  ]
},
  "trade": {
    "slug": "trade",
    "title": "Trade",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What does specialization mean for people and regions?",
        "questionImage": "",
        "answers": [
          { "text": "They focus on making certain goods and services", "correct": true, "image": "" },
          { "text": "They make all goods and services", "correct": false, "image": "" },
          { "text": "They only do farming", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Why do people and regions trade with others?",
        "questionImage": "",
        "answers": [
          { "text": "To get what they don’t have", "correct": true, "image": "" },
          { "text": "Because they have extra time", "correct": false, "image": "" },
          { "text": "To make new friends", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do specialized regions provide to others in exchange?",
        "questionImage": "",
        "answers": [
          { "text": "Goods and services", "correct": true, "image": "" },
          { "text": "Nothing", "correct": false, "image": "" },
          { "text": "Only money", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What phrase in the song explains specialization?",
        "questionImage": "",
        "answers": [
          { "text": "Make and provide", "correct": true, "image": "" },
          { "text": "Hide and keep", "correct": false, "image": "" },
          { "text": "Spend and borrow", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What do people get through trade that they could not produce themselves?",
        "questionImage": "",
        "answers": [
          { "text": "Needed goods", "correct": true, "image": "" },
          { "text": "Extra chores", "correct": false, "image": "" },
          { "text": "More taxes", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "transverse": {
  "slug": "transverse",
  "title": "Transverse",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. In a transverse wave, what does the wavelength show?",
      "questionImage": "",
      "answers": [
        { "text": "Distance crest-to-crest", "correct": true, "image": "" },
        { "text": "Height of a crest", "correct": false, "image": "" },
        { "text": "Loudness of sound", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What do we call the highest point of the wave?",
      "questionImage": "",
      "answers": [
        { "text": "Crest", "correct": true, "image": "" },
        { "text": "Trough", "correct": false, "image": "" },
        { "text": "Middle", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What do we call the lowest point of the wave?",
      "questionImage": "",
      "answers": [
        { "text": "Trough", "correct": true, "image": "" },
        { "text": "Crest", "correct": false, "image": "" },
        { "text": "Peak", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Wavelength is measured in which unit?",
      "questionImage": "",
      "answers": [
        { "text": "Meters", "correct": true, "image": "" },
        { "text": "Seconds", "correct": false, "image": "" },
        { "text": "Degrees", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which three parts are named in the song?",
      "questionImage": "",
      "answers": [
        { "text": "Wavelength, crest, trough", "correct": true, "image": "" },
        { "text": "Speed, mass, time", "correct": false, "image": "" },
        { "text": "Push, pull, twist", "correct": false, "image": "" }
      ]
    }
  ]
},
  "travelingsound": {
  "slug": "travelingsound",
  "title": "Traveling Sound",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Sound travels fastest in?",
      "questionImage": "",
      "answers": [
        { "text": "Solids", "correct": true, "image": "" },
        { "text": "Liquids", "correct": false, "image": "" },
        { "text": "Gases", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Sound travels slowest in?",
      "questionImage": "",
      "answers": [
        { "text": "Gases", "correct": true, "image": "" },
        { "text": "Solids", "correct": false, "image": "" },
        { "text": "Liquids", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Molecules in solids are?",
      "questionImage": "",
      "answers": [
        { "text": "Close together", "correct": true, "image": "" },
        { "text": "Far apart", "correct": false, "image": "" },
        { "text": "Always moving fast", "correct": false, "image": "" }
      ]
    }
  ]
},
  "triangles": {
    "slug": "triangles",
    "title": "Triangles",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. How many sides does a triangle have?",
        "answers": [
          { "text": "3", "correct": true },
          { "text": "4", "correct": false },
          { "text": "2", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What type of triangle has all three sides equal?",
        "answers": [
          { "text": "Equilateral triangle", "correct": true },
          { "text": "Isosceles triangle", "correct": false },
          { "text": "Scalene triangle", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What type of triangle has one angle equal to 90 degrees?",
        "answers": [
          { "text": "Right triangle", "correct": true },
          { "text": "Obtuse triangle", "correct": false },
          { "text": "Acute triangle", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What type of triangle has two sides equal?",
        "answers": [
          { "text": "Isosceles triangle", "correct": true },
          { "text": "Scalene triangle", "correct": false },
          { "text": "Equilateral triangle", "correct": false }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What type of triangle has all sides of different lengths?",
        "answers": [
          { "text": "Scalene triangle", "correct": true },
          { "text": "Equilateral triangle", "correct": false },
          { "text": "Isosceles triangle", "correct": false }
        ]
      }
    ]
  },
  "tribestoday": {
  "slug": "tribestoday",
  "title": "Tribes Today",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. How many tribes does Virginia officially recognize today?",
      "questionImage": "",
      "answers": [
        { "text": "8", "correct": true, "image": "" },
        { "text": "6", "correct": false, "image": "" },
        { "text": "10", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which tribe lives in the Piedmont Region of Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Monacan", "correct": true, "image": "" },
        { "text": "Pamunkey", "correct": false, "image": "" },
        { "text": "Rappahannock", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where are most of the other seven tribes located?",
      "questionImage": "",
      "answers": [
        { "text": "Tidewater Region", "correct": true, "image": "" },
        { "text": "Valley and Ridge Region", "correct": false, "image": "" },
        { "text": "Appalachian Plateau", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which of these is a recognized Virginia tribe?",
      "questionImage": "",
      "answers": [
        { "text": "Pamunkey", "correct": true, "image": "" },
        { "text": "Sioux", "correct": false, "image": "" },
        { "text": "Navajo", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which pair shows related Virginia tribes?",
      "questionImage": "",
      "answers": [
        { "text": "Upper Mattaponi and Mattaponi", "correct": true, "image": "" },
        { "text": "Mohawk and Pamunkey", "correct": false, "image": "" },
        { "text": "Cherokee and Monacan", "correct": false, "image": "" }
      ]
    }
  ]
},
  "understandtheequalsign": {
    "slug": "understandtheequalsign",
    "title": "Understand the equal sign",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Which equation is true?",
        "answers": [
          { "text": "3 + 2 = 5", "correct": true },
          { "text": "4 = 2 + 3 + 1", "correct": false },
          { "text": "6 = 7", "correct": false },
          { "text": "5 + 1 = 5", "correct": false }
        ]
      },
      {
        "question": "Which side has the same value: 4 + 1 __ 3 + 2",
        "answers": [
          { "text": "=", "correct": true },
          { "text": ">", "correct": false },
          { "text": "<", "correct": false },
          { "text": "≠", "correct": false }
        ]
      },
      {
        "question": "Choose the true statement.",
        "answers": [
          { "text": "2 + 4 = 6", "correct": true },
          { "text": "2 + 4 = 5", "correct": false },
          { "text": "6 = 7", "correct": false },
          { "text": "0 = 1", "correct": false }
        ]
      }
    ]
  },
  "vastatebird": {
    "slug": "vastatebird",
    "title": "VA State Bird",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What is the official state bird of Virginia?",
        "questionImage": "",
        "answers": [
          { "text": "Cardinal", "correct": true, "image": "" },
          { "text": "Bluebird", "correct": false, "image": "" },
          { "text": "Robin", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What color is the male Virginia cardinal?",
        "questionImage": "",
        "answers": [
          { "text": "Red", "correct": true, "image": "" },
          { "text": "Blue", "correct": false, "image": "" },
          { "text": "Green", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What color is the female Virginia cardinal?",
        "questionImage": "",
        "answers": [
          { "text": "Brown", "correct": true, "image": "" },
          { "text": "Red", "correct": false, "image": "" },
          { "text": "Yellow", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What type of bird is the cardinal known to be?",
        "questionImage": "",
        "answers": [
          { "text": "Songbird", "correct": true, "image": "" },
          { "text": "Seabird", "correct": false, "image": "" },
          { "text": "Penguin", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. In which year did the cardinal become Virginia’s official state bird?",
        "questionImage": "",
        "answers": [
          { "text": "1950", "correct": true, "image": "" },
          { "text": "1776", "correct": false, "image": "" },
          { "text": "2001", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "vastateflag": {
    "slug": "vastateflag",
    "title": "VA State Flag",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each part of the Virginia state flag to its description.",
        "options": [
          { "id": "background", "text": "Background", "image": "", "targetText": "Dark blue", "targetImage": "" },
          { "id": "center_seal", "text": "Center", "image": "", "targetText": "State seal", "targetImage": "" },
          { "id": "border", "text": "Border", "image": "", "targetText": "Red leaves and flowers", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match what appears on the state seal to what it represents.",
        "options": [
          { "id": "virtus", "text": "Virtus", "image": "", "targetText": "Bravery", "targetImage": "" },
          { "id": "fallen_tyrant", "text": "Fallen Tyrant", "image": "", "targetText": "Defeated evil", "targetImage": "" },
          { "id": "crown", "text": "Broken Crown", "image": "", "targetText": "Freedom from rule", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each flag detail to what it tells about Virginia.",
        "options": [
          { "id": "seal_text", "text": "Sic Semper Tyrannis", "image": "", "targetText": "State motto", "targetImage": "" },
          { "id": "virtus_sword", "text": "Virtus with sword", "image": "", "targetText": "Protects liberty", "targetImage": "" },
          { "id": "tyrant_down", "text": "Tyrant on ground", "image": "", "targetText": "Defeated power", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match the flag’s colors and symbols to what they mean.",
        "options": [
          { "id": "blue_color", "text": "Blue background", "image": "", "targetText": "Loyalty", "targetImage": "" },
          { "id": "white_seal", "text": "White seal", "image": "", "targetText": "Peace", "targetImage": "" },
          { "id": "red_border", "text": "Red border", "image": "", "targetText": "Courage", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each fact about the flag to the correct detail.",
        "options": [
          { "id": "adopt_year", "text": "Adopted", "image": "", "targetText": "1861", "targetImage": "" },
          { "id": "design_type", "text": "Design", "image": "", "targetText": "Circular seal on blue field", "targetImage": "" },
          { "id": "motto_location", "text": "Motto words", "image": "", "targetText": "On state seal", "targetImage": "" }
        ]
      }
    ]
  },
  "vastateflower": {
    "slug": "vastateflower",
    "title": "VA State Flower",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each fact about Virginia’s state flower to the correct word.",
        "options": [
          { "id": "dogwood", "text": "Dogwood", "image": "", "targetText": "State flower", "targetImage": "" },
          { "id": "virginia", "text": "Virginia", "image": "", "targetText": "State it represents", "targetImage": "" },
          { "id": "official", "text": "Official", "image": "", "targetText": "Named by law", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each part of the dogwood flower to how it looks.",
        "options": [
          { "id": "petals", "text": "Petals", "image": "", "targetText": "Four white petals", "targetImage": "" },
          { "id": "center", "text": "Center", "image": "", "targetText": "Green clusters", "targetImage": "" },
          { "id": "leaves", "text": "Leaves", "image": "", "targetText": "Bright green", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match the season or reason connected to the dogwood flower.",
        "options": [
          { "id": "spring", "text": "Spring", "image": "", "targetText": "When it blooms", "targetImage": "" },
          { "id": "beauty", "text": "Beauty", "image": "", "targetText": "Symbol of the state", "targetImage": "" },
          { "id": "strength", "text": "Strength", "image": "", "targetText": "Grows across Virginia", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each fact about the dogwood to its meaning or description.",
        "options": [
          { "id": "tree_type", "text": "Flowering tree", "image": "", "targetText": "Grows small and wide", "targetImage": "" },
          { "id": "bloom_color", "text": "White bloom", "image": "", "targetText": "Most common color", "targetImage": "" },
          { "id": "pink_bloom", "text": "Pink bloom", "image": "", "targetText": "Less common variety", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each historical fact to the correct date or reason.",
        "options": [
          { "id": "since_1918", "text": "Since 1918", "image": "", "targetText": "Named official flower", "targetImage": "" },
          { "id": "chosen", "text": "Chosen", "image": "", "targetText": "By General Assembly", "targetImage": "" },
          { "id": "honor", "text": "Honor", "image": "", "targetText": "State pride", "targetImage": "" }
        ]
      }
    ]
  },
  "vaunited": {
    "slug": "vaunited",
    "title": "VA United",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. What do we call the people who live in the United States of America?",
        "questionImage": "",
        "answers": [
          { "text": "Americans", "correct": true, "image": "" },
          { "text": "Robots", "correct": false, "image": "" },
          { "text": "Aliens", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which civic action lets people choose their leaders and share their voice?",
        "questionImage": "",
        "answers": [
          { "text": "Vote", "correct": true, "image": "" },
          { "text": "Litter", "correct": false, "image": "" },
          { "text": "Speed", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. What can people in a community do to choose who leads their town or city?",
        "questionImage": "",
        "answers": [
          { "text": "Elect leaders", "correct": true, "image": "" },
          { "text": "Skip laws", "correct": false, "image": "" },
          { "text": "Close parks", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. How can people help make their community a better place to live?",
        "questionImage": "",
        "answers": [
          { "text": "Volunteer", "correct": true, "image": "" },
          { "text": "Ignore problems", "correct": false, "image": "" },
          { "text": "Complain only", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Where do the people of Virginia come from, and what does that show about our state?",
        "questionImage": "",
        "answers": [
          { "text": "Many places", "correct": true, "image": "" },
          { "text": "One town", "correct": false, "image": "" },
          { "text": "One family", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "virginiabattles": {
  "slug": "virginiabattles",
  "title": "Virginia Battles",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What was the first Civil War battle in Virginia?",
      "questionImage": "",
      "answers": [
        { "text": "Bull Run", "correct": true, "image": "" },
        { "text": "Yorktown", "correct": false, "image": "" },
        { "text": "Antietam", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who led the Confederate soldiers at the Battle of Bull Run?",
      "questionImage": "",
      "answers": [
        { "text": "Stonewall Jackson", "correct": true, "image": "" },
        { "text": "Ulysses S. Grant", "correct": false, "image": "" },
        { "text": "William Sherman", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Who led the Confederate army to victory at Fredericksburg in 1862?",
      "questionImage": "",
      "answers": [
        { "text": "Robert E. Lee", "correct": true, "image": "" },
        { "text": "Abraham Lincoln", "correct": false, "image": "" },
        { "text": "Union Army", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which Virginia city fell to the Union army in 1864?",
      "questionImage": "",
      "answers": [
        { "text": "Richmond", "correct": true, "image": "" },
        { "text": "Atlanta", "correct": false, "image": "" },
        { "text": "Norfolk", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Where did General Robert E. Lee surrender to end the Civil War?",
      "questionImage": "",
      "answers": [
        { "text": "Appomattox", "correct": true, "image": "" },
        { "text": "Gettysburg", "correct": false, "image": "" },
        { "text": "Manassas", "correct": false, "image": "" }
      ]
    }
  ]
},
  "wantsandchoices": {
    "slug": "wantsandchoices",
    "title": "Wants and Choices",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each term to what it means.",
        "options": [
          { "id": "wants", "text": "Wants", "image": "", "targetText": "Things we’d like to have", "targetImage": "" },
          { "id": "needs", "text": "Needs", "image": "", "targetText": "Things we must have", "targetImage": "" },
          { "id": "choices", "text": "Choices", "image": "", "targetText": "Decisions we make", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each example to what it shows.",
        "options": [
          { "id": "food", "text": "Food", "image": "", "targetText": "Need", "targetImage": "" },
          { "id": "toy", "text": "Toy", "image": "", "targetText": "Want", "targetImage": "" },
          { "id": "water", "text": "Water", "image": "", "targetText": "Need", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each decision to what it shows about choices.",
        "options": [
          { "id": "game_snack", "text": "Game or snack", "image": "", "targetText": "Making a choice", "targetImage": "" },
          { "id": "toy_book", "text": "Toy or book", "image": "", "targetText": "Making a choice", "targetImage": "" },
          { "id": "tv_homework", "text": "TV or homework", "image": "", "targetText": "Choosing one", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each word to how it connects to scarcity.",
        "options": [
          { "id": "scarcity", "text": "Scarcity", "image": "", "targetText": "Not enough of something", "targetImage": "" },
          { "id": "limited", "text": "Limited", "image": "", "targetText": "Few resources", "targetImage": "" },
          { "id": "choices2", "text": "Choices", "image": "", "targetText": "We must decide", "targetImage": "" }
        ]
      },
      {
        "question": "Drag or tap any item from the top row (A) and drop it or tap it on the matching item in the bottom row (B). Match each reason people can’t have everything to the right idea.",
        "options": [
          { "id": "money", "text": "Money", "image": "", "targetText": "Limited resource", "targetImage": "" },
          { "id": "time", "text": "Time", "image": "", "targetText": "We can’t do it all", "targetImage": "" },
          { "id": "scarce_items", "text": "Scarce items", "image": "", "targetText": "Not enough for everyone", "targetImage": "" }
        ]
      }
    ]
  },
  "watercycle": {
    "slug": "watercycle",
    "title": "Water Cycle",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Evaporation needs…",
        "questionImage": "",
        "answers": [
          { "text": "Sun heat", "correct": true, "image": "" },
          { "text": "Moonlight", "correct": false, "image": "" },
          { "text": "Snow", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Condensation forms…",
        "questionImage": "",
        "answers": [
          { "text": "Clouds", "correct": true, "image": "" },
          { "text": "Rocks", "correct": false, "image": "" },
          { "text": "Sand", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Precipitation is…",
        "questionImage": "",
        "answers": [
          { "text": "Rain or snow", "correct": true, "image": "" },
          { "text": "Evaporation", "correct": false, "image": "" },
          { "text": "Melting", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. About how much of Earth is covered by water?",
        "questionImage": "",
        "answers": [
          { "text": "75%", "correct": true, "image": "" },
          { "text": "5%", "correct": false, "image": "" },
          { "text": "25%", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. The equator is…",
        "questionImage": "",
        "answers": [
          { "text": "An imaginary line", "correct": true, "image": "" },
          { "text": "A real river", "correct": false, "image": "" },
          { "text": "A mountain", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "watershed": {
  "slug": "watershed",
  "title": "Watershed",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. A watershed is land that drains to a…",
      "questionImage": "",
      "answers": [
        { "text": "Water body", "correct": true, "image": "" },
        { "text": "Mountain", "correct": false, "image": "" },
        { "text": "Cave", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Much of Virginia’s water drains to the…",
      "questionImage": "",
      "answers": [
        { "text": "Chesapeake Bay", "correct": true, "image": "" },
        { "text": "Great Lakes", "correct": false, "image": "" },
        { "text": "Pacific Ocean", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Virginia water also drains to the…",
      "questionImage": "",
      "answers": [
        { "text": "Atlantic Ocean", "correct": true, "image": "" },
        { "text": "Arctic Ocean", "correct": false, "image": "" },
        { "text": "Indian Ocean", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Some Virginia water reaches the Mississippi River and then the…",
      "questionImage": "",
      "answers": [
        { "text": "Gulf of Mexico", "correct": true, "image": "" },
        { "text": "Chesapeake Bay", "correct": false, "image": "" },
        { "text": "Canal", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Another Virginia drainage area is the…",
      "questionImage": "",
      "answers": [
        { "text": "Albemarle Sound", "correct": true, "image": "" },
        { "text": "Hudson Bay", "correct": false, "image": "" },
        { "text": "Mediterranean Sea", "correct": false, "image": "" }
      ]
    }
  ]
},
  "waveproperties": {
  "slug": "waveproperties",
  "title": "Wave Properties",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Frequency is?",
      "questionImage": "",
      "answers": [
        { "text": "Waves per second", "correct": true, "image": "" },
        { "text": "Wave height", "correct": false, "image": "" },
        { "text": "Wave bend", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Wavelength is?",
      "questionImage": "",
      "answers": [
        { "text": "Distance crest to crest", "correct": true, "image": "" },
        { "text": "Time for one wave", "correct": false, "image": "" },
        { "text": "Height of wave", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Amplitude is?",
      "questionImage": "",
      "answers": [
        { "text": "Wave height", "correct": true, "image": "" },
        { "text": "Waves per second", "correct": false, "image": "" },
        { "text": "Bending light", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Period is?",
      "questionImage": "",
      "answers": [
        { "text": "Time for one wave", "correct": true, "image": "" },
        { "text": "Energy size", "correct": false, "image": "" },
        { "text": "Wave speed", "correct": false, "image": "" }
      ]
    }
  ]
},
  "weathering": {
  "slug": "weathering",
  "title": "Weathering",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. Which process breaks rocks into smaller pieces?",
      "questionImage": "",
      "answers": [
        { "text": "Weathering", "correct": true, "image": "" },
        { "text": "Cooking", "correct": false, "image": "" },
        { "text": "Freezing", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. Which process moves rock and soil from one place to another?",
      "questionImage": "",
      "answers": [
        { "text": "Erosion", "correct": true, "image": "" },
        { "text": "Painting", "correct": false, "image": "" },
        { "text": "Reading", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What is it called when moved rock and soil are dropped in a new place?",
      "questionImage": "",
      "answers": [
        { "text": "Deposition", "correct": true, "image": "" },
        { "text": "Evaporation", "correct": false, "image": "" },
        { "text": "Condensation", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What natural forces often cause weathering and erosion on Earth’s surface?",
      "questionImage": "",
      "answers": [
        { "text": "Wind and rain", "correct": true, "image": "" },
        { "text": "Music and art", "correct": false, "image": "" },
        { "text": "Games", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. How do changes to Earth’s surface usually happen?",
      "questionImage": "",
      "answers": [
        { "text": "Over time", "correct": true, "image": "" },
        { "text": "Instantly", "correct": false, "image": "" },
        { "text": "Never", "correct": false, "image": "" }
      ]
    }
  ]
},
  "weatherpatterns": {
    "slug": "weatherpatterns",
    "title": "Weather Patterns",
    "gameType": "dragDrop",
    "placeholderStyle": { "backgroundColor": "#e8f4ff" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Match the weather word to what it means.",
        "options": [
          { "id": "temperature", "text": "Temperature", "targetText": "How hot or cold it is" },
          { "id": "wind", "text": "Wind", "targetText": "Air that moves" },
          { "id": "clouds", "text": "Clouds", "targetText": "Water drops in the sky" }
        ]
      },
      {
        "question": "Match the kind of weather to a picture idea.",
        "options": [
          { "id": "sunny", "text": "Sunny", "targetText": "Bright sun, few clouds" },
          { "id": "rainy", "text": "Rainy", "targetText": "Raindrops falling" },
          { "id": "snowy", "text": "Snowy", "targetText": "White flakes falling" },
          { "id": "windy", "text": "Windy", "targetText": "Leaves blowing" }
        ]
      },
      {
        "question": "Match the season to the kind of weather we often see.",
        "options": [
          { "id": "spring", "text": "Spring", "targetText": "Rain and flowers" },
          { "id": "summer", "text": "Summer", "targetText": "Hot and sunny" },
          { "id": "fall", "text": "Fall (Autumn)", "targetText": "Cooler, leaves change" },
          { "id": "winter", "text": "Winter", "targetText": "Cold, sometimes snow" }
        ]
      },
      {
        "question": "Match the sky sound or sight to its name.",
        "options": [
          { "id": "thunder", "text": "Thunder", "targetText": "Loud rumble" },
          { "id": "lightning", "text": "Lightning", "targetText": "Bright flash" },
          { "id": "breeze", "text": "Breeze", "targetText": "Soft wind" }
        ]
      },
      {
        "question": "Match the clothing to the weather.",
        "options": [
          { "id": "raincoat", "text": "Raincoat", "targetText": "Rainy" },
          { "id": "shorts", "text": "Shorts", "targetText": "Hot day" },
          { "id": "coat", "text": "Winter coat", "targetText": "Cold day" },
          { "id": "hat", "text": "Sun hat", "targetText": "Sunny day" }
        ]
      }
    ]
  },
  "westafricapower": {
  "slug": "westafricapower",
  "title": "West Africa Power",
  "gameType": "dragDrop",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match each empire to what gave them power.",
      "options": [
        { "id": "ghana", "text": "Ghana", "image": "", "targetText": "Trade", "targetImage": "" },
        { "id": "mali", "text": "Mali", "image": "", "targetText": "Trade", "targetImage": "" },
        { "id": "songhai", "text": "Songhai", "image": "", "targetText": "Trade", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match the Portuguese trade items.",
      "options": [
        { "id": "metals", "text": "Metals", "image": "", "targetText": "Trade item", "targetImage": "" },
        { "id": "clothes", "text": "Clothes", "image": "", "targetText": "Trade item", "targetImage": "" },
        { "id": "gold", "text": "Gold", "image": "", "targetText": "For trade", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match empires to their river location.",
      "options": [
        { "id": "ghana2", "text": "Ghana", "image": "", "targetText": "Niger River", "targetImage": "" },
        { "id": "mali2", "text": "Mali", "image": "", "targetText": "Niger River", "targetImage": "" },
        { "id": "songhai2", "text": "Songhai", "image": "", "targetText": "Niger River", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match the time period to the empires.",
      "options": [
        { "id": "ghana3", "text": "Ghana", "image": "", "targetText": "300–1600 AD", "targetImage": "" },
        { "id": "mali3", "text": "Mali", "image": "", "targetText": "300–1600 AD", "targetImage": "" },
        { "id": "songhai3", "text": "Songhai", "image": "", "targetText": "300–1600 AD", "targetImage": "" }
      ]
    },
    {
      "question": "Grab or click the item from the top row A and drop it on the item from the bottom row B that matches. Match each group with its trade role.",
      "options": [
        { "id": "portuguese", "text": "Portuguese", "image": "", "targetText": "Traded goods", "targetImage": "" },
        { "id": "ghana4", "text": "Ghana", "image": "", "targetText": "Controlled trade", "targetImage": "" },
        { "id": "mali4", "text": "Mali", "image": "", "targetText": "Controlled trade", "targetImage": "" }
      ]
    }
  ]
},
  "whatdoplantsneed": {
    "slug": "whatdoplantsneed",
    "title": "What Do Plants Need",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Animals need…",
        "questionImage": "",
        "answers": [
          { "text": "Food and water", "correct": true, "image": "" },
          { "text": "Metal", "correct": false, "image": "" },
          { "text": "Plastic", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Animals also need…",
        "questionImage": "",
        "answers": [
          { "text": "Air and shelter", "correct": true, "image": "" },
          { "text": "Music", "correct": false, "image": "" },
          { "text": "Paint", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Aquatic means…",
        "questionImage": "",
        "answers": [
          { "text": "Lives in water", "correct": true, "image": "" },
          { "text": "Lives on land", "correct": false, "image": "" },
          { "text": "Lives in the sky", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Plants need…",
        "questionImage": "",
        "answers": [
          { "text": "Air and light", "correct": true, "image": "" },
          { "text": "Gold and salt", "correct": false, "image": "" },
          { "text": "Wheels", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Plants also need…",
        "questionImage": "",
        "answers": [
          { "text": "Water and nutrients", "correct": true, "image": "" },
          { "text": "Batteries", "correct": false, "image": "" },
          { "text": "Gasoline", "correct": false, "image": "" }
        ]
      }
    ]
  },
  "whentheycame": {
  "slug": "whentheycame",
  "title": "When They Came",
  "gameType": "multipleChoice",
  "placeholderStyle": { "backgroundColor": "transparent" },
  "placeholderImage": "",
  "questions": [
    {
      "question": "Read the question, then choose the correct answer. What did the Spanish bring to America?",
      "questionImage": "",
      "answers": [
        { "text": "Christianity", "correct": true, "image": "" },
        { "text": "Silk", "correct": false, "image": "" },
        { "text": "Tea", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the English claim in America?",
      "questionImage": "",
      "answers": [
        { "text": "Land", "correct": true, "image": "" },
        { "text": "Diamonds", "correct": false, "image": "" },
        { "text": "Spices", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the English do with Native Americans?",
      "questionImage": "",
      "answers": [
        { "text": "Traded", "correct": true, "image": "" },
        { "text": "Ignored", "correct": false, "image": "" },
        { "text": "Enslaved", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the French spread?",
      "questionImage": "",
      "answers": [
        { "text": "Religion", "correct": true, "image": "" },
        { "text": "Gold", "correct": false, "image": "" },
        { "text": "Cotton", "correct": false, "image": "" }
      ]
    },
    {
      "question": "Read the question, then choose the correct answer. What did the French set up?",
      "questionImage": "",
      "answers": [
        { "text": "Trading posts", "correct": true, "image": "" },
        { "text": "Castles", "correct": false, "image": "" },
        { "text": "Ships", "correct": false, "image": "" }
      ]
    }
  ]
},
  "wholeagain": {
    "slug": "wholeagain",
    "title": "Whole Again",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Two halves make a ____.",
        "answers": [
          { "text": "whole", "correct": true },
          { "text": "third", "correct": false },
          { "text": "fourth", "correct": false },
          { "text": "piece", "correct": false }
        ]
      },
      {
        "question": "Four fourths make a ____.",
        "answers": [
          { "text": "whole", "correct": true },
          { "text": "half", "correct": false },
          { "text": "third", "correct": false },
          { "text": "quarter", "correct": false }
        ]
      },
      {
        "question": "1/4 + 3/4 equals:",
        "answers": [
          { "text": "1 whole", "correct": true },
          { "text": "1/2", "correct": false },
          { "text": "2/4", "correct": false },
          { "text": "0", "correct": false }
        ]
      }
    ]
  },
  "workeasy": {
    "slug": "workeasy",
    "title": "Work Easy (Simple Machines)",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Read the question, then choose the correct answer. Why do we use simple machines?",
        "questionImage": "",
        "answers": [
          { "text": "To make work easier", "correct": true, "image": "" },
          { "text": "To make work harder", "correct": false, "image": "" },
          { "text": "To confuse people", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which simple machine is like a seesaw?",
        "questionImage": "",
        "answers": [
          { "text": "Lever", "correct": true, "image": "" },
          { "text": "Screw", "correct": false, "image": "" },
          { "text": "Wedge", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. Which simple machine is like a ramp?",
        "questionImage": "",
        "answers": [
          { "text": "Inclined plane", "correct": true, "image": "" },
          { "text": "Pulley", "correct": false, "image": "" },
          { "text": "Wheel and axle", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. A pulley helps you…",
        "questionImage": "",
        "answers": [
          { "text": "Lift with a rope", "correct": true, "image": "" },
          { "text": "Cut wood", "correct": false, "image": "" },
          { "text": "Hold pieces together", "correct": false, "image": "" }
        ]
      },
      {
        "question": "Read the question, then choose the correct answer. A screw is used to…",
        "questionImage": "",
        "answers": [
          { "text": "Hold things together", "correct": true, "image": "" },
          { "text": "Roll across the floor", "correct": false, "image": "" },
          { "text": "Lift like a lever", "correct": false, "image": "" }
        ]
      }
    ]
  }
};

export default quizLibrary;
